import React, { useState, useEffect } from "react";
import "./banner.scss";
import "react-toastify/dist/ReactToastify.css";
import Navbar from "../header/Navbar";
import Modal from "react-bootstrap/Modal";
import EthPrice from "../../../hooks/chinaFunction/ethPrice";
import UniPrice from "../../../hooks/chinaFunction/uniPrice";
import LinkPrice from "../../../hooks/chinaFunction/linkPrice";
import { useWeb3React } from "@web3-react/core";
import useWeb3 from "../../../hooks/useWeb3";
import moment from "moment";
import AllowanceTpl from "../../../hooks/dataFetchers/AllowanceTpl";
import AllowanceTpl1 from "../../../hooks/dataFetchers/AllowanceTpl1";
import ApproveTpl from "../../../hooks/dataFetchers/ApproveTpl";
import ApproveTplUsdc from "../../../hooks/dataFetchers/ApproveTplUsdc";
import ApproveTplUsdc1 from "../../../hooks/dataFetchers/approveTplUsdc1";
import ApproveTplWbtc from "../../../hooks/dataFetchers/ApproveTplWbtc";
import ApproveTplWbtc1 from "../../../hooks/dataFetchers/approveTplWbtc1";
import ApproveTomi from "../../../hooks/dataFetchers/ApproveTomi";
import ApproveGems from "../../../hooks/dataFetchers/ApproveGems";
import ApproveLink from "../../../hooks/dataFetchers/ApproveLink";
import ApprovePepe from "../../../hooks/dataFetchers/ApprovePepe";
import ApproveUnisawape from "../../../hooks/dataFetchers/ApproveUniswape";
import ApproveTomi1 from "../../../hooks/dataFetchers/ApproveTomi1";
import ApproveTpl1 from "../../../hooks/dataFetchers/ApproveTpl1";
import BalacefAccount from "../../../hooks/dataFetchers/BalaceOfAccount";
import PurchaseEth from "../../../hooks/chinaFunction/purchaseEth";
import PurchaseEth1 from "../../../hooks/chinaFunction/purchaseEth1";
import PurchaseUsdt from "../../../hooks/chinaFunction/purchaseUsdt";
import PurchaseUsdc from "../../../hooks/chinaFunction/purchaseUsdc";
import PurchaseUsdc1 from "../../../hooks/chinaFunction/purchaseUsdc1";
import PurchaseWbtc from "../../../hooks/chinaFunction/purchaseWbtc";
import PurchaseWbtc1 from "../../../hooks/chinaFunction/purchaseWbtc1";
import PurchaseUsdt1 from "../../../hooks/chinaFunction/purchaseUsdt1";
import PurchasePepe from "../../../hooks/chinaFunction/purchasePepe";
import PurchaseLink from "../../../hooks/chinaFunction/purchaseLink";
import PurchaseUniswape from "../../../hooks/chinaFunction/purchaseUniswape";
import Loader from "../../../hooks/loader";
import axios from "axios";
import { API_URL } from "../../../utils/ApiUrl";
import { toast } from "react-toastify";
import CuurentRound from "../../../hooks/chinaFunction/round";
import CuurentRoundNft from "../../../hooks/chinaFunction/roundNft";
import SaleStatus from "../../../hooks/chinaFunction/saleStatus";
import SaleStatusNft from "../../../hooks/chinaFunction/saleStatusNft";
import PsMarketCap from "../../../hooks/chinaFunction/psMarketCap";
import InMarketCap from "../../../hooks/chinaFunction/inMarketCap";
import SaleStatus1 from "../../../hooks/chinaFunction/saleStatus1";
import InTotalPurchase from "../../../hooks/chinaFunction/inTotalPurchase";
import PsTotalPurchase from "../../../hooks/chinaFunction/psTotalPurchase";
import Timer from "../../../hooks/chinaFunction/timer";
import TimerNft from "../../../hooks/chinaFunction/timeNft";
import { useHistory } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import DopNft from "../../DopNft/DopNft";
import BalacefAccountTomi from "../../../hooks/dataFetchers/BlanaceOfAccountTom";
import BalacefAccountGems from "../../../hooks/dataFetchers/BlanaceOfAccountGems";
import BalacefAccountLink from "../../../hooks/dataFetchers/BalacefAccountLink";
import BalacefAccountPepe from "../../../hooks/dataFetchers/BalacefAccountPepe";
import BalacefAccountUni from "../../../hooks/dataFetchers/BalacefAccountUni";
import BalacefAccountUsdc from "../../../hooks/dataFetchers/BalanceOfAccountUsdc";
import BalacefAccountWbtc from "../../../hooks/dataFetchers/BalanceOfAccountWbtc";
import AllowanceTomi from "../../../hooks/dataFetchers/AllowanceTomi";
import AllowanceGems from "../../../hooks/dataFetchers/AllowanceGems";
import AllowanceLink from "../../../hooks/dataFetchers/AllowanceLink";
import AllowancePepe from "../../../hooks/dataFetchers/AllowancePepe";
import AllowanceUniswape from "../../../hooks/dataFetchers/AllowanceUniswape";
import AllowanceUsdc from "../../../hooks/dataFetchers/AllowanceUsdc";
import AllowanceUsdc1 from "../../../hooks/dataFetchers/AllowanceUsdc1";
import AllowanceWbtc from "../../../hooks/dataFetchers/AllowanceWbtc";
import AllowanceWbtc1 from "../../../hooks/dataFetchers/AllowanceWbtc1";
import AllowanceTomi1 from "../../../hooks/dataFetchers/AllowanceTomi1";
import PurchaseTomi from "../../../hooks/chinaFunction/purchaseTomi";
import PurchaseTomi1 from "../../../hooks/chinaFunction/puchaseTomi1";
import DiscountedPrice from "../../../hooks/chinaFunction/discountedPrice";
import Environment from "../../../utils/Environment";
import WbtcPrice from "../../../hooks/chinaFunction/wbtcPrice";
import AllowanceDop from "../../../hooks/dataFetchers/AllowanceDop";
import ApproveDop from "../../../hooks/dataFetchers/ApproveDop";
import PurchaseDop from "../../../hooks/chinaFunction/purchaseDop";
import AllowanceDop1 from "../../../hooks/dataFetchers/AllowanceDop1";
import ApproveDop1 from "../../../hooks/dataFetchers/ApproveDop1";
import PurchaseDop1 from "../../../hooks/chinaFunction/purchaseDop1";
import BalacefAccountDop from "../../../hooks/dataFetchers/balanceOfAccountDop";
import { setupNetwork } from "../../../utils/wallet";
import { map, set } from "lodash";
import { ProgressBar } from "react-bootstrap";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import GetGemsStakedIndex from "../../../hooks/chinaFunction/getGemsStakedIndex";
import GetGemsStaked from "../../../hooks/chinaFunction/getGemsStakeAmount";
import { saveAddress } from "@sharemint/sdk";
import { storeReferrer } from "@sharemint/sdk";
import PurchaseGems from "../../../hooks/chinaFunction/purchaseGems";
import PurchaseGems1 from "../../../hooks/chinaFunction/purchaseGems1";
import AllowanceGems1 from "../../../hooks/dataFetchers/AllowanceGems1";
import ApproveGems1 from "../../../hooks/dataFetchers/ApproveGems1";
import { isBrowser } from "react-device-detect";
import InsurancePercentage from "../../../hooks/dataFetchers/insurancePercentage";

import { requestWithState } from "../../../@api/requestWithState";
const Banner = ({ setShow }) => {
  let sharemintValue = localStorage.getItem("sharemint");
  let ipBuyer = localStorage.getItem("ip");
  let countryBuyer = localStorage.getItem("country");
  const [checkBoxx, setCheckBoxx] = useState(false);
  const [insurancePer, setInsurancePer] = useState(0);
  const { allowanceDop } = AllowanceDop();
  const { allowanceDop1 } = AllowanceDop1();
  const { approveDop } = ApproveDop();
  const { approveDop1 } = ApproveDop1();
  const { purchaseDop } = PurchaseDop();
  const { purchaseDop1 } = PurchaseDop1();
  const { balacefAccountDop } = BalacefAccountDop();
  const history = useHistory();
  const { getGemsStaked } = GetGemsStaked();
  const { getGemsStakedIndex } = GetGemsStakedIndex();
  const { allowanceLink } = AllowanceLink();
  const { allowanceTomi } = AllowanceTomi();
  const { allowanceGems } = AllowanceGems();
  const { allowancePepe } = AllowancePepe();
  const { allowanceUniswape } = AllowanceUniswape();
  const { allowanceUsdc } = AllowanceUsdc();
  const { allowanceWbtc } = AllowanceWbtc();
  const { allowanceUsdc1 } = AllowanceUsdc1();
  const { allowanceWbtc1 } = AllowanceWbtc1();
  const { allowanceTomi1 } = AllowanceTomi1();
  const { cuurentRound } = CuurentRound();
  const { cuurentRoundNft } = CuurentRoundNft();
  const { saleStatus } = SaleStatus();
  const { saleStatusNft } = SaleStatusNft();
  const { insurancePercentage } = InsurancePercentage();
  const { psMarketCap } = PsMarketCap();
  const { inMarketCap } = InMarketCap();
  const { psTotalPurchase } = PsTotalPurchase();
  const { inTotalPurchase } = InTotalPurchase();
  const { saleStatus1 } = SaleStatus1();
  const { timer } = Timer();
  const { timerNft } = TimerNft();
  const { purchaseTomi } = PurchaseTomi();
  const { purchaseGems } = PurchaseGems();
  const { approveGems1 } = ApproveGems1();
  const { purchaseGems1 } = PurchaseGems1();
  const { allowanceGems1 } = AllowanceGems1();
  const [gemsAllowance1, setGemsAllwance1] = useState(null);
  const { purchaseTomi1 } = PurchaseTomi1();
  const { discountedPrice } = DiscountedPrice();
  const [psTotlaPurchasess, setPsTotlaPurchasess] = useState(null);
  const [inTotlaPurchasess, setInTotlaPurchasess] = useState(null);
  const [psmyTotlaPurchasess, setMyPsTotlaPurchasess] = useState(null);
  const [inMyTotlaPurchasess, setMyInTotlaPurchasess] = useState(null);
  const [psMaxxCap, setPsMaxxCap] = useState(null);
  const [inMaxxCap, setInMaxxCap] = useState(null);
  const [stakeEndTime, setStakeEndTime] = useState([]);
  const [stakingData, setStakingData] = useState([]);
  var now11 = new Date();
  let createdDate = now11?.getTime();

  const [email, setEmail] = useState(null);

  const [inputFeild7, setInputField7] = useState(null);
  const [otp, setOtp] = useState("");
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [isOtpValid, setIsOtpValid] = useState(true);
  const [showverify, setShowVerify] = useState(false);
  const [verified, setVerified] = useState(null);
  const [isChecking, setIsChecking] = useState(false);

  const [timer12, setTimer12] = useState(0);
  const [isResendDisabled, setIsResendDisabled] = useState(false);
  const [inputFeild6, setInputFeild6] = useState(null);
  const [cheked, setCheked] = useState(false);
  const [cheked1, setCheked1] = useState(false);
  const [cheked2, setCheked2] = useState(false);
  const [checkedNew, setCheckedNew] = useState(false);
  const [checkedNew1, setCheckedNew1] = useState(false);
  const [inputFeild8, setInputFeild8] = useState(null);
  const [emailModelCheck, setEmailModelCheck] = useState(null);
  const [show2, setShow2] = useState(false);
  const handleClose2 = () => {
    setShow2(false);
    setCheked(false);
    setCheked1(false);
    setCheckedNew(false);
  };
  const handleShow2 = () => setShow2(true);
  useEffect(() => {
    storeReferrer();
    return () => {};
  }, []);
  // console.log(createdDate,'createdDate');
  // const capHandler = async () => {
  //   try {

  //     // const { psMarketCap } = PsMarketCap()
  //     // const { inMarketCap } = InMarketCap()
  //     // const { psTotalPurchase } = PsTotalPurchase()
  //     // const { inTotalPurchase } = InTotalPurchase()
  //     let a = await psMarketCap()
  //     setPsMaxxCap(a)
  //     let b = await inMarketCap()
  //     setInMaxxCap(b)
  //     let c = await psTotalPurchase()
  //     setPsTotlaPurchasess(c)
  //     let v = await inTotalPurchase()
  //     setInTotlaPurchasess(v)
  //     // console.log(a,b,v,c,'total cap');
  //   } catch (err) {
  //     console.log(err, 'err from cap');

  //   }
  // }
  // // console.log(psMaxxCap,psmyTotlaPurchasess,'nooooooooor',psTotlaPurchasess);
  let currentTime = createdDate / 1000;
  currentTime = parseInt(currentTime);
  const objjjj = localStorage?.getItem("oobjj");
  const code = localStorage?.getItem("accessCode");
  const instiPrice = localStorage?.getItem("price_ins");
  const role = localStorage?.getItem("role_ins");
  // const email = localStorage?.getItem("email");
  const modalTwitter = localStorage?.getItem("twittter");
  const startTime11 = localStorage?.getItem("timeeee");
  const [id, setId] = useState(null);
  const [price, setPrice] = useState(null);
  const [round, setRound] = useState(null);
  const [loaderr, setLoarder] = useState(false);
  const [loaderr1, setLoarder1] = useState(false);
  const { purchaseUsdt } = PurchaseUsdt();
  const { purchaseUsdc } = PurchaseUsdc();
  const { purchaseUsdc1 } = PurchaseUsdc1();
  const { purchaseWbtc } = PurchaseWbtc();
  const { purchaseWbtc1 } = PurchaseWbtc1();
  const { purchasePepe } = PurchasePepe();
  const { purchaseLink } = PurchaseLink();
  const { purchaseUniswape } = PurchaseUniswape();
  const { purchaseEth } = PurchaseEth();
  const { purchaseUsdt1 } = PurchaseUsdt1();
  const { purchaseEth1 } = PurchaseEth1();
  const { approveTpl } = ApproveTpl();
  const { approveTplUsdc } = ApproveTplUsdc();
  const { approveTplwbtc } = ApproveTplWbtc();
  const { approveTplUsdc1 } = ApproveTplUsdc1();
  const { approveTplwbtc1 } = ApproveTplWbtc1();
  const { approveTomi } = ApproveTomi();
  const { approveGems } = ApproveGems();
  const { approveLink } = ApproveLink();
  const { approvePepe } = ApprovePepe();
  const { approveUnisawape } = ApproveUnisawape();
  const { approveTomi1 } = ApproveTomi1();
  const { approveTpl1 } = ApproveTpl1();
  const { allowanceTpl } = AllowanceTpl();
  const { allowanceTpl1 } = AllowanceTpl1();
  const { balacefAccount } = BalacefAccount();
  const { balacefAccountTomi } = BalacefAccountTomi();
  const { balacefAccountGems } = BalacefAccountGems();
  const { balacefAccountLink } = BalacefAccountLink();
  const { balacefAccountUni } = BalacefAccountUni();
  const { balacefAccountPepe } = BalacefAccountPepe();
  const { balacefAccountUsdc } = BalacefAccountUsdc();
  const { balacefAccountWbtc } = BalacefAccountWbtc();
  const [currentRoundd, setCurrentRoundd] = useState(null);
  const [copyOfPrice, setCopyOfPrice] = useState(null);
  const [priceCheck, setPriceCheck] = useState(false);
  const web3 = useWeb3();
  let now = Date.now();
  const { ethPrice } = EthPrice();
  const { linkPrice } = LinkPrice();
  const { uniPrice } = UniPrice();
  const { wbtcPrice } = WbtcPrice();
  const [inputFeild5, setInputField5] = useState(null);
  const [inputFeild, setInputField] = useState(null);
  const [inputFeild1, setInputField1] = useState(null);
  const [ethPricevalue, setEthPrice] = useState(0);
  const [uniPricevalue, setUniPrice] = useState(0);
  const [dopPricevalue, setDopPrice] = useState(0);
  const [linkPricevalue, setlinkPrice] = useState(0);
  const [blanceOfEth, setBlanceOfEth] = useState(0);
  const [date, setDate] = useState(0);
  const [mainTag, setMainTag] = useState("ETH");
  const [mainTag1, setMainTag1] = useState("USDT");
  const { account, chainId } = useWeb3React();
  const [balanceeUsdt, setBalanceeUsdt] = useState(null);
  const [sallowance, setAllowance] = useState(null);
  const [getAllowanceUsdc, setAllowanceUsdc] = useState(null);
  const [getAllowanceWbtc, setAllowanceWbtc] = useState(null);
  const [getAllowanceUsdc1, setAllowanceUsdc1] = useState(null);
  const [getAllowanceWbtc1, setAllowanceWbtc1] = useState(null);
  const [sallowance1, setAllowance1] = useState(null);
  const [currentRount, setCurrentRount] = useState(null);
  const [currentTimer, setCurrentTimer] = useState(null);
  const [timeshow, setTimeshow] = useState(false);
  const [day, setDay] = useState(0);
  const [hour, setHour] = useState(0);
  const [min, setMin] = useState(0);
  const [sec, setSec] = useState(0);
  const [saleCurrentStaus, setSaleCurrentStaus] = useState(false);
  const [saleCurrentStaus1, setSaleCurrentStaus1] = useState(false);
  const [check, setCheck] = useState(false);
  const [amountInUsdt, setAmountInUsdt] = useState(null);
  const [niceName, setNicName] = useState(null);
  // console.log(niceName,'niceName');
  const [tab, setTab] = useState("home");
  const [tagImge, setTagImge] = useState("/assets/eth-icon.svg");
  const [pepePrice, setPepePrice] = useState(0);
  const [tomiPrice, setTomiPrice] = useState(0);
  const [gemsPrice, setGemsPrice] = useState(0);
  const [gemsBalance, setGemsBalance] = useState(0);
  const [wbtcCurrentPrice, setWbtcCurrentPrice] = useState(null);
  // const [usdcCurrentPrice,setUsdcCurrentPrice]=useState(null)
  const [balaceOfTmi, setBalanceOfTomi] = useState(null);
  const [balaceOfUnii, setBalanceOfUnii] = useState(null);
  const [balaceOfDoppp, setBalanceOfDopp] = useState(null);
  const [balaceOfLinkk, setBalanceOfLinkk] = useState(null);
  const [balaceOfPepee, setBalanceOfPepee] = useState(null);
  const [balaceOfUsdc, setBalanceOfUsdc] = useState(null);
  const [balaceOfWbtc, setBalanceOfWbtc] = useState(null);
  const [tomiAllowance, setTomiAllwance] = useState(null);
  const [gemsAllowance, setGemsAllwance] = useState(null);
  const [uniAllowance, setUniAllwance] = useState(null);
  const [linkAllowance, setLinkAllwance] = useState(null);
  const [dopAllowance, setDopAllwance] = useState(null);
  const [dopAllowance1, setDopAllwance1] = useState(null);
  const [pepeAllowance, setPepeAllwance] = useState(null);
  const [tomiAllowance1, setTomiAllwance1] = useState(null);
  const [percent, setPercet] = useState(0);
  const [stakeIndex, setStakeIndux] = useState([]);
  const [stakedAmount, setStakedAmount] = useState(0);
  const [multiplyPercentNumbere, setMultiplyPercentNumbere] = useState(0);
  const [discountedPriceee, setDiscountedPriceee] = useState(0);
  const [ethValueCalcualte, setethValueCalcualte] = useState(null);
  const [stakeEndTime1, setStakeEndTime1] = useState([]);
  const [stakingData1, setStakingData1] = useState({});

  const [cheked3, setCheked3] = useState(false);
  const [cheked4, setCheked4] = useState(false);

  const [show2insurance1, setShow2Insurance1] = useState(false);
  const handleClose2Insurance1 = () => {
    setShow2Insurance1(false);
  };
  const handleClose2Insurance12 = () => {
    // setInsuranceCheck(true);
    setCheckBoxx(true);
    setShow2Insurance1(false);
  };
  const handleShow2Insurance1 = () => {
    setShow2Insurance1(true);
  };
  // const handleClose2Insurance1 = () => setShow2Insurance1(true);

  // const [limitObj, setLimitObj] = useState(null)
  // const [limitObjperc, setLimitObjperc] = useState(null)
  // const [gaugePosition,setGaugePosition] =useState(null);
  // console.log( stakedAmount,discountedPriceee,multiplyPercentNumbere,' Additional Tokens');

  const [show0, setShow0] = useState(false);

  const handleClos0 = async () => {
    setShow0(false);
    if (inputFeild && inputFeild1) {
      if (chainId !== 1) {
        let ss = await setupNetwork();
        if (ss) {
          confirm();
        }
      } else {
        confirm();
      }
    }
  };
  const handleShow0 = () => setShow0(true);

  const [show5, setShow5] = useState(false);
  const handleClose5 = () => {
    setShow5(false);
    window.location.reload();
  };
  const handleShow5 = () => setShow5(true);

  useEffect(() => {
    // capHandler()
    firstTimeData();
    firstTimeData11();
    uniPriceHandler();
    linkPriceHnadler();
    dopPriceHandler();
    saleStatusss();
    alowence();
    getPepePrice();
    getTomiPrice();
    getGemsPrice();
    getWbtcCurrentPrice();
    if (account) {
      balaceOf();
      firstTimeData1();
      balancerOftomi();
      balancerOfGems();
      balancerOfPepe();
      balancerOfUni();
      balancerOfDop();
      balancerOfLink();
      balancerOfUsdc();
      balancerOfWbtc();
      fetchStakingData();
      fetchStakingData1();
      // StakeIndec()
      getGemsStakedAmount();
    } else {
      setBalanceeUsdt(null);
      setBlanceOfEth(null);
      setBalanceOfTomi(null);
      setBalanceOfUnii(null);
      setBalanceOfDopp(null);
      setBalanceOfLinkk(null);
      setBalanceOfPepee(null);
      setBalanceOfUsdc(null);
      setBalanceOfWbtc(null);
      setGemsBalance(null);
    }
  }, [account]);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     firstTimeData();
  //     firstTimeData1();
  //   }, 30000);

  //   return () => {
  //     clearInterval(interval);
  //   };
  // }, [account]);

  // console.log(sallowance,'sajad',inputFeild);

  const saleStatusss = async () => {
    try {
      let b = await saleStatus();
      let b1 = await saleStatus1();
      if (b || b1) {
        console.log(b1, b, "noooor imad");
        // setCurrentRoundd(b)
        // roundData(b)
        setSaleCurrentStaus(b);
        setSaleCurrentStaus1(b1);
      }
    } catch (err) {
      console.log(err.message, "noooor imad");
    }
  };

  const firstTimeData = async () => {
    setLoarder1(true);
    try {
      let b;
      b = await cuurentRound();
      setRound(b);
      let price = 0;
      if (b) {
        if (b == 1) {
          // setMultiplyPercentNumbere(0.2);
          price = 0.2;
        } else {
          // setMultiplyPercentNumbere(0.07);
          price = 0.07;
        }
        // console.log(b, "cccccccc");
        // setCurrentRoundd(b)
        roundData(b, price);
      }
    } catch (err) {
      console.log(err.message, "nooor");
      setLoarder1(false);
    }
  };
  // console.log(ethPricevalue,'ethPricevalue');
  const firstTimeData11 = async () => {
    try {
      let a = await ethPrice();
      if (a) {
        setEthPrice(a);
      }
    } catch (err) {
      console.log(err.message);
    }
  };
  // const uniPriceHandler = async () => {
  //   try {
  //     let a = await uniPrice();
  //     if (a) {
  //     setUniPrice(a);
  //     }
  //   } catch (err) {
  //     console.log(err.message,'aaa');
  //   }
  // };
  const uniPriceHandler = async () => {
    try {
      const config = {
        method: "get",
        url: `${API_URL}users/uni-price`,
      };
      const postApiRes = await axios(config).then(function (response) {
        let qw = response?.data?.data;
        // setPepePrice(qw)
        setUniPrice(qw);
      });
    } catch (error) {
      console.log("coin market cap error::", error);
    }
  };
  const dopPriceHandler = async () => {
    try {
      const config = {
        method: "get",
        url: `${API_URL}users/dop-price`,
      };
      const postApiRes = await axios(config).then(function (response) {
        let qw = response?.data?.data;
        // setPepePrice(qw)
        setDopPrice(qw);
      });
    } catch (error) {
      console.log("coin market cap error::", error);
    }
  };
  const linkPriceHnadler = async () => {
    try {
      let a = await linkPrice();
      if (a) {
        setlinkPrice(a);
      }
    } catch (err) {
      console.log(err.message);
    }
  };
  const getPepePrice = async () => {
    try {
      const config = {
        method: "get",
        url: `${API_URL}users/pepe-price`,
      };
      const postApiRes = await axios(config).then(function (response) {
        // console.log(response,'response');
        let qw = response?.data?.data;
        setPepePrice(qw);
      });
    } catch (error) {
      console.log("coin market cap error::", error);
    }
  };
  const getTomiPrice = async () => {
    try {
      const config = {
        method: "get",
        url: `${API_URL}users/tomi-price`,
      };
      const postApiRes = await axios(config).then(function (response) {
        // console.log(response,'response');
        let qw = response?.data?.data;
        setTomiPrice(qw);
      });
    } catch (error) {
      console.log("coin market cap error::", error);
    }
  };

  const getGemsPrice = async () => {
    try {
      const config = {
        method: "get",
        url: `${API_URL}users/gems-price`,
      };
      const postApiRes = await axios(config).then(function (response) {
        // console.log(response,'response');
        let qw = response?.data?.data;
        setGemsPrice(qw);
      });
    } catch (error) {
      console.log("coin market cap error::", error);
    }
  };

  const firstTimeData1 = async () => {
    try {
      var balance = await web3.eth.getBalance(account);
      setBlanceOfEth(balance / 10 ** 18);
    } catch (err) {
      console.log(err.message);
    }
  };

  const getWbtcCurrentPrice = async () => {
    try {
      let a = await wbtcPrice();
      if (a) {
        // console.log(a,'aaa');
        setWbtcCurrentPrice(a);
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  const [show1, setShow1] = useState(false);
  const handleClose = () => {
    setInputField("");
    setInputField1("");
    setMyInTotlaPurchasess(0);
    setMyPsTotlaPurchasess(0);
    setShow1(false);
  };
  const handleShow = () => setShow1(true);
  const changeTag = () => {
    if (mainTag === "ETH") {
      setMainTag("USDT");
      setMainTag1("ETH");
      setInputField1("");
      setInputField("");
      setMyInTotlaPurchasess(0);
      setMyPsTotlaPurchasess(0);
      // }
    } else {
      setMainTag("ETH");
      setMainTag1("USDT");
      setInputField1("");
      setInputField("");
      setMyInTotlaPurchasess(0);
      setMyPsTotlaPurchasess(0);
    }
  };
  const changeTag1 = (e) => {
    if (e === "ETH") {
      discoundedPriceee(currentRoundd, Environment.eth);
      setMainTag("ETH");
      setTagImge("/assets/eth-icon.svg");
      // setMainTag1("ETH");
      setInputField1("");
      setInputField("");
      setMyInTotlaPurchasess(0);
      setMyPsTotlaPurchasess(0);
      // }
    } else if (e == "USDT") {
      discoundedPriceee(currentRoundd, Environment.busd);
      setMainTag("USDT");
      setTagImge("/assets/usdt.svg");
      // setMainTag1("USDT");
      setInputField1("");
      setInputField("");
      setMyInTotlaPurchasess(0);
      setMyPsTotlaPurchasess(0);
    } else if (e == "USDC") {
      discoundedPriceee(currentRoundd, Environment.usdc);
      setMainTag("USDC");
      setTagImge("/assets/usdc.svg");
      // setMainTag1("USDT");
      setInputField1("");
      setInputField("");
      setMyInTotlaPurchasess(0);
      setMyPsTotlaPurchasess(0);
    } else if (e == "WBTC") {
      discoundedPriceee(currentRoundd, Environment.wbtc);
      setMainTag("WBTC");
      setTagImge("/assets/wbtc.svg");
      // setMainTag1("USDT");
      setInputField1("");
      setInputField("");
      setMyInTotlaPurchasess(0);
      setMyPsTotlaPurchasess(0);
    } else if (e == "PEPE") {
      discoundedPriceee(currentRoundd, Environment.pepe);
      setMainTag("PEPE");
      setTagImge("/assets/pepe.svg");
      // setMainTag1("USDT");
      setInputField1("");
      setInputField("");
      setMyInTotlaPurchasess(0);
      setMyPsTotlaPurchasess(0);
    } else if (e == "DOP") {
      discoundedPriceee(currentRoundd, Environment.dop);
      setMainTag("DOP");
      setTagImge("/assets/dop.svg");
      // setMainTag1("USDT");
      setInputField1("");
      setInputField("");
      setMyInTotlaPurchasess(0);
      setMyPsTotlaPurchasess(0);
    } else if (e == "UNI") {
      discoundedPriceee(currentRoundd, Environment.unisape);
      setMainTag("UNI");
      setTagImge("/assets/uniswap.svg");
      // setMainTag1("USDT");
      setInputField1("");
      setInputField("");
      setMyInTotlaPurchasess(0);
      setMyPsTotlaPurchasess(0);
    } else if (e == "LINK") {
      discoundedPriceee(currentRoundd, Environment.link);
      setMainTag("LINK");
      setTagImge("/assets/link.svg");
      // setMainTag1("USDT");
      setInputField1("");
      setInputField("");
      setMyInTotlaPurchasess(0);
      setMyPsTotlaPurchasess(0);
    } else if (e == "TOMI") {
      discoundedPriceee(currentRoundd, Environment.tomi);
      setMainTag("TOMI");
      setTagImge("/assets/tomi-icon-drop.svg");
      // setMainTag1("USDT");
      setInputField1("");
      setInputField("");
      setMyInTotlaPurchasess(0);
      setMyPsTotlaPurchasess(0);
    } else {
      discoundedPriceee(currentRoundd, Environment.gems);
      setMainTag("GEMS");
      setTagImge("/assets/newgemslogosvg.svg");
      // setMainTag1("USDT");
      setInputField1("");
      setInputField("");
      setMyInTotlaPurchasess(0);
      setMyPsTotlaPurchasess(0);
    }
  };
  const inputField1Handler = (e) => {
    setAmountInUsdt(0);
    let value = e.target.value;
    if (mainTag === "ETH") {
      if (value) {
        let amount = parseFloat((ethPricevalue * value) / price).toFixed(6);
        let amount1 = "";
        if (price > 0) {
          amount1 = Math.round(amount * 1e12) / 1e12;
        } else {
          amount1 = 0.0;
        }
        setInputField1(parseFloat(amount1)?.toFixed(2));
        setAmountInUsdt(parseFloat(ethPricevalue * value));
        setInputField(value);
        setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
        setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
        let aa = (ethPricevalue * value).toFixed(4);
        let vv = aa / discountedPriceee;
        let cc = vv - parseFloat(amount1)?.toFixed(2);
        setethValueCalcualte(cc);
        // console.log(cc.toFixed,aa,vv,discountedPriceee, 'ccccc');

        // (parseFloat(inputFeild) * parseFloat(ethPricevalue) / parseFloat(discountedPriceee))- (parseFloat(inputFeild1))
        // ?.toFixed(2)
      } else {
        setInputField1("");
        setInputField("");
        setethValueCalcualte(0);
        setMyInTotlaPurchasess(0);
        setMyPsTotlaPurchasess(0);
      }
    } else if (mainTag === "USDT") {
      if (value) {
        let amount = parseFloat(value / price).toFixed(6);
        let amount1 = "";
        if (price > 0) {
          amount1 = Math.round(amount * 1e12) / 1e12;
        } else {
          amount1 = 0.0;
        }
        setInputField1(parseFloat(amount1)?.toFixed(2));
        setInputField(value);
        setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
        setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
        setAmountInUsdt(parseFloat(value));

        let aa = value;
        let vv = aa / discountedPriceee;
        let cc = vv - parseFloat(amount1)?.toFixed(2);
        setethValueCalcualte(cc);
      } else {
        setInputField1("");
        setInputField("");
        setethValueCalcualte(0);
        setMyInTotlaPurchasess(0);
        setMyPsTotlaPurchasess(0);
      }
    } else if (mainTag === "USDC") {
      if (value) {
        let amount = parseFloat(value / price).toFixed(6);
        let amount1 = "";
        if (price > 0) {
          amount1 = Math.round(amount * 1e12) / 1e12;
        } else {
          amount1 = 0.0;
        }
        setInputField1(parseFloat(amount1)?.toFixed(2));
        setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
        setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
        setInputField(value);
        setAmountInUsdt(parseFloat(value));
        let aa = value;
        let vv = aa / discountedPriceee;
        let cc = vv - parseFloat(amount1)?.toFixed(2);
        setethValueCalcualte(cc);
      } else {
        setInputField1("");
        setInputField("");
        setMyInTotlaPurchasess(0);
        setMyPsTotlaPurchasess(0);
        setethValueCalcualte(0);
      }
    } else if (mainTag === "WBTC") {
      if (value) {
        let amount = parseFloat((wbtcCurrentPrice * value) / price).toFixed(6);
        let amount1 = "";
        if (price > 0) {
          amount1 = Math.round(amount * 1e12) / 1e12;
        } else {
          amount1 = 0.0;
        }
        setInputField1(parseFloat(amount1)?.toFixed(2));
        setAmountInUsdt(parseFloat(wbtcCurrentPrice * value));
        setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
        setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
        setInputField(value);
        let aa = (wbtcCurrentPrice * value).toFixed(4);
        let vv = aa / discountedPriceee;
        let cc = vv - parseFloat(amount1)?.toFixed(2);
        setethValueCalcualte(cc);
      } else {
        setInputField1("");
        setInputField("");
        setMyInTotlaPurchasess(0);
        setMyPsTotlaPurchasess(0);
      }
    } else if (mainTag === "UNI") {
      if (value) {
        let amount = parseFloat((uniPricevalue * value) / price).toFixed(6);
        let amount1 = "";
        if (price > 0) {
          amount1 = Math.round(amount * 1e12) / 1e12;
        } else {
          amount1 = 0.0;
        }

        setInputField1(parseFloat(amount1)?.toFixed(2));
        setAmountInUsdt(parseFloat(uniPricevalue * value));
        setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
        setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
        setInputField(value);

        let aa = (uniPricevalue * value).toFixed(4);
        let vv = aa / discountedPriceee;
        let cc = vv - parseFloat(amount1)?.toFixed(2);
        setethValueCalcualte(cc);
      } else {
        setInputField1("");
        setInputField("");
        setMyInTotlaPurchasess(0);
        setMyPsTotlaPurchasess(0);
      }
    } else if (mainTag === "LINK") {
      if (value) {
        let amount = parseFloat((linkPricevalue * value) / price).toFixed(6);
        let amount1 = "";
        if (price > 0) {
          amount1 = Math.round(amount * 1e12) / 1e12;
        } else {
          amount1 = 0.0;
        }
        // console.log('aasas',linkPricevalue,value,price);
        setInputField1(parseFloat(amount1)?.toFixed(2));
        setAmountInUsdt(parseFloat(linkPricevalue * value));
        setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
        setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
        setInputField(value);

        let aa = (linkPricevalue * value).toFixed(4);
        let vv = aa / discountedPriceee;
        let cc = vv - parseFloat(amount1)?.toFixed(2);
        setethValueCalcualte(cc);
      } else {
        setInputField1("");
        setInputField("");
        setMyInTotlaPurchasess(0);
        setMyPsTotlaPurchasess(0);
      }
    } else if (mainTag === "DOP") {
      if (value) {
        let amount = parseFloat((dopPricevalue * value) / price).toFixed(6);
        let amount1 = "";
        if (price > 0) {
          amount1 = Math.round(amount * 1e12) / 1e12;
        } else {
          amount1 = 0.0;
        }
        // console.log('aasas',linkPricevalue,value,price);
        setInputField1(parseFloat(amount1)?.toFixed(2));
        setAmountInUsdt(parseFloat(dopPricevalue * value));
        setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
        setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
        setInputField(value);

        let aa = (dopPricevalue * value).toFixed(4);
        let vv = aa / discountedPriceee;
        let cc = vv - parseFloat(amount1)?.toFixed(2);
        setethValueCalcualte(cc);
      } else {
        setInputField1("");
        setInputField("");
        setMyInTotlaPurchasess(0);
        setMyPsTotlaPurchasess(0);
      }
    } else if (mainTag === "PEPE") {
      if (value) {
        let amount = parseFloat((pepePrice * value) / price).toFixed(6);
        let amount1 = "";
        if (price > 0) {
          amount1 = Math.round(amount * 1e12) / 1e12;
        } else {
          amount1 = 0.0;
        }
        setInputField1(parseFloat(amount1)?.toFixed(2));
        setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
        setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
        setAmountInUsdt(parseFloat(pepePrice * value));
        setInputField(value);

        let aa = (pepePrice * value).toFixed(4);
        let vv = aa / discountedPriceee;
        let cc = vv - parseFloat(amount1)?.toFixed(2);
        setethValueCalcualte(cc);
      } else {
        setInputField1("");
        setInputField("");
        setMyInTotlaPurchasess(0);
        setMyPsTotlaPurchasess(0);
      }
    } else if (mainTag === "TOMI") {
      if (value) {
        let amount = parseFloat((tomiPrice * value) / price).toFixed(6);
        let amount1 = "";
        if (price > 0) {
          amount1 = Math.round(amount * 1e12) / 1e12;
        } else {
          amount1 = 0.0;
        }
        setInputField1(parseFloat(amount1)?.toFixed(2));
        setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
        setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
        setAmountInUsdt(parseFloat(tomiPrice * value));
        setInputField(value);
        let aa = (tomiPrice * value).toFixed(4);
        let vv = aa / discountedPriceee;
        let cc = vv - parseFloat(amount1)?.toFixed(2);
        setethValueCalcualte(cc);
      } else {
        setInputField1("");
        setInputField("");
        setMyInTotlaPurchasess(0);
        setMyPsTotlaPurchasess(0);
      }
    } else {
      if (value) {
        let amount = parseFloat((gemsPrice * value) / price).toFixed(6);
        let amount1 = "";
        if (price > 0) {
          amount1 = Math.round(amount * 1e12) / 1e12;
        } else {
          amount1 = 0.0;
        }
        setInputField1(parseFloat(amount1)?.toFixed(2));
        setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
        setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
        setAmountInUsdt(parseFloat(gemsPrice * value));
        setInputField(value);
        let aa = (gemsPrice * value).toFixed(4);
        let vv = aa / discountedPriceee;
        let cc = vv - parseFloat(amount1)?.toFixed(2);
        setethValueCalcualte(cc);
      } else {
        setInputField1("");
        setInputField("");
        setMyInTotlaPurchasess(0);
        setMyPsTotlaPurchasess(0);
      }
    }
  };
  const inputField1Handler1 = (e) => {
    let value = e.target.value;
    if (mainTag === "ETH") {
      if (value) {
        let amount = parseFloat((value * price) / ethPricevalue).toFixed(6);
        let amount1 = Math.round(amount * 1e12) / 1e12;
        setInputField(parseFloat(amount1)?.toFixed(2));
        setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
        setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
        setInputField1(parseFloat(value));

        // }
      } else {
        setInputField1("");
        setInputField("");
        setMyInTotlaPurchasess(0);
        setMyPsTotlaPurchasess(0);
      }
    } else if (mainTag === "USDT") {
      if (value) {
        let amount = parseFloat(value * price).toFixed(6);
        let amount1 = Math.round(amount * 1e12) / 1e12;
        setInputField(parseFloat(amount1)?.toFixed(2));
        setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
        setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
        setInputField1(value);
      } else {
        setInputField1("");
        setInputField("");
        setMyInTotlaPurchasess(0);
        setMyPsTotlaPurchasess(0);
      }
    } else if (mainTag === "USDC") {
      if (value) {
        let amount = parseFloat(value * price).toFixed(6);
        let amount1 = Math.round(amount * 1e12) / 1e12;
        setInputField(parseFloat(amount1)?.toFixed(2));
        setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
        setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
        setInputField1(value);
      } else {
        setInputField1("");
        setInputField("");
        setMyInTotlaPurchasess(0);
        setMyPsTotlaPurchasess(0);
      }
    } else if (mainTag === "WBTC") {
      if (value) {
        let amount = parseFloat((value * price) / wbtcCurrentPrice).toFixed(6);
        let amount1 = Math.round(amount * 1e12) / 1e12;
        setInputField(parseFloat(amount1)?.toFixed(2));
        setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
        setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
        setInputField1(parseFloat(value));
      } else {
        setInputField1("");
        setInputField("");
        setMyInTotlaPurchasess(0);
        setMyPsTotlaPurchasess(0);
      }
    } else if (mainTag === "UNI") {
      if (value) {
        let amount = parseFloat((value * price) / uniPricevalue).toFixed(6);
        let amount1 = Math.round(amount * 1e12) / 1e12;
        setInputField(parseFloat(amount1)?.toFixed(2));
        setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
        setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
        setInputField1(parseFloat(value));
      } else {
        setInputField1("");
        setInputField("");
        setMyInTotlaPurchasess(0);
        setMyPsTotlaPurchasess(0);
      }
    } else if (mainTag === "LINK") {
      if (value) {
        let amount = parseFloat((value * price) / linkPricevalue).toFixed(6);
        let amount1 = Math.round(amount * 1e12) / 1e12;
        setInputField(parseFloat(amount1)?.toFixed(2));
        setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
        setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
        setInputField1(parseFloat(value));
      } else {
        setInputField1("");
        setInputField("");
        setMyInTotlaPurchasess(0);
        setMyPsTotlaPurchasess(0);
      }
    } else if (mainTag === "DOP") {
      if (value) {
        let amount = parseFloat((value * price) / dopPricevalue).toFixed(6);
        let amount1 = Math.round(amount * 1e12) / 1e12;
        setInputField(parseFloat(amount1)?.toFixed(2));
        setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
        setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);
        setInputField1(parseFloat(value));
      } else {
        setInputField1("");
        setInputField("");
        setMyInTotlaPurchasess(0);
        setMyPsTotlaPurchasess(0);
      }
    } else if (mainTag === "PEPE") {
      if (value) {
        let amount = parseFloat((value * price) / pepePrice).toFixed(6);
        let amount1 = Math.round(amount * 1e12) / 1e12;
        setInputField(parseFloat(amount1)?.toFixed(2));
        setInputField1(parseFloat(value));
        setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
        setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);

        // }
      } else {
        setInputField1("");
        setInputField("");
        setMyInTotlaPurchasess(0);
        setMyPsTotlaPurchasess(0);
      }
    } else if (mainTag === "TOMI") {
      if (value) {
        let amount = parseFloat((value * price) / tomiPrice).toFixed(6);
        let amount1 = Math.round(amount * 1e12) / 1e12;
        setInputField(parseFloat(amount1)?.toFixed(2));
        setInputField1(parseFloat(value));
        setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
        setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);

        // }
      } else {
        setInputField1("");
        setInputField("");
        setMyInTotlaPurchasess(0);
        setMyPsTotlaPurchasess(0);
      }
    } else {
      if (value) {
        let amount = parseFloat((value * price) / gemsPrice).toFixed(6);
        let amount1 = Math.round(amount * 1e12) / 1e12;
        setInputField(parseFloat(amount1)?.toFixed(2));
        setInputField1(parseFloat(value));
        setMyInTotlaPurchasess(amount1 + inTotlaPurchasess);
        setMyPsTotlaPurchasess(amount1 + psTotlaPurchasess);

        // }
      } else {
        setInputField1("");
        setInputField("");
        setMyInTotlaPurchasess(0);
        setMyPsTotlaPurchasess(0);
      }
    }
  };
  const balaceOf = async () => {
    try {
      let balace = await balacefAccount(account);
      if (balace) {
        setBalanceeUsdt(balace);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const balancerOftomi = async () => {
    try {
      let balace = await balacefAccountTomi(account);
      if (balace) {
        console.log(balace, "tomi erre");
        setBalanceOfTomi(balace);
      }
    } catch (err) {
      console.log(err, "tomi erre");
    }
  };
  const balancerOfGems = async () => {
    try {
      let balace = await balacefAccountGems(account);
      if (balace) {
        setGemsBalance(balace);
      }
    } catch (err) {
      console.log(err, "tomi erre");
    }
  };
  const balancerOfPepe = async () => {
    try {
      let balace = await balacefAccountPepe(account);
      if (balace) {
        setBalanceOfPepee(balace);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const balancerOfUni = async () => {
    try {
      let balace = await balacefAccountUni(account);
      if (balace) {
        setBalanceOfUnii(balace);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const balancerOfDop = async () => {
    try {
      let balace = await balacefAccountDop(account);
      if (balace) {
        setBalanceOfDopp(balace);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const balancerOfLink = async () => {
    try {
      let balace = await balacefAccountLink(account);
      if (balace) {
        setBalanceOfLinkk(balace);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const balancerOfUsdc = async () => {
    try {
      let balace = await balacefAccountUsdc(account);
      if (balace) {
        setBalanceOfUsdc(balace);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const balancerOfWbtc = async () => {
    try {
      let balace = await balacefAccountWbtc(account);
      if (balace) {
        setBalanceOfWbtc(balace);
      }
    } catch (err) {
      console.log(err, "sdsdsdvcv");
    }
  };
  const alowence = async () => {
    try {
      // let insirance = await insurancePercentage();
      // setInsurancePer(insirance / 100);

      let w134sr = await allowanceGems1();
      setGemsAllwance1(w134sr);
      let w134s = await allowanceDop1();
      setDopAllwance1(w134s);
      let was = await allowanceGems();
      setGemsAllwance(was);
      let wbtcc = await allowanceWbtc();
      setAllowanceWbtc(wbtcc);
      let r = await allowanceTpl();
      setAllowance(r);
      let w11 = await allowanceLink();
      setLinkAllwance(w11);
      let w134 = await allowanceDop();
      setDopAllwance(w134);
      let w22 = await allowancePepe();
      setPepeAllwance(w22);
      let w33 = await allowanceUniswape();
      setUniAllwance(w33);
      let usdcc = await allowanceUsdc();
      setAllowanceUsdc(usdcc);
      let w = await allowanceTomi();
      setTomiAllwance(w);
      let r1 = await allowanceTpl1();
      setAllowance1(r1);
      let da = await allowanceTomi1();
      setTomiAllwance1(da);

      let usdcc1 = await allowanceUsdc1();
      setAllowanceUsdc1(usdcc1);
      let wbtcc1 = await allowanceWbtc1();
      setAllowanceWbtc1(wbtcc1);
    } catch (err) {
      console.log(err, "nooooer23");
    }
  };
  const handlerPop = async () => {
    if (role === "institution") {
      {
        confirm();
      }
    } else {
      if (
        (stakedAmount >= 5555 && stakingData?.length > 0) ||
        moment().isBefore(stakeEndTime1)
      ) {
        if (inputFeild && inputFeild1) {
          if (chainId !== 1) {
            let ss = await setupNetwork();
            if (ss) {
              confirm();
            }
          } else {
            confirm();
          }
        }
      } else {
        handleShow0();
      }
    }
  };
  const confirm = async () => {
    setLoarder(true);
    let postApiRes = "";
    var config = "";
    confirmBuyBefore();
    if (role === "institution") {
      if (mainTag == "ETH") {
        config = {
          method: "post",
          url: `${API_URL}institutions/buy/rain`,
          data: {
            tokenSelected: mainTag,
            accessCode: code,
            walletAddress: inputFeild5?.toString(),
            country: countryBuyer,
            privateSale: "RAIN",
          },
        };
      } else if (mainTag == "USDC") {
        config = {
          method: "post",
          url: `${API_URL}institutions/buy/rain`,
          data: {
            tokenSelected: mainTag,
            accessCode: code,
            walletAddress: inputFeild5?.toString(),
            country: countryBuyer,
            privateSale: "RAIN",
          },
        };
      } else if (mainTag == "WBTC") {
        config = {
          method: "post",
          url: `${API_URL}institutions/buy/rain`,
          data: {
            tokenSelected: mainTag,
            accessCode: code,
            walletAddress: inputFeild5?.toString(),
            country: countryBuyer,
            privateSale: "RAIN",
          },
        };
      } else if (mainTag == "USDT") {
        config = {
          method: "post",
          url: `${API_URL}institutions/buy/rain`,
          data: {
            tokenSelected: mainTag,
            accessCode: code,
            walletAddress: inputFeild5?.toString(),
            country: countryBuyer,
            privateSale: "RAIN",
          },
        };
      } else if (mainTag == "TOMI") {
        config = {
          method: "post",
          url: `${API_URL}institutions/buy/rain`,
          data: {
            tokenSelected: mainTag,
            accessCode: code,
            walletAddress: inputFeild5?.toString(),
            country: countryBuyer,
            privateSale: "RAIN",
          },
        };
      } else if (mainTag == "DOP") {
        config = {
          method: "post",
          url: `${API_URL}institutions/buy/rain`,
          data: {
            tokenSelected: mainTag,
            accessCode: code,
            walletAddress: inputFeild5?.toString(),
            country: countryBuyer,
            privateSale: "RAIN",
          },
        };
      } else {
        config = {
          method: "post",
          url: `${API_URL}institutions/buy/rain`,
          data: {
            tokenSelected: mainTag,
            accessCode: code,
            walletAddress: inputFeild5?.toString(),
            country: countryBuyer,
            privateSale: "RAIN",
          },
        };
      }

      postApiRes = await axios(config)
        .then(function (response) {
          return response?.data?.data;
        })
        .catch(function (error) {
          toast.error(error?.response?.data.message);
        });
    } else {
      if (mainTag == "TOMI") {
        config = {
          method: "post",
          url: `${API_URL}users/buy-rain`,
          data: {
            accessCode: code,
            walletAddress: account.toString(),
            country: countryBuyer,
            tokenSelected: "TOMI",
            email: email,
            type: "TOKEN",
            // isInsured: checkBoxx,
            // buyingAmount: amountInUsdt,
          },
        };
      } else if (mainTag == "ETH") {
        config = {
          method: "post",
          url: `${API_URL}users/buy-rain`,
          data: {
            accessCode: code,
            walletAddress: account.toString(),
            country: countryBuyer,
            tokenSelected: "ETH",
            email: email,
            type: "TOKEN",
            // isInsured: checkBoxx,
            // buyingAmount: amountInUsdt,
          },
        };
      } else if (mainTag == "WBTC") {
        config = {
          method: "post",
          url: `${API_URL}users/buy-rain`,
          data: {
            accessCode: code,
            walletAddress: account.toString(),
            country: countryBuyer,
            tokenSelected: "WBTC",
            email: email,
            type: "TOKEN",
            // isInsured: checkBoxx,
            // buyingAmount: amountInUsdt,
          },
        };
      } else if (mainTag == "USDC") {
        config = {
          method: "post",
          url: `${API_URL}users/buy-rain`,
          data: {
            accessCode: code,
            walletAddress: account.toString(),
            country: countryBuyer,
            tokenSelected: "USDC",
            email: email,
            // isInsured: checkBoxx,
            type: "TOKEN",
            // buyingAmount: amountInUsdt,
          },
        };
      } else if (mainTag == "UNI") {
        // let pricee= uniPricevalue
        // pricee =parseFloat(pricee).toFixed(6)
        // let amount1 = Math.round((pricee) * 1e12) / 1e12;
        // let nd = web3.utils.toWei(amount1.toString(), "mwei");
        config = {
          method: "post",
          url: `${API_URL}users/buy-rain`,
          data: {
            accessCode: code,
            walletAddress: account.toString(),
            country: countryBuyer,
            tokenSelected: "UNI",
            email: email,
            type: "TOKEN",
            // isInsured: checkBoxx,
            // buyingAmount: amountInUsdt,
          },
        };
      } else if (mainTag == "LINK") {
        // let pricee= uniPricevalue
        // pricee =parseFloat(pricee).toFixed(6)
        // let amount1 = Math.round((pricee) * 1e12) / 1e12;
        // let nd = web3.utils.toWei(amount1.toString(), "mwei");
        config = {
          method: "post",
          url: `${API_URL}users/buy-rain`,
          data: {
            accessCode: code,
            walletAddress: account.toString(),
            country: countryBuyer,
            tokenSelected: "LINK",
            type: "TOKEN",
            email: email,
            // isInsured: checkBoxx,
            // buyingAmount: amountInUsdt,
          },
        };
      } else if (mainTag == "PEPE") {
        // let pricee= uniPricevalue
        // pricee =parseFloat(pricee).toFixed(6)
        // let amount1 = Math.round((pricee) * 1e12) / 1e12;
        // let nd = web3.utils.toWei(amount1.toString(), "mwei");
        config = {
          method: "post",
          url: `${API_URL}users/buy-rain`,
          data: {
            accessCode: code,
            walletAddress: account.toString(),
            country: countryBuyer,
            tokenSelected: "PEPE",
            type: "TOKEN",
            email: email,
            // isInsured: checkBoxx,
            // buyingAmount: amountInUsdt,
          },
        };
      } else if (mainTag == "DOP") {
        // let pricee= uniPricevalue
        // pricee =parseFloat(pricee).toFixed(6)
        // let amount1 = Math.round((pricee) * 1e12) / 1e12;
        // let nd = web3.utils.toWei(amount1.toString(), "mwei");
        config = {
          method: "post",
          url: `${API_URL}users/buy-rain`,
          data: {
            accessCode: code,
            walletAddress: account.toString(),
            country: countryBuyer,
            tokenSelected: "DOP",
            type: "TOKEN",
            email: email,
            // isInsured: checkBoxx,
            // buyingAmount: amountInUsdt,
          },
        };
      } else if (mainTag === "USDT") {
        config = {
          method: "post",
          url: `${API_URL}users/buy-rain`,
          data: {
            accessCode: code,
            walletAddress: account.toString(),
            country: countryBuyer,
            tokenSelected: "USDT",
            type: "TOKEN",
            email: email,
            // isInsured: checkBoxx,
            // buyingAmount: amountInUsdt,
          },
        };
      } else {
        config = {
          method: "post",
          url: `${API_URL}users/buy-rain`,
          data: {
            accessCode: code,
            walletAddress: account.toString(),
            country: countryBuyer,
            tokenSelected: "GEMS",
            type: "TOKEN",
            email: email,
            // isInsured: checkBoxx,
            // buyingAmount: amountInUsdt,
          },
        };
      }

      postApiRes = await axios(config)
        .then(function (response) {
          return response?.data?.data;
        })
        .catch(function (error) {
          toast.error(error?.response?.data.message);
        });
    }

    if (role === "institution") {
      if (mainTag === "ETH") {
        try {
          if (postApiRes) {
            if (saleCurrentStaus1) {
              let b = blanceOfEth - parseFloat(inputFeild);
              let x = await purchaseEth1(
                parseFloat(inputFeild1),
                parseFloat(inputFeild),
                postApiRes,
                inputFeild5,
                b
              );
              if (x) {
                confirmInst(x, postApiRes);
                setLoarder(false);
                firstTimeData();
                firstTimeData11();
                firstTimeData1();
                balaceOf();
                alowence();
                // balaceOf1();
                // capHandler()
                handleShow();
              }
            } else {
              toast.error("Sale is Currently Paused");
              setLoarder(false);
            }
          } else {
            setLoarder(false);
          }
        } catch (err) {
          console.log(err, "errr");
          setLoarder(false);
          toast.error("Transaction reverted:" + err.message);
        }
      } else if (mainTag === "USDT") {
        if (sallowance1 === 0) {
          try {
            let z = await approveTpl1(10000000, account);
            if (postApiRes) {
              if (saleCurrentStaus1) {
                if (z) {
                  let q = await purchaseUsdt1(
                    inputFeild,
                    postApiRes,
                    inputFeild5,
                    blanceOfEth,
                    parseFloat(inputFeild1)
                  );
                  if (q) {
                    confirmInst(q, postApiRes);
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            alowence();
            console.log(err, "err");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > sallowance1) {
              if (postApiRes) {
                if (saleCurrentStaus1) {
                  let res = await approveTpl1(0, account);
                  if (res) {
                    let res11 = await approveTpl1(10000000, account);

                    if (res11) {
                      let q = await purchaseUsdt1(
                        inputFeild,
                        postApiRes,
                        inputFeild5,
                        blanceOfEth,
                        parseFloat(inputFeild1)
                      );
                      if (q) {
                        confirmInst(q, postApiRes);
                        setLoarder(false);
                        firstTimeData();
                        firstTimeData11();
                        firstTimeData1();
                        balaceOf();
                        alowence();
                        // balaceOf1();
                        // capHandler()
                        handleShow();
                      }
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus1) {
                  let q = await purchaseUsdt1(
                    inputFeild,
                    postApiRes,
                    inputFeild5,
                    blanceOfEth,
                    parseFloat(inputFeild1)
                  );
                  if (q) {
                    confirmInst(q, postApiRes);
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            alowence();
            console.log(err, "errr");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        }
      } else if (mainTag === "WBTC") {
        if (getAllowanceWbtc1 === 0) {
          try {
            let z = await approveTplwbtc1(10000000, account);
            if (postApiRes) {
              if (saleCurrentStaus1) {
                if (z) {
                  let q = await purchaseWbtc1(
                    inputFeild,
                    postApiRes,
                    inputFeild5,
                    blanceOfEth,
                    parseFloat(inputFeild1)
                  );
                  if (q) {
                    confirmInst(q, postApiRes);
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            alowence();
            console.log(err, "err");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > getAllowanceWbtc1) {
              if (postApiRes) {
                if (saleCurrentStaus1) {
                  let res11 = await approveTplwbtc1(10000000, account);

                  if (res11) {
                    let q = await purchaseWbtc1(
                      inputFeild,
                      postApiRes,
                      inputFeild5,
                      blanceOfEth,
                      parseFloat(inputFeild1)
                    );
                    if (q) {
                      confirmInst(q, postApiRes);
                      setLoarder(false);
                      firstTimeData();
                      firstTimeData11();
                      firstTimeData1();
                      balaceOf();
                      alowence();
                      // capHandler()
                      // balaceOf1();
                      handleShow();
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus1) {
                  let q = await purchaseWbtc1(
                    inputFeild,
                    postApiRes,
                    inputFeild5,
                    blanceOfEth,
                    parseFloat(inputFeild1)
                  );
                  if (q) {
                    confirmInst(q, postApiRes);
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            alowence();
            console.log(err, "errr");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        }
      } else if (mainTag === "USDC") {
        if (getAllowanceUsdc1 === 0) {
          try {
            let z = await approveTplUsdc1(10000000, account);
            if (postApiRes) {
              if (saleCurrentStaus1) {
                if (z) {
                  let q = await purchaseUsdc1(
                    inputFeild,
                    postApiRes,
                    inputFeild5,
                    blanceOfEth,
                    parseFloat(inputFeild1)
                  );
                  if (q) {
                    confirmInst(q, postApiRes);
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    handleShow();
                    // capHandler()
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            alowence();
            console.log(err, "err");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > getAllowanceUsdc1) {
              if (postApiRes) {
                if (saleCurrentStaus1) {
                  let res11 = await approveTplUsdc1(10000000, account);

                  if (res11) {
                    let q = await purchaseUsdc1(
                      inputFeild,
                      postApiRes,
                      inputFeild5,
                      blanceOfEth,
                      parseFloat(inputFeild1)
                    );
                    if (q) {
                      confirmInst(q, postApiRes);
                      setLoarder(false);
                      firstTimeData();
                      firstTimeData11();
                      firstTimeData1();
                      balaceOf();
                      alowence();
                      // capHandler()
                      // balaceOf1();
                      handleShow();
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus1) {
                  let q = await purchaseUsdc1(
                    inputFeild,
                    postApiRes,
                    inputFeild5,
                    blanceOfEth,
                    parseFloat(inputFeild1)
                  );
                  if (q) {
                    confirmInst(q, postApiRes);
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    handleShow();
                    // capHandler()
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            alowence();
            console.log(err, "errr");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        }
      } else if (mainTag === "TOMI") {
        if (tomiAllowance1 === 0) {
          try {
            let z = await approveTomi1(10000000, account);
            if (postApiRes) {
              if (saleCurrentStaus1) {
                if (z) {
                  let q = await purchaseTomi1(
                    inputFeild,
                    postApiRes,
                    inputFeild5,
                    blanceOfEth,
                    parseFloat(inputFeild1)
                  );
                  if (q) {
                    confirmInst(q, postApiRes);
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    handleShow();
                    // capHandler()
                  }
                }
              } else {
                toast.error("Sale is Crrently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            alowence();
            console.log(err, "err");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > tomiAllowance1) {
              if (postApiRes) {
                if (saleCurrentStaus1) {
                  let res11 = await approveTomi1(10000000, account);

                  if (res11) {
                    let q = await purchaseTomi1(
                      inputFeild,
                      postApiRes,
                      inputFeild5,
                      blanceOfEth,
                      parseFloat(inputFeild1)
                    );
                    if (q) {
                      confirmInst(q, postApiRes);
                      setLoarder(false);
                      firstTimeData();
                      firstTimeData11();
                      firstTimeData1();
                      balaceOf();
                      alowence();
                      // capHandler()
                      // balaceOf1();
                      handleShow();
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus1) {
                  let q = await purchaseTomi1(
                    inputFeild,
                    postApiRes,
                    inputFeild5,
                    blanceOfEth,
                    parseFloat(inputFeild1)
                  );
                  if (q) {
                    confirmInst(q, postApiRes);
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            alowence();
            console.log(err, "errr");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        }
      } else if (mainTag === "DOP") {
        if (dopAllowance1 === 0) {
          try {
            let z = await approveDop1(10000000, account);
            if (postApiRes) {
              if (saleCurrentStaus1) {
                if (z) {
                  let q = await purchaseDop1(
                    inputFeild,
                    postApiRes,
                    inputFeild5,
                    blanceOfEth,
                    parseFloat(inputFeild1)
                  );
                  if (q) {
                    confirmInst(q, postApiRes);
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    handleShow();
                    // capHandler()
                  }
                }
              } else {
                toast.error("Sale is Crrently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            alowence();
            console.log(err, "err");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > dopAllowance1) {
              if (postApiRes) {
                if (saleCurrentStaus1) {
                  let res11 = await approveDop1(10000000, account);

                  if (res11) {
                    let q = await purchaseDop1(
                      inputFeild,
                      postApiRes,
                      inputFeild5,
                      blanceOfEth,
                      parseFloat(inputFeild1)
                    );
                    if (q) {
                      confirmInst(q, postApiRes);
                      setLoarder(false);
                      firstTimeData();
                      firstTimeData11();
                      firstTimeData1();
                      balaceOf();
                      alowence();
                      // capHandler()
                      // balaceOf1();
                      handleShow();
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus1) {
                  let q = await purchaseDop1(
                    inputFeild,
                    postApiRes,
                    inputFeild5,
                    blanceOfEth,
                    parseFloat(inputFeild1)
                  );
                  if (q) {
                    confirmInst(q, postApiRes);
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            alowence();
            console.log(err, "errr");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        }
      } else {
        if (gemsAllowance1 === 0) {
          try {
            let z = await approveGems1(10000000, account);
            if (postApiRes) {
              if (saleCurrentStaus1) {
                if (z) {
                  let q = await purchaseGems1(
                    inputFeild,
                    postApiRes,
                    inputFeild5,
                    blanceOfEth,
                    parseFloat(inputFeild1)
                  );
                  if (q) {
                    confirmInst(q, postApiRes);
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    handleShow();
                    // capHandler()
                  }
                }
              } else {
                toast.error("Sale is Crrently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            alowence();
            console.log(err, "err");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > gemsAllowance1) {
              if (postApiRes) {
                if (saleCurrentStaus1) {
                  let res11 = await approveGems1(10000000, account);

                  if (res11) {
                    let q = await purchaseGems1(
                      inputFeild,
                      postApiRes,
                      inputFeild5,
                      blanceOfEth,
                      parseFloat(inputFeild1)
                    );
                    if (q) {
                      confirmInst(q, postApiRes);
                      setLoarder(false);
                      firstTimeData();
                      firstTimeData11();
                      firstTimeData1();
                      balaceOf();
                      alowence();
                      // capHandler()
                      // balaceOf1();
                      handleShow();
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus1) {
                  let q = await purchaseGems1(
                    inputFeild,
                    postApiRes,
                    inputFeild5,
                    blanceOfEth,
                    parseFloat(inputFeild1)
                  );
                  if (q) {
                    confirmInst(q, postApiRes);
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            alowence();
            console.log(err, "errr");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        }
      }
    } else {
      if (mainTag === "ETH") {
        try {
          if (postApiRes) {
            if (saleCurrentStaus) {
              let b = blanceOfEth - parseFloat(inputFeild);
              // console.log(b,'balance',gasPrice/10**9);
              let x = await purchaseEth(
                parseFloat(inputFeild1),
                parseFloat(inputFeild),
                postApiRes,
                currentRoundd,
                b,
                stakeIndex,
                checkBoxx,
                insurancePer
              );
              if (x) {
                if (checkBoxx) {
                  confirmBuy12(x, postApiRes);
                } else {
                  confirmBuy(x, postApiRes);
                }

                setLoarder(false);
                firstTimeData();
                firstTimeData11();
                firstTimeData1();
                balaceOf();
                alowence();
                // capHandler()
                // balaceOf1();
                handleShow();
              }
            } else {
              toast.error("Sale is Currently Paused");
              setLoarder(false);
            }
          } else {
            setLoarder(false);
          }
        } catch (err) {
          console.log(err.message, "errr");
          setLoarder(false);
          toast.error("Transaction reverted:" + err.message);
        }
      } else if (mainTag === "USDT") {
        if (sallowance === 0) {
          try {
            if (postApiRes) {
              if (saleCurrentStaus) {
                let z = await approveTpl(10000000, account);
                if (z) {
                  let q = await purchaseUsdt(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            console.log(err, "err");
            alowence();
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > sallowance) {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let res = await approveTpl(0, account);
                  if (res) {
                    let res11 = await approveTpl(10000000, account);

                    if (res11) {
                      let q = await purchaseUsdt(
                        inputFeild,
                        postApiRes,
                        currentRoundd,
                        blanceOfEth,
                        parseFloat(inputFeild1),
                        stakeIndex,
                        insurancePer
                      );
                      if (q) {
                        if (checkBoxx) {
                          confirmBuy12(q, postApiRes);
                        } else {
                          confirmBuy(q, postApiRes);
                        }
                        setLoarder(false);
                        firstTimeData();
                        firstTimeData11();
                        firstTimeData1();
                        balaceOf();
                        alowence();
                        // capHandler()
                        // balaceOf1();
                        handleShow();
                      }
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let q = await purchaseUsdt(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            console.log(err, "errr");
            setLoarder(false);
            alowence();
            toast.error("Transaction reverted:" + err.message);
          }
        }
      } else if (mainTag === "USDC") {
        console.log(getAllowanceUsdc, "sallowance");
        if (getAllowanceUsdc === 0) {
          try {
            if (postApiRes) {
              if (saleCurrentStaus) {
                let z = await approveTplUsdc(10000000, account);
                if (z) {
                  let q = await purchaseUsdc(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    // capHandler()
                    alowence();
                    handleShow();
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            console.log(err, "err");
            alowence();
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > getAllowanceUsdc) {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let res11 = await approveTplUsdc(10000000, account);

                  if (res11) {
                    let q = await purchaseUsdc(
                      inputFeild,
                      postApiRes,
                      currentRoundd,
                      blanceOfEth,
                      parseFloat(inputFeild1),
                      stakeIndex,
                      checkBoxx,
                      insurancePer
                    );
                    if (q) {
                      if (checkBoxx) {
                        confirmBuy12(q, postApiRes);
                      } else {
                        confirmBuy(q, postApiRes);
                      }
                      setLoarder(false);
                      firstTimeData();
                      firstTimeData11();
                      firstTimeData1();
                      balaceOf();
                      alowence();
                      // capHandler()
                      // balaceOf1();
                      handleShow();
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let q = await purchaseUsdc(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            console.log(err, "errr");
            setLoarder(false);
            alowence();
            toast.error("Transaction reverted:" + err.message);
          }
        }
      } else if (mainTag === "WBTC") {
        if (getAllowanceWbtc === 0) {
          try {
            if (postApiRes) {
              if (saleCurrentStaus) {
                console.log(getAllowanceWbtc, mainTag, "sallowance");
                let z = await approveTplwbtc(1000000, account);
                if (z) {
                  let q = await purchaseWbtc(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    // capHandler()
                    alowence();
                    handleShow();
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            console.log(err, "err");
            alowence();
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > getAllowanceWbtc) {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let res11 = await approveTplwbtc(1000000, account);

                  if (res11) {
                    let q = await purchaseWbtc(
                      inputFeild,
                      postApiRes,
                      currentRoundd,
                      blanceOfEth,
                      parseFloat(inputFeild1),
                      stakeIndex,
                      checkBoxx,
                      insurancePer
                    );
                    if (q) {
                      if (checkBoxx) {
                        confirmBuy12(q, postApiRes);
                      } else {
                        confirmBuy(q, postApiRes);
                      }
                      setLoarder(false);
                      firstTimeData();
                      firstTimeData11();
                      firstTimeData1();
                      balaceOf();
                      alowence();
                      // capHandler()
                      // balaceOf1();
                      handleShow();
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let q = await purchaseWbtc(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            console.log(err, "errr");
            setLoarder(false);
            alowence();
            toast.error("Transaction reverted:" + err.message);
          }
        }
      } else if (mainTag === "LINK") {
        console.log(mainTag, linkAllowance, "sdsdsds");
        if (linkAllowance === 0) {
          try {
            let z = await approveLink(10000000, account);
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (z) {
                  let q = await purchaseLink(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            alowence();
            console.log(err, "err");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > linkAllowance) {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let res11 = await approveLink(10000000, account);

                  if (res11) {
                    let q = await purchaseLink(
                      inputFeild,
                      postApiRes,
                      currentRoundd,
                      blanceOfEth,
                      parseFloat(inputFeild1),
                      stakeIndex,
                      checkBoxx,
                      insurancePer
                    );
                    if (q) {
                      if (checkBoxx) {
                        confirmBuy12(q, postApiRes);
                      } else {
                        confirmBuy(q, postApiRes);
                      }
                      setLoarder(false);
                      firstTimeData();
                      firstTimeData11();
                      firstTimeData1();
                      balaceOf();
                      alowence();
                      // capHandler()
                      // balaceOf1();
                      handleShow();
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let q = await purchaseLink(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            alowence();
            console.log(err, "errr");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        }
      } else if (mainTag === "PEPE") {
        if (pepeAllowance === 0) {
          try {
            let z = await approvePepe(1000000000000000, account);
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (z) {
                  let q = await purchasePepe(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            alowence();
            console.log(err, "err");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > pepeAllowance) {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let res11 = await approvePepe(10000000000000000, account);

                  if (res11) {
                    let q = await purchasePepe(
                      inputFeild,
                      postApiRes,
                      currentRoundd,
                      blanceOfEth,
                      parseFloat(inputFeild1),
                      stakeIndex,
                      checkBoxx,
                      insurancePer
                    );
                    if (q) {
                      if (checkBoxx) {
                        confirmBuy12(q, postApiRes);
                      } else {
                        confirmBuy(q, postApiRes);
                      }
                      setLoarder(false);
                      firstTimeData();
                      firstTimeData11();
                      firstTimeData1();
                      balaceOf();
                      alowence();
                      // capHandler()
                      // balaceOf1();
                      handleShow();
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let q = await purchasePepe(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            alowence();
            console.log(err, "errr");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        }
      } else if (mainTag === "DOP") {
        if (dopAllowance === 0) {
          try {
            let z = await approveDop(1000000000000000, account);
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (z) {
                  let q = await purchaseDop(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            alowence();
            console.log(err, "err");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > dopAllowance) {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let res11 = await approveDop(10000000000000000, account);

                  if (res11) {
                    let q = await purchaseDop(
                      inputFeild,
                      postApiRes,
                      currentRoundd,
                      blanceOfEth,
                      parseFloat(inputFeild1),
                      stakeIndex,
                      checkBoxx,
                      insurancePer
                    );
                    if (q) {
                      if (checkBoxx) {
                        confirmBuy12(q, postApiRes);
                      } else {
                        confirmBuy(q, postApiRes);
                      }
                      setLoarder(false);
                      firstTimeData();
                      firstTimeData11();
                      firstTimeData1();
                      balaceOf();
                      alowence();
                      // capHandler()
                      // balaceOf1();
                      handleShow();
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let q = await purchaseDop(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            alowence();
            console.log(err, "errr");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        }
      } else if (mainTag === "UNI") {
        if (uniAllowance === 0) {
          try {
            let z = await approveUnisawape(10000000, account);
            if (postApiRes) {
              if (saleCurrentStaus) {
                if (z) {
                  let q = await purchaseUniswape(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            alowence();
            console.log(err, "err");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > uniAllowance) {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let res11 = await approveUnisawape(10000000, account);

                  if (res11) {
                    let q = await purchaseUniswape(
                      inputFeild,
                      postApiRes,
                      currentRoundd,
                      blanceOfEth,
                      parseFloat(inputFeild1),
                      stakeIndex,
                      checkBoxx,
                      insurancePer
                    );
                    if (q) {
                      if (checkBoxx) {
                        confirmBuy12(q, postApiRes);
                      } else {
                        confirmBuy(q, postApiRes);
                      }
                      setLoarder(false);
                      firstTimeData();
                      firstTimeData11();
                      firstTimeData1();
                      balaceOf();
                      alowence();
                      // capHandler()
                      // balaceOf1();
                      handleShow();
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let q = await purchaseUniswape(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            alowence();
            console.log(err, "errr");
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        }
      } else if (mainTag === "TOMI") {
        if (tomiAllowance === 0) {
          try {
            if (postApiRes) {
              if (saleCurrentStaus) {
                let z = await approveTomi(10000000, account);
                if (z) {
                  let q = await purchaseTomi(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    // capHandler()
                    alowence();
                    handleShow();
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            console.log(err, "err");
            alowence();
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > tomiAllowance) {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let res11 = await approveTomi(10000000, account);

                  if (res11) {
                    let q = await purchaseTomi(
                      inputFeild,
                      postApiRes,
                      currentRoundd,
                      blanceOfEth,
                      parseFloat(inputFeild1),
                      stakeIndex,
                      checkBoxx,
                      insurancePer
                    );
                    if (q) {
                      if (checkBoxx) {
                        confirmBuy12(q, postApiRes);
                      } else {
                        confirmBuy(q, postApiRes);
                      }
                      setLoarder(false);
                      firstTimeData();
                      firstTimeData11();
                      firstTimeData1();
                      balaceOf();
                      alowence();
                      // capHandler()
                      // balaceOf1();
                      handleShow();
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let q = await purchaseTomi(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            console.log(err, "errr");
            setLoarder(false);
            alowence();
            toast.error("Transaction reverted:" + err.message);
          }
        }
      } else {
        if (gemsAllowance === 0) {
          try {
            if (postApiRes) {
              if (saleCurrentStaus) {
                let z = await approveGems(10000000, account);
                if (z) {
                  let q = await purchaseGems(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    // capHandler()
                    alowence();
                    handleShow();
                  }
                }
              } else {
                toast.error("Sale is Currently Paused");
                setLoarder(false);
              }
            } else {
              setLoarder(false);
            }
          } catch (err) {
            console.log(err, "err");
            alowence();
            setLoarder(false);
            toast.error("Transaction reverted:" + err.message);
          }
        } else {
          try {
            if (inputFeild > gemsAllowance) {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let res11 = await approveGems(10000000, account);

                  if (res11) {
                    let q = await purchaseGems(
                      inputFeild,
                      postApiRes,
                      currentRoundd,
                      blanceOfEth,
                      parseFloat(inputFeild1),
                      stakeIndex,
                      checkBoxx,
                      insurancePer
                    );
                    if (q) {
                      if (checkBoxx) {
                        confirmBuy12(q, postApiRes);
                      } else {
                        confirmBuy(q, postApiRes);
                      }
                      setLoarder(false);
                      firstTimeData();
                      firstTimeData11();
                      firstTimeData1();
                      balaceOf();
                      alowence();
                      // capHandler()
                      // balaceOf1();
                      handleShow();
                    }
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            } else {
              if (postApiRes) {
                if (saleCurrentStaus) {
                  let q = await purchaseGems(
                    inputFeild,
                    postApiRes,
                    currentRoundd,
                    blanceOfEth,
                    parseFloat(inputFeild1),
                    stakeIndex,
                    checkBoxx,
                    insurancePer
                  );
                  if (q) {
                    if (checkBoxx) {
                      confirmBuy12(q, postApiRes);
                    } else {
                      confirmBuy(q, postApiRes);
                    }
                    setLoarder(false);
                    firstTimeData();
                    firstTimeData11();
                    firstTimeData1();
                    balaceOf();
                    alowence();
                    // capHandler()
                    handleShow();
                  }
                } else {
                  toast.error("Sale is Currently Paused");
                  setLoarder(false);
                }
              } else {
                setLoarder(false);
              }
            }
          } catch (err) {
            console.log(err, "errr");
            setLoarder(false);
            alowence();
            toast.error("Transaction reverted:" + err.message);
          }
        }
      }
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      let now = "";
      let time = "";
      let diff = "";
      if (currentTime < new Date(parseInt(currentRount?.startTime))) {
        now = new Date();
        time = new Date(parseInt(currentRount?.startTime));
        diff = time.getTime() - parseInt(now.getTime() / 1000);
        setTimeshow(false);
      } else if (
        currentTime > new Date(parseInt(currentRount?.startTime)) &&
        currentTime < new Date(parseInt(currentRount?.endTime))
      ) {
        now = new Date();
        time = new Date(parseInt(currentRount?.endTime));
        diff = time.getTime() - parseInt(now.getTime() / 1000);
        setTimeshow(false);
        // console.log(diff);
      }
      if (diff <= 0) {
        if (currentTime < new Date(parseInt(currentRount?.startTime))) {
          window.location.reload();
        }
        clearInterval(interval);
        setTimeshow(true);
        // setPrice(0)
        // setId(null)
        // setRound(null)
      }
      const days = Math.floor(diff / (60 * 60 * 24));
      const hours = Math.floor((diff % (60 * 60 * 24)) / (60 * 60));
      const mins = Math.floor((diff % (60 * 60)) / 60);
      const secs = Math.floor(diff % 60);
      setDay(days);
      setHour(hours);
      setMin(mins);
      setSec(secs);

      const currentTime11 = new Date();
      if (currentTime11 > new Date(startTime11)) {
        history.push("/");
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [currentRount]);

  const userLogin1 = async (e) => {
    // setLoarder(true);
    discoundedPriceee(e, Environment?.eth);
    let b = tab === "home" ? "sale-rounds/users" : "sale-rounds/users-nft";
    await axios
      .get(API_URL + b)
      .then(async (res) => {
        // setLoarder(false);
        let a = res.data.data;
        // console.log(a, 'aaaa', e);
        a.map((i) => {
          if (e == i?.round && i.privateSale == "RAIN") {
            setNicName(i.nickName);
          }
        });

        setTimeout(() => {
          // console.log("Delayed for 1 second.");
          setLoarder1(false);
        }, "1000");
        // calucation(res.data.data)
        // console.log(res.data.data,'res.data.data');
      })
      .catch((err) => {
        console.log(err, "err");
        setLoarder1(false);
        // setLoarder(false);
      });
  };
  const calucation = (e, pppp) => {
    let dummy = [];
    let a = "";
    let indexx = "";
    let aaa = e.map((i, index) => {
      let tempLockedLending2 = "";
      if (
        currentTime > parseInt(i.startTime) &&
        currentTime < parseInt(i.endTime)
      ) {
        a = i;
        indexx = index + 1;
        let deff = currentTime - parseInt(i.startTime);
        tempLockedLending2 = { ...i, diffrence: deff, currentround: index + 1 };
        dummy.push(tempLockedLending2);
      } else {
        let deff = currentTime - parseInt(i.startTime);
        tempLockedLending2 = { ...i, diffrence: deff, currentround: index + 1 };
        dummy.push(tempLockedLending2);
      }
    });
    if (a) {
      setPrice(a?.price / 10 ** 18);
      let b = a?.price / 10 ** 18;
      let disprice = indexx == 1 ? 0.2 : 0.07;
      setMultiplyPercentNumbere(indexx == 1 ? 0.2 : 0.07);
      let c = b * disprice;
      let v = b - c;
      setDiscountedPriceee(v);
      setCopyOfPrice(a?.price / 10 ** 18);
      setCurrentRount(a);
      setCurrentRoundd(indexx);
      localStorage.setItem("currentRunningRound", indexx);
      userLogin1(indexx + 2);
      // setPrice(value?.price/10**18)
    } else if (dummy?.length > 0) {
      dummy.sort((a, b) => {
        return a?.diffrence - b?.diffrence;
      });
      console.log(dummy, "dummydummy");
      setCurrentRount(dummy[0]);
      setCurrentRoundd(dummy[0]?.currentround);
      localStorage.setItem("currentRunningRound", dummy[0]?.currentround);
      setPrice(dummy[0]?.price / 10 ** 18);
      let b = dummy[0]?.price / 10 ** 18;
      let disprice = dummy[0]?.currentround == 1 ? 0.2 : 0.07;
      let c = b * disprice;
      let v = b - c;
      setMultiplyPercentNumbere(dummy[0]?.currentround == 1 ? 0.2 : 0.07);
      setDiscountedPriceee(v);
      setCopyOfPrice(dummy[0]?.price / 10 ** 18);
      userLogin1(dummy[0]?.currentround + 2);
      // console.log(dummy,'dummy');
    }
    // console.log(dummy,'new dateee',a);
    if (role === "institution") {
      setPrice(instiPrice);
    }
  };
  useEffect(() => {
    // console.log('usefffef',email,code);
    if (!code) {
      history.push("/");
    }
  }, [startTime11]);
  useEffect(() => {
    //  console.log(chainId,'chainIdchainId');
    if (account) {
      if (chainId != 1) {
        setupNetwork();
      }
    }
  }, [account, chainId]);

  const roundData = async (e, pppp) => {
    // console.log(e, 'ccccccc');
    try {
      if (parseInt(e) <= 1) {
        // console.log("in if noor ", e);
        let c = "";
        if (tab === "home") {
          // console.log(e,'noooor');
          c = await timer(e);
          // console.log(c,'in timer');
        } else {
          c = await timerNft(e);
        }

        if (c) {
          setCurrentRount(c);
          setPrice(c?.price / 10 ** 18);
          let b = c?.price / 10 ** 18;
          let discount = e == 1 ? 0.2 : 0.07;
          setMultiplyPercentNumbere(e == 1 ? 0.2 : 0.07);
          let cc = b * discount;
          let v = b - cc;
          setDiscountedPriceee(v);
          // console.log(e, multiplyPercentNumbere, v, 'ccccccc');
          setCopyOfPrice(c?.price / 10 ** 18);
          setCurrentRoundd(e);
          localStorage.setItem("currentRunningRound", e);
          userLogin1(e);
          setTimeout(() => {
            // console.log("Delayed for 1 second.");
            setLoarder1(false);
          }, "1000");

          // setPrice(c.price/10**18)
          // console.log('nooor',c.price);
          // setCurrentTimer(c)
        }
      } else {
        let dummy = [];
        // console.log(e, 'loooop bahis');
        for (let a = 1; a <= e; a++) {
          // console.log(a, 'loooop');
          let c = "";
          if (tab === "home") {
            c = await timer(a);
            // console.log("noor if  ", c);
          } else {
            // console.log('noor else  ',c);
            c = await timerNft(a);
          }
          dummy.push(c);
        }
        // console.log(dummy, 'loooop');
        calucation(dummy, pppp);
      }
    } catch (err) {
      console.log(err, "erro in timer");
      setLoarder1(false);
    }
  };

  const inputField1Handler5 = async (e) => {
    var length = e.target.value.split(" ").join("").length;
    setInputField5(e.target.value);
    setCheck(false);
    if (length === 42) {
      let r = web3.utils.isAddress(e.target.value);
      if (r) {
        setCheck(true);
      } else {
        setCheck(false);
      }
    }
  };

  const confirmInst = async (data, api) => {
    // console.log(data, api, inputFeild5, price, inputFeild1, inputFeild, mainTag, 'noooooor');
    const config = {
      method: "post",
      url: `${API_URL}emails`,
      data: {
        accessCode: code,
        transactionHash: data?.transactionHash,
        accessCodeRole: role,
        by: account,
        dopPurchased: inputFeild1,
        buyingAmount: parseFloat(inputFeild),
        recipientEmail: email,
        tokenSelected: mainTag,
        country: countryBuyer,
        ipAddress: ipBuyer,
        price: price,
        privateSale: "RAIN",
        isInsured: false,
        recipient: inputFeild5,
      },
    };
    const postApiRes = await axios(config)
      .then(function (response) {
        // return response?.data?.data;
      })
      .catch(function (error) {
        // toast.error(error?.response?.data.message);
      });
  };
  const confirmBuy12 = async (dataaa, api) => {
    // console.log(data, api, inputFeild5, price, inputFeild1, inputFeild, mainTag, 'noooooor');
    let nereValue =
      parseFloat(inputFeild1) + parseInt(ethValueCalcualte?.toFixed(2));
    const config = {
      method: "post",
      url: `${API_URL}emails`,
      data: {
        accessCode: code,
        transactionHash: dataaa?.transactionHash,
        accessCodeRole: role,
        by: account,
        dopPurchased:
          (stakedAmount >= 5555 && stakingData?.length > 0) ||
          moment().isBefore(stakeEndTime1)
            ? nereValue
            : inputFeild1,
        buyingAmount: parseFloat(inputFeild),
        recipientEmail: email,
        tokenSelected: mainTag,
        country: countryBuyer,
        ipAddress: ipBuyer,
        price:
          (stakedAmount >= 5555 && stakingData?.length > 0) ||
          moment().isBefore(stakeEndTime1)
            ? discountedPriceee?.toFixed(4)
            : price,
        privateSale: "RAIN",
        recipient: account,
        isInsured: true,
        buyingAmountUsd: amountInUsdt?.toFixed(4),
        insuranceFee: parseFloat(inputFeild * insurancePer)?.toFixed(4),
        insuranceFeeUsd: parseFloat(amountInUsdt * insurancePer)?.toFixed(4),
        totalBuyingAmount: parseFloat(
          parseFloat(inputFeild) + parseFloat(inputFeild * insurancePer)
        )?.toFixed(4),
        totalBuyingAmountUsd: parseFloat(
          parseFloat(amountInUsdt) + parseFloat(amountInUsdt * insurancePer)
        )?.toFixed(4),
      },
    };

    const postApiRes = await axios(config)
      .then(function (response) {
        // return response?.data?.data;
      })
      .catch(function (error) {
        // toast.error(error?.response?.data.message);
      });
  };
  const confirmBuy = async (dataaa, api) => {
    // console.log(data, api, inputFeild5, price, inputFeild1, inputFeild, mainTag, 'noooooor');
    let nereValue =
      parseFloat(inputFeild1) + parseInt(ethValueCalcualte?.toFixed(2));
    const config = {
      method: "post",
      url: `${API_URL}emails`,
      data: {
        accessCode: code,
        transactionHash: dataaa?.transactionHash,
        accessCodeRole: role,
        by: account,
        recipient: account,
        dopPurchased:
          (stakedAmount >= 5555 && stakingData?.length) ||
          moment().isBefore(stakeEndTime1)
            ? nereValue
            : inputFeild1,
        buyingAmount: parseFloat(inputFeild),
        recipientEmail: email,
        tokenSelected: mainTag,
        country: countryBuyer,
        ipAddress: ipBuyer,
        price:
          (stakedAmount >= 5555 && stakingData?.length) ||
          moment().isBefore(stakeEndTime1)
            ? discountedPriceee?.toFixed(4)
            : price,
        privateSale: "RAIN",
        isInsured: false,
        buyingAmountUsd: parseFloat(amountInUsdt)?.toFixed(4),
      },
    };
    const postApiRes = await axios(config)
      .then(function (response) {
        // return response?.data?.data;
      })
      .catch(function (error) {
        // toast.error(error?.response?.data.message);
      });
  };
  const confirmBuyBefore = async (dataaa, api) => {
    // console.log(data, api, inputFeild5, price, inputFeild1, inputFeild, mainTag, 'noooooor');
    let nereValue =
      parseFloat(inputFeild1) + parseInt(ethValueCalcualte?.toFixed(2));
    const config = {
      method: "post",
      url: `${API_URL}emails/temp`,
      data: {
        accessCode: code,
        accessCodeRole: role,
        by: account,
        recipient: account,
        dopPurchased:
          (stakedAmount >= 5555 && stakingData?.length) ||
          moment().isBefore(stakeEndTime1)
            ? nereValue
            : inputFeild1,
        buyingAmount: parseFloat(inputFeild),
        recipientEmail: email,
        tokenSelected: mainTag,
        country: countryBuyer,
        ipAddress: ipBuyer,
        price:
          (stakedAmount >= 5555 && stakingData?.length) ||
          moment().isBefore(stakeEndTime1)
            ? discountedPriceee?.toFixed(4)
            : price,
        privateSale: "RAIN",
        isInsured: false,
        buyingAmountUsd: parseFloat(amountInUsdt)?.toFixed(4),
      },
    };
    const postApiRes = await axios(config)
      .then(function (response) {
        // return response?.data?.data;
      })
      .catch(function (error) {
        // toast.error(error?.response?.data.message);
      });
  };

  const tabHandler = (e) => {
    discoundedPriceee(currentRoundd, Environment.eth);
    setMainTag("ETH");
    setTagImge("/assets/eth-icon.svg");
    if (tab == "home") {
      setTab("profile");
    } else {
      setTab("home");
    }
  };
  // console.log(price,'buy price');
  const discoundedPriceee = async (aa, e) => {
    // console.log(a,e,'a,e');
    try {
      let ab = await discountedPrice(aa, e);
      // console.log('buy',ab,copyOfPrice);
      if (role != "institution") {
        if (ab > 0) {
          // console.log('if chala');
          setPrice(ab);
          let b = ab;
          let c = b * multiplyPercentNumbere;
          let v = b - c;
          setDiscountedPriceee(v);
          setPercet(100 * ((copyOfPrice - ab) / copyOfPrice));
          console.log(ab, e, "callll ho raHA ");
          setPriceCheck(true);
        } else {
          if (copyOfPrice) {
            setPriceCheck(false);
            setPrice(copyOfPrice);
            let b = copyOfPrice;
            let c = b * multiplyPercentNumbere;
            let v = b - c;
            setDiscountedPriceee(v);
          }
        }
      } else {
        setPrice(instiPrice);
      }
    } catch (err) {
      console.log(err, "discoundedPrice err");
    }
  };

  const witterHandler = () => {
    const weChatShareUrl = "https://x.com/Gems_VIP_";

    // Open the WeChat share link in a new window
    window.open(weChatShareUrl, "_blank");
    window.location.reload();
  };

  const [showTooltip, setShowTooltip] = useState(false);

  const handleMouseEnter = () => {
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  const handleTooltipMouseEnter = () => {
    setShowTooltip(true);
  };

  const handleTooltipMouseLeave = () => {
    setShowTooltip(false);
  };

  // useEffect(() => {
  //   setInterval(() => {
  //     fetchStakingData()
  //   }, 30000);
  // }, [])
  // const apiCheck = async (e) => {

  //   const data = {
  //     accessCode: code,
  //   };
  //   await axios
  //     .post(API_URL + "users/verify-code", data)
  //     .then(async (res) => {
  //       setLimitObj(res.data.data.limit)
  //       let a = parseInt(res.data.data.limit.buyingLimit)
  //       let b = parseInt(res.data.data.limit.saleCount)
  //       let c = (b / a) * 100
  //       const clampedValue = Math.min(100, Math.max(0, c));
  //       setGaugePosition(`${clampedValue}%`)
  //       setLimitObjperc(c)
  //       let dd = JSON.stringify(res.data.data.limit)
  //       localStorage?.setItem("oobjj", dd);
  //     })
  //     .catch((err) => {
  //       console.log(err, "err");

  //     });
  // }

  const fetchStakingData = async () => {
    // setLoarder1(true);
    var data = JSON.stringify({
      query: `query MyQuery {
        stakeds(where: {isClaimed: false, staker: "${account}"}) {
          stakerStakeIndex
          transactionHash
          stakeEndTime
          staker
          isClaimed
          id
          blockTimestamp
          blockNumber
          amount
        }
      }`,
      variables: {},
    });
    var config = {
      method: "post",
      url: Environment.gemsLockingGraph,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    await axios(config)
      .then(async function (response) {
        console.log(response, "response");

        const resData = response?.data?.data?.stakeds;
        if (resData?.length > 0) {
          let a = resData.map((e) => {
            return e.stakerStakeIndex;
          });
          // console.log(a, 'mainn1');
          let bcc = a?.sort();
          setStakeIndux(bcc);
          setStakingData(resData);
          const currentTime = moment();
          const endTimeStampInSeconds = parseInt(
            resData[resData?.length - 1]?.stakeEndTime
          );
          const endTimeStamp = moment(endTimeStampInSeconds * 1000); // Convert to milliseconds
          if (!endTimeStamp.isValid()) {
            setStakeEndTime(currentTime);
          } else {
            setStakeEndTime(endTimeStamp);
          }
          // setLoarder1(false)
        }
      })
      .catch(function (error) {
        // setLoarder1(false);
        console.log(error, "error onse?.data?.data?.investments ma");
      });
  };
  const fetchStakingData1 = async (useV2 = false) => {
    // setLoarder1(true);
    var data = JSON.stringify({
      query: `query MyQuery {
  subscribeds(where: {by: "${account}"}, orderBy: blockTimestamp, orderDirection: desc) {
      blockTimestamp
      blockNumber
      amountPurchased
      by
      endTime
      id
      tokenPrice
      transactionHash
    }
  }`,
      variables: {},
    });

    var config = {
      method: "post",
      url: useV2
        ? Environment.gemSubscriptionMultiple
        : Environment.gemsSubscribeGrap,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    await axios(config)
      .then(async function (response) {
        const resData = response?.data?.data?.subscribeds;
        // console.log("43353453454", resData);
        if ((!resData || resData.length === 0) && !useV2) {
          return fetchStakingData1(true);
        }
        if (resData?.length > 0) {
          let a = resData.map((e) => {
            return e.stakerStakeIndex;
          });
          let bcc = a?.sort();
          // setStakeIndux(bcc);
          setStakingData1(resData[0]);

          const currentTime = moment();
          const endTimeStampInSeconds = parseInt(resData[0]?.endTime);
          const endTimeStamp = moment(endTimeStampInSeconds * 1000); // Convert to milliseconds

          if (!endTimeStamp.isValid() || currentTime.isAfter(endTimeStamp)) {
            if (!useV2) {
              // Try again with gemSubscriptionMultiple
              return fetchStakingData1(true);
            } else {
              setStakeEndTime1(currentTime);
            }
          } else {
            setStakeEndTime1(endTimeStamp);
          }
          // setLoarder1(false)
        }
        // setLoarder1(false);
      })
      .catch(function (error) {
        // setLoarder1(false);
        console.log(error, "error onse?.data?.data?.investments ma");
      });
  };

  //   const StakeIndec=async()=>{
  //     const bal = await getGemsStakedIndex(account);
  //     console.log(bal, 'bal');
  //     if (bal !== null || bal !== undefined) {
  //       if(bal==0){
  //         setStakeIndux([])
  //       }else{
  //         setStakeIndux([parseInt(bal)-1])
  //       }

  //     }
  //  }

  const getGemsStakedAmount = async () => {
    const staked = await getGemsStaked(account);

    if (staked) {
      setStakedAmount(staked);
    }
  };

  // const inputField1Handler6 = (e) => {
  //   if (e.target.checked == true) {
  //     setCheked3(true);
  //   } else {
  //     setCheked3(false);
  //   }
  // };

  // const inputField1Handler7 = (e) => {
  //   if (e.target.checked == true) {
  //     setCheked4(true);
  //   } else {
  //     setCheked4(false);
  //   }
  // };

  useEffect(() => {
    let countdown;
    if (timer12 > 0) {
      countdown = setTimeout(() => {
        setTimer12((prev) => prev - 1);
      }, 1000);
    } else if (timer12 === 0 && isResendDisabled) {
      setIsResendDisabled(false);
    }
    return () => clearTimeout(countdown);
  }, [timer12, isResendDisabled]);

  const handleSendCode = async (e) => {
    e.preventDefault();
    if (isResendDisabled) return;

    try {
      const response = await requestWithState({
        url: `emails/verify-email`,
        method: "POST",
        data: {
          email: inputFeild7,
          by: account.toLowerCase(),
          country: countryBuyer,
        },
      });

      console.log(response);
      if (response?.statusCode === 200) {
        console.log("Email already verified.");
        setShowOtpInput(false);
        handleCloseVerify(true);
      } else if (response?.statusCode === 201) {
        console.log("Verification email sent.");
        toast.success("Verification email sent.");
        setShowOtpInput(true);

        // Start cooldown
        setIsResendDisabled(true);
        setTimer12(10);
      } else if (response?.statusCode === 409) {
        toast.error("Email already exists");
      }
    } catch (error) {
      // toast.error(error.message)
      console.error("Failed to send verification email:", error);
    }
  };

  const handleVerifyOtp = async () => {
    try {
      const response = await requestWithState({
        url: `emails/verify-otp`,
        method: "POST",
        data: {
          email: inputFeild7,
          by: account.toLowerCase(),
          otp,
        },
      });

      if (response?.statusCode === 201) {
        setVerified(true);
        console.log("Email verified successfully");
        setIsOtpValid(true);
        handleCloseVerify(true);
        setEmail(inputFeild7);
        setEmailModelCheck(true);
        handleClose2();
      } else {
        setIsOtpValid(false);
      }
    } catch (error) {
      console.error("OTP verification failed:", error);
      setIsOtpValid(false);
    }
  };

  const handleShowVerify = () => {
    setShowVerify(true);
  };
  const handleCloseVerify = () => {
    // if(!verified){
    if (verified) {
      handleShow5();
    }
    setShowVerify(false);
    // }
  };

  const inputField1Handler2 = (e) => {
    if (e.target.checked == true) {
      setCheked(true);
    } else {
      setCheked(false);
      setCheked1(false);
    }
  };

  const checkVerification = async () => {
    try {
      const response = await requestWithState({
        url: `emails/wallet-details`,
        method: "POST",
        data: {
          country: countryBuyer,
          by: account.toLowerCase(),
        },
      });

      console.log(response, "Verification Response");
      if (response?.deta?.isVerified) {
        setVerified(true);
        console.log("Verified fetched successfully:", response?.deta);
        setEmail(inputFeild8);
        handleClose();
        // setEmail(response?.deta?.email)
      } else {
        setVerified(false);
        console.log("User is not verfied");
      }
    } catch (error) {
      setVerified(false);
      console.error("Error checking premium:", error);
    }
  };

  const inputField1Handler4 = (e) => {
    if (e.target.checked == true) {
      setCheked2(true);
    } else {
      setCheked2(false);
    }
  };
  const inputField1Handler3 = (e) => {
    if (e.target.checked == true) {
      setCheked1(true);
    } else {
      setCheked1(false);
    }
  };

  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }

  const inputField1Handler7 = (e) => {
    let value = e.target.value;

    if (!isValidEmail(value)) {
      setInputField7(value);
      setCheckedNew1(false);
    } else {
      setInputField7(value);
      setCheckedNew1(true);
    }
  };

  const inputField1Handler8 = (e) => {
    let value = e.target.value;
    if (!isValidEmail(value)) {
      setInputFeild8(value);
    } else {
      setInputFeild8(value);
    }
  };

  const checkVerificationBefore = async (a) => {
    try {
      const response = await requestWithState({
        url: `emails/wallet-details`,
        method: "POST",
        data: {
          country: countryBuyer,
          by: a.toLowerCase(),
        },
      });

      console.log(response.deta.email, "Verification Response");
      if (response.deta.email) {
        setEmail(response.deta.email);
        setEmailModelCheck(true);
      }
    } catch (error) {}
  };
  useEffect(() => {
    if (account) {
      checkVerificationBefore(account);
    }
  }, [account]);

  return (
    <>
      {loaderr1 && <Loader />}
      {loaderr && (
        <Loader text={"Please wait, your transaction is in process"} />
      )}
      <Navbar setShow={setShow} />
      <section className="main-banner">
        <img
          src="/assets/leftshade.png"
          alt="leftshade"
          className="leftshade"
        />
        <img
          src="/assets/rightshade.png"
          alt="rightshade"
          className="rightshade"
        />
        {/* <img
          src="\assets\homepage-bg.png"
          alt="img"
          className="img-fluid banner-bg"
        />
        <img
          src="\assets\mblviewbg.png"
          alt="img"
          className="img-fluid mblviewbanner-bg d-none"
        /> */}
        <div className="container">
          <div className="banner-content">
            <div className="timermain">
              <div className="timerleft">
                <div className="mainiconimg">
                  <img
                    src="\assets\newincentivlogo.svg"
                    alt="iconimginner"
                    className="iconimginner"
                  />
                </div>
                <div className="mainicontexts">
                  <h6 className="timerhead">Rain</h6>
                  {role !== "institution" ? (
                    <>
                      {currentTime <
                      new Date(parseInt(currentRount?.startTime)) ? (
                        <p className="timerpara">Round {niceName} Starts in:</p>
                      ) : (
                        <>
                          {currentTime >
                            new Date(parseInt(currentRount?.startTime)) &&
                          currentTime <
                            new Date(parseInt(currentRount?.endTime)) ? (
                            <p className="timerpara">
                              Round {niceName} Ends in:
                            </p>
                          ) : (
                            ""
                          )}
                        </>
                      )}
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {role !== "institution" ? (
                <>
                  {timeshow ? (
                    <p className="timerended">Sale ended!</p>
                  ) : (
                    <span className="innertimertext">
                      {day ? day : 0}D : {hour ? hour : 0}H : {min ? min : 0}M :{" "}
                      {sec ? sec : 0}S
                    </span>
                  )}
                </>
              ) : (
                ""
              )}
            </div>

            <div className="twice-content">
              <div className="upper-content">
                <div className="left">
                  <img
                    src="\assets\newincentivlogo.svg"
                    alt="img"
                    className="img-fluid tokennnimmgg"
                  />
                  <div className="text">
                    <h6>Rain</h6>
                    <p>$RAIN</p>
                  </div>
                </div>
                <div className="right">
                  {/* <h6>${tomi?.toFixed(2)}</h6>
                {change24hr1 > 0 ? (
                  <p>{change24hr1?.toFixed(2)}% (1d)</p>
                ) : (
                  <p className="red">{change24hr1?.toFixed(2)}% (1d)</p>
                )} */}
                  <>
                    {role === "institution" ? (
                      <h6>
                        ${price ? parseFloat(price)?.toFixed(8) : "0.000"} USD
                      </h6>
                    ) : (
                      <>
                        {priceCheck ||
                        (stakedAmount >= 5555 && stakingData?.length > 0) ||
                        moment().isBefore(stakeEndTime1) ? (
                          <>
                            {(stakedAmount >= 5555 &&
                              stakingData?.length > 0) ||
                            moment().isBefore(stakeEndTime1) ? (
                              <div className="right-text-content">
                                <div className="inner-left">
                                  <h5>Special offer</h5>
                                  <p className="special-para">
                                    You save {currentRoundd == 1 ? "20" : "7"}%
                                    {priceCheck
                                      ? `+ ${parseInt(percent)}%`
                                      : ""}
                                  </p>
                                </div>
                                <div className="inner-right">
                                  <h6>
                                    {" "}
                                    <h6>
                                      $
                                      {discountedPriceee
                                        ? parseFloat(
                                            discountedPriceee
                                          )?.toFixed(8)
                                        : "0.000"}{" "}
                                      USD
                                    </h6>
                                  </h6>
                                  <p>${parseFloat(price).toFixed(8)}</p>
                                </div>
                              </div>
                            ) : (
                              <div className="right-text-content">
                                <div className="inner-left">
                                  <h5>Special offer</h5>
                                  <p className="special-para">
                                    You save {parseInt(percent)}%
                                  </p>
                                </div>
                                <div className="inner-right">
                                  <h6>
                                    {" "}
                                    <h6>
                                      $
                                      {price
                                        ? parseFloat(price)?.toFixed(8)
                                        : "0.000"}{" "}
                                      USD
                                    </h6>
                                  </h6>
                                  <p>${parseFloat(copyOfPrice).toFixed(8)}</p>
                                </div>
                              </div>
                            )}
                          </>
                        ) : (
                          <h6>
                            ${price ? parseFloat(price)?.toFixed(8) : "0.000"}{" "}
                            USD
                          </h6>
                        )}
                      </>
                    )}
                  </>
                </div>
              </div>
              {role !== "institution" ? (
                <div className="discount-offer">
                  <img
                    src="/assets/discontbgnew.png"
                    alt="img"
                    className="img-fluid discont-bg"
                  />
                  <div className="left-sidee">
                    <div className="upper-text">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="26"
                        height="26"
                        viewBox="0 0 26 26"
                        fill="none"
                      >
                        <path
                          d="M20.5833 3.25H5.41666L2.16666 9.75L13 22.75L23.8333 9.75L20.5833 3.25ZM10.4217 8.66667L12.0467 5.41667H13.9533L15.5783 8.66667H10.4217ZM11.9167 10.8333V18.07L5.89332 10.8333H11.9167ZM14.0833 10.8333H20.1067L14.0833 18.07V10.8333ZM20.865 8.66667H17.9942L16.3692 5.41667H19.24L20.865 8.66667ZM6.75999 5.41667H9.63082L8.00582 8.66667H5.13499L6.75999 5.41667Z"
                          fill="#E89735"
                        />
                      </svg>
                      <h6>Gems Premium</h6>
                    </div>
                    {(stakedAmount >= 5555 && stakingData?.length > 0) ||
                    moment().isBefore(stakeEndTime1) ? (
                      <p>
                        Subscribe to Gems Premium and receive upto{" "}
                        {currentRoundd == 1 ? "20" : "7"}% discount{" "}
                      </p>
                    ) : (
                      <p>
                        Subscribe to Gems Premium and receive upto{" "}
                        {currentRoundd == 1 ? "20" : "7"}% discount{" "}
                      </p>
                    )}
                  </div>
                  <div className="right-sidee">
                    {(stakedAmount >= 5555 && stakingData?.length > 0) ||
                    moment().isBefore(stakeEndTime1) ? (
                      <div className="see-plan">
                        <a href="/discount" className="btn-seeplan">
                          see my plan
                        </a>
                        <p>
                          Plan expires on{" "}
                          {moment(stakeEndTime)?.format("DD/MM/YY")}
                        </p>
                      </div>
                    ) : (
                      <a href="/discount" className="btn-discount">
                        Get gems premium
                      </a>
                    )}
                  </div>
                </div>
              ) : (
                ""
              )}
              {/* <div className="availablemain">
                <h6 className="availablehead">Available Credit  <div className="tooltip-div">
                  <OverlayTrigger
                    placement="bottom"
                    overlay={
                      <Tooltip
                        id="smooth-tooltip"
                        onMouseEnter={handleTooltipMouseEnter}
                        onMouseLeave={handleTooltipMouseLeave}
                      >
                        <h5>Available Credit</h5>
                        <p>This indicates the available allocation for purchasing during the presale associated with this leader code.</p>
                      </Tooltip>
                    }
                    show={showTooltip}
                  >
                    <div
                      onMouseEnter={handleMouseEnter}
                      onMouseLeave={handleMouseLeave}
                      style={{ cursor: "pointer" }}
                    >
                      <svg style={{ marginTop: "-5px" }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M7.99967 1.33333C4.32634 1.33333 1.33301 4.32666 1.33301 7.99999C1.33301 11.6733 4.32634 14.6667 7.99967 14.6667C11.673 14.6667 14.6663 11.6733 14.6663 7.99999C14.6663 4.32666 11.673 1.33333 7.99967 1.33333ZM7.49967 5.33333C7.49967 5.05999 7.72634 4.83333 7.99967 4.83333C8.27301 4.83333 8.49967 5.05999 8.49967 5.33333V8.66666C8.49967 8.93999 8.27301 9.16666 7.99967 9.16666C7.72634 9.16666 7.49967 8.93999 7.49967 8.66666V5.33333ZM8.61301 10.92C8.57967 11.0067 8.53301 11.0733 8.47301 11.14C8.40634 11.2 8.33301 11.2467 8.25301 11.28C8.17301 11.3133 8.08634 11.3333 7.99967 11.3333C7.91301 11.3333 7.82634 11.3133 7.74634 11.28C7.66634 11.2467 7.59301 11.2 7.52634 11.14C7.46634 11.0733 7.41967 11.0067 7.38634 10.92C7.35301 10.84 7.33301 10.7533 7.33301 10.6667C7.33301 10.58 7.35301 10.4933 7.38634 10.4133C7.41967 10.3333 7.46634 10.26 7.52634 10.1933C7.59301 10.1333 7.66634 10.0867 7.74634 10.0533C7.90634 9.98666 8.09301 9.98666 8.25301 10.0533C8.33301 10.0867 8.40634 10.1333 8.47301 10.1933C8.53301 10.26 8.57967 10.3333 8.61301 10.4133C8.64634 10.4933 8.66634 10.58 8.66634 10.6667C8.66634 10.7533 8.64634 10.84 8.61301 10.92Z" fill="black" />
                      </svg>
                    </div>
                  </OverlayTrigger>
                </div></h6>
                <p className="availablepara"><span className="greynumber">${parseInt(limitObj?.saleCount)}</span>/${limitObj?.buyingLimit}</p>
                <ProgressBar now={limitObjperc} />
                <div className="Apppppppp">
                  <input
                    type="range"
                    min="0"
                    max="100"
                    value={limitObjperc}
                    className="d-none"
                  />
                  <div className="gauge-container">
                    <div className="gauge">
                      <div className="gauge-indicator" style={{ left: gaugePosition }}></div>
                    </div>
                    <div className="gauge-labels">
                      <span>Low</span>
                      <span>Medium</span>
                      <span>High</span>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
            {role === "institution" ? (
              <div className="bottom-content">
                <h6 className="main-head">Buy</h6>
                <div className="parent-box">
                  <img
                    src="\assets\swap-arrow.svg"
                    alt="img"
                    className="img-fluid swap-arrow"
                  />
                  <div className="inner-box">
                    {" "}
                    <div className="left">
                      <div class="dropdown">
                        <button
                          class="dropdown-toggle"
                          type="button"
                          data-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <div className="flexset">
                            <img
                              src={tagImge}
                              alt="img"
                              className="img-fluid suxvsvsyucsusc"
                            />
                            <div className="text">
                              <h6>{mainTag}</h6>
                            </div>
                          </div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="8"
                            height="5"
                            viewBox="0 0 8 5"
                            fill="none"
                          >
                            <path
                              d="M7.81779 1.29713L5.9829 3.24602L4.86253 4.44207C4.38809 4.94599 3.61641 4.94599 3.14197 4.44207L0.181004 1.29713C-0.207694 0.88428 0.0723969 0.180007 0.615431 0.180007H3.82219H7.38336C7.93211 0.180007 8.20648 0.88428 7.81779 1.29713Z"
                              fill="#02171D"
                            />
                          </svg>
                        </button>
                        <ul class="dropdown-menu">
                          <li>
                            <a
                              class="dropdown-item gscrxcsx"
                              onClick={() => changeTag1("ETH")}
                            >
                              <img
                                src="/assets/eth-icon.svg"
                                alt="img"
                                className="img-fluid"
                              />{" "}
                              ETH
                            </a>
                          </li>
                          <li>
                            <a
                              class="dropdown-item gscrxcsx"
                              onClick={() => changeTag1("USDT")}
                            >
                              <img
                                src="/assets/usdt.svg"
                                alt="img"
                                className="img-fluid"
                              />{" "}
                              USDT
                            </a>
                          </li>
                          <li>
                            <a
                              class="dropdown-item gscrxcsx"
                              onClick={() => changeTag1("DOP")}
                            >
                              <img
                                src="\assets\dop.svg"
                                alt="img"
                                className="img-fluid"
                              />{" "}
                              DOP
                            </a>
                          </li>
                          <li>
                            <a
                              class="dropdown-item gscrxcsx"
                              onClick={() => changeTag1("GEMS")}
                            >
                              <img
                                src="\assets\newgemslogosvg.svg"
                                alt="img"
                                className="img-fluid"
                              />{" "}
                              GEMS
                            </a>
                          </li>

                          {/* <li>
                                <a class="dropdown-item gscrxcsx" onClick={() => changeTag1('TOMI')}>
                                  <img
                                    src="\assets\tomi-icon-drop.svg"
                                    alt="img"
                                    className="img-fluid"
                                  />{" "}
                                  TOMI
                                </a>
                              </li> */}
                          {/* <li>
                          <a class="dropdown-item gscrxcsx" onClick={() => changeTag1('USDC')}>
                            <img
                              src="\assets\usdc.svg"
                              alt="img"
                              className="img-fluid"
                            />{" "}
                            USDC
                          </a>
                        </li> */}
                          {/* <li>
                          <a class="dropdown-item gscrxcsx" onClick={() => changeTag1('WBTC')}>
                            <img
                              src="\assets\wbtc.svg"
                              alt="img"
                              className="img-fluid"
                            />{" "}
                            WBTC
                          </a>
                        </li> */}
                        </ul>
                      </div>
                    </div>
                    <div className="right">
                      <h6>
                        Balance:{" "}
                        <span>
                          {
                            mainTag === "ETH"
                              ? blanceOfEth > 0
                                ? blanceOfEth?.toFixed(4)
                                : "0.000"
                              : mainTag === "USDT"
                              ? balanceeUsdt > 0
                                ? balanceeUsdt?.toFixed(4)
                                : "0.000"
                              : mainTag === "USDC"
                              ? balaceOfUsdc > 0
                                ? balaceOfUsdc?.toFixed(4)
                                : "0.000"
                              : mainTag === "WBTC"
                              ? balaceOfWbtc > 0
                                ? balaceOfWbtc?.toFixed(6)
                                : "0.000"
                              : mainTag === "TOMI"
                              ? balaceOfTmi > 0
                                ? balaceOfTmi?.toFixed(6)
                                : "0.000"
                              : mainTag === "DOP"
                              ? balaceOfDoppp > 0
                                ? balaceOfDoppp?.toFixed(6)
                                : "0.000"
                              : gemsBalance > 0
                              ? gemsBalance?.toFixed(6)
                              : "0.000"

                            // balaceOfTmi > 0
                            //   ? balaceOfTmi
                            //     ?.toFixed(4)
                            //   : "0.000"
                          }{" "}
                          {mainTag === "ETH"
                            ? " ETH "
                            : mainTag === "USDT"
                            ? " USDT "
                            : mainTag === "USDC"
                            ? "USDC"
                            : mainTag === "WBTC"
                            ? "WBTC"
                            : mainTag === "TOMI"
                            ? "TOMI"
                            : mainTag === "DOP"
                            ? "DOP"
                            : "GEMS"}
                        </span>{" "}
                      </h6>
                      {/* balanceeUsdt?.toFixed(2)?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") */}
                      <input
                        onChange={inputField1Handler}
                        value={inputFeild}
                        onWheel={(e) => e.target.blur()}
                        type="number"
                        placeholder="0.00"
                      />
                      {/* <p>0.00</p> */}
                    </div>
                  </div>
                  <div className="inner-box">
                    <div className="leftiii">
                      <img
                        src="\assets\newincentivlogo.svg"
                        alt="img"
                        className="img-fluid"
                        style={{
                          width: "35px",
                          height: "35px",
                          borderRadius: "120px",
                        }}
                      />
                      <div className="text">
                        <h6>Rain</h6>
                        <p className="textpara">$RAIN</p>
                      </div>
                    </div>
                    <div className="right">
                      <h6>
                        {/* Balance:{" "} */}
                        {/* <span style={{ color: "#fff" }}>
          {balacefAccountTomii > 0
            ? balacefAccountTomii
              ?.toFixed(4)
            : "0.000"}
        </span> */}
                      </h6>
                      <input
                        onChange={inputField1Handler1}
                        value={inputFeild1}
                        disabled
                        onWheel={(e) => e.target.blur()}
                        type="number"
                        placeholder="0.00"
                      />
                      {/* <p>0.00</p> */}
                    </div>
                  </div>
                </div>
                {role === "institution" && (
                  <div
                    className="material-textfield"
                    style={{ marginTop: "20px", marginBottom: "25px" }}
                  >
                    <input
                      onChange={inputField1Handler5}
                      value={inputFeild5}
                      onWheel={(e) => e.target.blur()}
                      type="text"
                      placeholder="Enter only ERC20 wallet address"
                    />
                    <label>Enter $RAIN recipient wallet address</label>
                  </div>
                )}
                <div className="bottom-text">
                  {/* <div className="inner-text">
<p>Receive:</p>
<h6>
{inputFeild1
  ? inputFeild1
    ?.toFixed(3)
  : "0.00"}{" "}
TOMI
</h6>
</div>
<div className="inner-text">
<p>+{aaa / 10}% Bonus:</p>
<h6>
{inputFeild1
  ? ((inputFeild1 * (aaa / 10)) / 100)
    ?.toFixed(3)
  : "0.00"}{" "}
TOMI
</h6>
</div> */}
                  <div className="inner-text-bold">
                    <h6>Total:</h6>
                    <h6>
                      {inputFeild1 && inputFeild ? (
                        <>
                          {checkBoxx
                            ? parseFloat(
                                inputFeild1 + inputFeild1 * insurancePer
                              )?.toFixed(4)
                            : parseFloat(inputFeild1)?.toFixed(4)}
                        </>
                      ) : (
                        "0.00"
                      )}{" "}
                      $RAIN
                    </h6>
                  </div>
                  {/* <div className="inner-text">
                    <p>Unlock Date:</p>
                    <h6>{date}</h6>
                    <h6>Q1,2024</h6>
                  </div> */}
                </div>
                {account ? (
                  <>
                    {
                      role !== "institution" ? (
                        <>
                          {mainTag === "ETH" ? (
                            <>
                              {inputFeild == "" ||
                              inputFeild == null ||
                              inputFeild <= 0 ||
                              blanceOfEth <
                                (checkBoxx
                                  ? parseFloat(inputFeild) +
                                    parseFloat(inputFeild) * insurancePer
                                  : inputFeild) ? (
                                <>
                                  <button className=" btn-buy">
                                    Buy $RAIN{" "}
                                  </button>
                                </>
                              ) : (
                                <button
                                  className="newClasss"
                                  onClick={handlerPop}
                                >
                                  Buy $RAIN{" "}
                                </button>
                              )}
                            </>
                          ) : (
                            <>
                              {mainTag === "USDT" ? (
                                <>
                                  {inputFeild == "" ||
                                  inputFeild == null ||
                                  inputFeild <= 0 ||
                                  balanceeUsdt <
                                    (checkBoxx
                                      ? parseFloat(inputFeild) +
                                        parseFloat(inputFeild) * insurancePer
                                      : inputFeild) ? (
                                    <>
                                      <button className=" btn-buy">
                                        Buy $RAIN{" "}
                                      </button>
                                    </>
                                  ) : (
                                    <button
                                      className="newClasss"
                                      onClick={handlerPop}
                                    >
                                      Buy $RAIN{" "}
                                    </button>
                                  )}
                                </>
                              ) : (
                                <>
                                  {inputFeild == "" ||
                                  inputFeild == null ||
                                  inputFeild <= 0 ||
                                  balancerOftomi <
                                    (checkBoxx
                                      ? parseFloat(inputFeild) +
                                        parseFloat(inputFeild) * insurancePer
                                      : inputFeild) ? (
                                    <>
                                      <button className=" btn-buy">
                                        Buy $RAIN{" "}
                                      </button>
                                    </>
                                  ) : (
                                    <button
                                      className="newClasss"
                                      onClick={handlerPop}
                                    >
                                      Buy $RAIN{" "}
                                    </button>
                                  )}
                                </>
                              )}
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          {check ? (
                            <>
                              {mainTag === "ETH" ? (
                                <>
                                  {inputFeild == "" ||
                                  inputFeild == null ||
                                  inputFeild <= 0 ||
                                  blanceOfEth <
                                    (checkBoxx
                                      ? parseFloat(inputFeild) +
                                        parseFloat(inputFeild) * insurancePer
                                      : inputFeild) ? (
                                    <>
                                      <button className=" btn-buy">
                                        Buy $RAIN{" "}
                                      </button>
                                    </>
                                  ) : (
                                    <button
                                      className="newClasss"
                                      onClick={handlerPop}
                                    >
                                      Buy $RAIN{" "}
                                    </button>
                                  )}
                                </>
                              ) : (
                                <>
                                  {mainTag == "USDT" ? (
                                    // <button className="btn-buy" onClick={handlerPop}>Buy TOMI....</button>
                                    <>
                                      {inputFeild == "" ||
                                      inputFeild == null ||
                                      inputFeild <= 0 ||
                                      balanceeUsdt <
                                        (checkBoxx
                                          ? parseFloat(inputFeild) +
                                            parseFloat(inputFeild) *
                                              insurancePer
                                          : inputFeild) ? (
                                        <button className=" btn-buy">
                                          Buy $RAIN
                                        </button>
                                      ) : (
                                        <button
                                          className="newClasss"
                                          onClick={handlerPop}
                                        >
                                          Buy $RAIN{" "}
                                        </button>
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      {mainTag == "USDC" ? (
                                        // <button className="btn-buy" onClick={handlerPop}>Buy TOMI....</button>
                                        <>
                                          {inputFeild == "" ||
                                          inputFeild == null ||
                                          inputFeild <= 0 ||
                                          balaceOfUsdc <
                                            (checkBoxx
                                              ? parseFloat(inputFeild) +
                                                parseFloat(inputFeild) *
                                                  insurancePer
                                              : inputFeild) ? (
                                            <button className=" btn-buy">
                                              Buy $RAIN
                                            </button>
                                          ) : (
                                            <button
                                              className="newClasss"
                                              onClick={handlerPop}
                                            >
                                              Buy $RAIN{" "}
                                            </button>
                                          )}
                                        </>
                                      ) : (
                                        <>
                                          {mainTag == "WBTC" ? (
                                            // <button className="btn-buy" onClick={handlerPop}>Buy TOMI....</button>
                                            <>
                                              {inputFeild == "" ||
                                              inputFeild == null ||
                                              inputFeild <= 0 ||
                                              balaceOfWbtc <
                                                (checkBoxx
                                                  ? parseFloat(inputFeild) +
                                                    parseFloat(inputFeild) *
                                                      insurancePer
                                                  : inputFeild) ? (
                                                <button className=" btn-buy">
                                                  Buy $RAIN
                                                </button>
                                              ) : (
                                                <button
                                                  className="newClasss"
                                                  onClick={handlerPop}
                                                >
                                                  Buy $RAIN{" "}
                                                </button>
                                              )}
                                            </>
                                          ) : (
                                            // <button className="btn-buy" onClick={handlerPop}>Buy TOMI....</button>
                                            <>
                                              {mainTag === "TOMI" ? (
                                                <>
                                                  {inputFeild == "" ||
                                                  inputFeild == null ||
                                                  inputFeild <= 0 ||
                                                  balaceOfTmi <
                                                    (checkBoxx
                                                      ? parseFloat(inputFeild) +
                                                        parseFloat(inputFeild) *
                                                          insurancePer
                                                      : inputFeild) ? (
                                                    <button className=" btn-buy">
                                                      Buy $RAIN
                                                    </button>
                                                  ) : (
                                                    <button
                                                      className="newClasss"
                                                      onClick={handlerPop}
                                                    >
                                                      Buy $RAIN{" "}
                                                    </button>
                                                  )}
                                                </>
                                              ) : (
                                                <>
                                                  {mainTag === "DOP" ? (
                                                    <>
                                                      {inputFeild == "" ||
                                                      inputFeild == null ||
                                                      inputFeild <= 0 ||
                                                      balaceOfDoppp <
                                                        (checkBoxx
                                                          ? parseFloat(
                                                              inputFeild
                                                            ) +
                                                            parseFloat(
                                                              inputFeild
                                                            ) *
                                                              insurancePer
                                                          : inputFeild) ? (
                                                        <button className=" btn-buy">
                                                          Buy $RAIN
                                                        </button>
                                                      ) : (
                                                        <button
                                                          className="newClasss"
                                                          onClick={handlerPop}
                                                        >
                                                          Buy $RAIN{" "}
                                                        </button>
                                                      )}
                                                    </>
                                                  ) : (
                                                    <>
                                                      {inputFeild == "" ||
                                                      inputFeild == null ||
                                                      inputFeild <= 0 ||
                                                      gemsBalance <
                                                        (checkBoxx
                                                          ? parseFloat(
                                                              inputFeild
                                                            ) +
                                                            parseFloat(
                                                              inputFeild
                                                            ) *
                                                              insurancePer
                                                          : inputFeild) ? (
                                                        <button className=" btn-buy">
                                                          Buy $RAIN
                                                        </button>
                                                      ) : (
                                                        <button
                                                          className="newClasss"
                                                          onClick={handlerPop}
                                                        >
                                                          Buy $RAIN{" "}
                                                        </button>
                                                      )}
                                                    </>
                                                  )}
                                                </>
                                              )}
                                            </>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                                </>
                              )}
                            </>
                          ) : (
                            <button className=" btn-buy">Buy $RAIN</button>
                          )}
                        </>
                      )
                      // <button className=" newClasss" onClick={handlerPop}>Buy Do </button>
                    }
                  </>
                ) : (
                  <button className="btn-buy" onClick={() => setShow(true)}>
                    Buy $RAIN
                  </button>
                )}
              </div>
            ) : (
              <div className="custom-tabs">
                <Tabs
                  defaultActiveKey={tab}
                  id="uncontrolled-tab-example"
                  onSelect={tabHandler}
                >
                  <Tab eventKey="home" title="Buy Token">
                    <div className="bottom-content">
                      <div className="twice-contentt">
                        <h6 className="main-head m-0">Buy $RAIN</h6>
                        <p>
                          Balance:{" "}
                          {mainTag === "ETH"
                            ? blanceOfEth > 0
                              ? blanceOfEth?.toFixed(4)
                              : "0.000"
                            : mainTag === "USDT"
                            ? balanceeUsdt > 0
                              ? balanceeUsdt?.toFixed(4)
                              : "0.000"
                            : mainTag === "USDC"
                            ? balaceOfUsdc > 0
                              ? balaceOfUsdc?.toFixed(4)
                              : "0.000"
                            : mainTag === "WBTC"
                            ? balaceOfWbtc > 0
                              ? balaceOfWbtc?.toFixed(6)
                              : "0.000"
                            : mainTag === "UNI"
                            ? balaceOfUnii > 0
                              ? balaceOfUnii?.toFixed(6)
                              : "0.000"
                            : mainTag === "LINK"
                            ? balaceOfLinkk > 0
                              ? balaceOfLinkk?.toFixed(6)
                              : "0.000"
                            : mainTag === "PEPE"
                            ? balaceOfPepee > 0
                              ? balaceOfPepee?.toFixed(6)
                              : "0.000"
                            : mainTag === "DOP"
                            ? balaceOfDoppp > 0
                              ? balaceOfDoppp?.toFixed(6)
                              : "0.000"
                            : mainTag === "TOMI"
                            ? balaceOfTmi > 0
                              ? balaceOfTmi?.toFixed(4)
                              : "0.000"
                            : gemsBalance > 0
                            ? gemsBalance?.toFixed(4)
                            : "0.000"}{" "}
                          {mainTag === "ETH"
                            ? " ETH "
                            : mainTag === "USDT"
                            ? " USDT "
                            : mainTag === "USDC"
                            ? "USDC"
                            : mainTag === "WBTC"
                            ? "WBTC"
                            : mainTag === "UNI"
                            ? "UNI"
                            : mainTag === "LINK"
                            ? "LINK"
                            : mainTag === "PEPE"
                            ? "PEPE"
                            : mainTag === "DOP"
                            ? "DOP"
                            : mainTag === "TOMI"
                            ? "TOMI"
                            : "GEMS"}
                        </p>
                      </div>

                      <div className="parent-box">
                        <img
                          src="\assets\swap-arrow.svg"
                          alt="img"
                          className="img-fluid swap-arrow"
                        />
                        <div className="inner-box">
                          {" "}
                          <div className="left">
                            <div class="dropdown">
                              <button
                                class="dropdown-toggle"
                                type="button"
                                data-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <div className="flexset">
                                  <img
                                    src={tagImge}
                                    alt="img"
                                    className="img-fluid suxvsvsyucsusc"
                                  />
                                  <div className="text">
                                    <h6>{mainTag}</h6>
                                  </div>
                                </div>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="8"
                                  height="5"
                                  viewBox="0 0 8 5"
                                  fill="none"
                                >
                                  <path
                                    d="M7.81779 1.29713L5.9829 3.24602L4.86253 4.44207C4.38809 4.94599 3.61641 4.94599 3.14197 4.44207L0.181004 1.29713C-0.207694 0.88428 0.0723969 0.180007 0.615431 0.180007H3.82219H7.38336C7.93211 0.180007 8.20648 0.88428 7.81779 1.29713Z"
                                    fill="#02171D"
                                  />
                                </svg>
                              </button>
                              <ul class="dropdown-menu">
                                <li>
                                  <a
                                    class="dropdown-item gscrxcsx"
                                    onClick={() => changeTag1("ETH")}
                                  >
                                    <img
                                      src="/assets/eth-icon.svg"
                                      alt="img"
                                      className="img-fluid"
                                    />{" "}
                                    ETH
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item gscrxcsx"
                                    onClick={() => changeTag1("USDT")}
                                  >
                                    <img
                                      src="/assets/usdt.svg"
                                      alt="img"
                                      className="img-fluid"
                                    />{" "}
                                    USDT
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item gscrxcsx"
                                    onClick={() => changeTag1("USDC")}
                                  >
                                    <img
                                      src="\assets\usdc.svg"
                                      alt="img"
                                      className="img-fluid"
                                    />{" "}
                                    USDC
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item gscrxcsx"
                                    onClick={() => changeTag1("GEMS")}
                                  >
                                    <img
                                      src="\assets\newgemslogosvg.svg"
                                      alt="img"
                                      className="img-fluid"
                                    />{" "}
                                    GEMS
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item gscrxcsx"
                                    onClick={() => changeTag1("WBTC")}
                                  >
                                    <img
                                      src="\assets\wbtc.svg"
                                      alt="img"
                                      className="img-fluid"
                                    />{" "}
                                    WBTC
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item gscrxcsx"
                                    onClick={() => changeTag1("LINK")}
                                  >
                                    <img
                                      src="\assets\link.svg"
                                      alt="img"
                                      className="img-fluid"
                                    />{" "}
                                    LINK
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item gscrxcsx"
                                    onClick={() => changeTag1("TOMI")}
                                  >
                                    <img
                                      src="\assets\tomi-icon-drop.svg"
                                      alt="img"
                                      className="img-fluid"
                                    />{" "}
                                    TOMI
                                  </a>
                                </li>

                                <li>
                                  <a
                                    class="dropdown-item gscrxcsx"
                                    onClick={() => changeTag1("PEPE")}
                                  >
                                    <img
                                      src="\assets\pepe.svg"
                                      alt="img"
                                      className="img-fluid"
                                    />{" "}
                                    PEPE
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item gscrxcsx"
                                    onClick={() => changeTag1("UNI")}
                                  >
                                    <img
                                      src="\assets\uniswap.svg"
                                      alt="img"
                                      className="img-fluid"
                                    />{" "}
                                    UNI
                                  </a>
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item gscrxcsx"
                                    onClick={() => changeTag1("DOP")}
                                  >
                                    <img
                                      src="\assets\dop.svg"
                                      alt="img"
                                      className="img-fluid"
                                    />{" "}
                                    DOP
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="right">
                            <h6>
                              $
                              {inputFeild1 && inputFeild
                                ? amountInUsdt?.toLocaleString(undefined, {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 2,
                                  })
                                : "0.00"}
                            </h6>
                            {/* balanceeUsdt?.toFixed(2)?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",") */}
                            <input
                              onChange={inputField1Handler}
                              value={inputFeild}
                              onWheel={(e) => e.target.blur()}
                              type="number"
                              placeholder="0.00"
                            />
                            {/* <p>0.00</p> */}
                          </div>
                        </div>
                        <div className="inner-box">
                          <div className="leftiii">
                            <img
                              src="\assets\newincentivlogo.svg"
                              alt="img"
                              className="img-fluid"
                              style={{
                                width: "35px",
                                height: "35px",
                                borderRadius: "120px",
                              }}
                            />
                            <div className="text">
                              <h6>Rain</h6>
                              <p className="textpara">$RAIN</p>
                            </div>
                          </div>
                          <div className="right">
                            <h6>
                              {/* Balance:{" "} */}
                              {/* <span style={{ color: "#fff" }}>
{balacefAccountTomii > 0
? balacefAccountTomii
?.toFixed(4)
: "0.000"}
</span> */}
                            </h6>
                            <input
                              onChange={inputField1Handler1}
                              value={inputFeild1}
                              disabled
                              onWheel={(e) => e.target.blur()}
                              type="number"
                              placeholder="0.00"
                            />
                            {/* <p>0.00</p> */}
                          </div>
                        </div>
                      </div>

                      {/* <div className="getinsurance-flow">
                        <img
                          src="\assets\insurance-bg.png"
                          alt="img"
                          className="img-fluid insurance-shadow"
                        />
                        <div className="left-side">
                          <div className="lefthead">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                            >
                              <path
                                d="M13.5007 9.49826L13.5007 6.79987L9.38942 10.9008L6.93848 9.17174L6.93848 11.6734L9.38941 13.5202L13.5007 9.49826Z"
                                fill="#329879"
                              />
                              <path
                                d="M15.4004 5.93396L15.4004 3.68436L9.94927 0.63287L9.94927 2.88247L15.4004 5.93396Z"
                                fill="#329879"
                              />
                              <path
                                d="M4.48633 5.93396L4.48633 3.68436L9.93745 0.632871L10.8798 2.05067L9.93745 2.88248L4.48633 5.93396Z"
                                fill="#329879"
                              />
                              <path
                                d="M17.1221 10.7532L17.1221 5.93036L15.0664 5.93036L15.0664 10.7532L17.1221 10.7532Z"
                                fill="#329879"
                              />
                              <path
                                d="M2.7334 10.7532L2.7334 5.93036L4.78902 5.93036L4.78902 10.7532L2.7334 10.7532Z"
                                fill="#329879"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M9.26893 17.126C12.9144 15.8369 15.176 13.4242 15.0669 10.3578L17.1225 10.4369C17.2772 14.7847 14.0172 17.6273 9.95425 19.064L9.26893 17.126Z"
                                fill="#329879"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M10.6333 17.126C6.98789 15.8369 4.67972 13.4241 4.7888 10.3578L2.69363 10.4369C2.53896 14.7847 5.88506 17.6273 9.948 19.064L10.6333 17.126Z"
                                fill="#329879"
                              />
                            </svg>
                            <h6 className="protecthead">Gems Protect</h6>
                          </div>
                          <p>
                            Get 75% of your purchase covered by paying just 5%
                            of the total cost.{" "}
                          </p>
                        </div>
                        <div className="right-side">
                          {!checkBoxx ? (
                            <>
                              <button
                                onClick={handleShow2Insurance1}
                                className={
                                  inputFeild
                                    ? "addinsurance-btn"
                                    : "addinsurance-btn disabled"
                                }
                                // className="addinsurance-btn"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="25"
                                  viewBox="0 0 24 25"
                                  fill="none"
                                >
                                  <path
                                    d="M9 20.5C9 21.6 8.1 22.5 7 22.5C5.9 22.5 5 21.6 5 20.5C5 19.4 5.9 18.5 7 18.5C8.1 18.5 9 19.4 9 20.5ZM17 18.5C15.9 18.5 15 19.4 15 20.5C15 21.6 15.9 22.5 17 22.5C18.1 22.5 19 21.6 19 20.5C19 19.4 18.1 18.5 17 18.5ZM7.2 15.3V15.2L8.1 13.5H15.5C16.2 13.5 16.9 13.1 17.2 12.5L21.1 5.5L19.4 4.5L15.5 11.5H8.5L4.3 2.5H1V4.5H3L6.6 12.1L5.2 14.5C5.1 14.8 5 15.1 5 15.5C5 16.6 5.9 17.5 7 17.5H19V15.5H7.4C7.3 15.5 7.2 15.4 7.2 15.3Z"
                                    fill="#329879"
                                  />
                                </svg>{" "}
                                <>
                                  {inputFeild1 > 0 ? (
                                    <>
                                      Add for{" "}
                                      {(
                                        inputFeild * insurancePer
                                      )?.toLocaleString(undefined, {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 5,
                                      })}{" "}
                                      {mainTag}
                                    </>
                                  ) : (
                                    <>Add Gems Protect</>
                                  )}
                                </>
                              </button>
                            </>
                          ) : (
                            <>
                              <div className="insurance-added">
                                <div className="btn-added">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="25"
                                    viewBox="0 0 24 25"
                                    fill="none"
                                  >
                                    <path
                                      d="M9 20.5C9 21.6 8.1 22.5 7 22.5C5.9 22.5 5 21.6 5 20.5C5 19.4 5.9 18.5 7 18.5C8.1 18.5 9 19.4 9 20.5ZM17 18.5C15.9 18.5 15 19.4 15 20.5C15 21.6 15.9 22.5 17 22.5C18.1 22.5 19 21.6 19 20.5C19 19.4 18.1 18.5 17 18.5ZM7.2 15.3V15.2L8.1 13.5H15.5C16.2 13.5 16.9 13.1 17.2 12.5L21.1 5.50002L19.4 4.50002L15.5 11.5H8.5L4.3 2.50002H1V4.50002H3L6.6 12.1L5.2 14.5C5.1 14.8 5 15.1 5 15.5C5 16.6 5.9 17.5 7 17.5H19V15.5H7.4C7.3 15.5 7.2 15.4 7.2 15.3ZM18 3.30002L16.6 1.90002L11.8 6.70002L9.2 4.10002L7.8 5.50002L11.8 9.50002L18 3.30002Z"
                                      fill="#E2E9EC"
                                    />
                                  </svg>
                                  <h6>Gems Protect Added</h6>
                                </div>
                                <div
                                  className="btnnotadded"
                                  onClick={() => {
                                    setCheckBoxx(false);
                                    setCheked3(false);
                                    setCheked4(false);
                                  }}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="25"
                                    viewBox="0 0 24 25"
                                    fill="none"
                                  >
                                    <path
                                      d="M9 20.5C9 21.6 8.1 22.5 7 22.5C5.9 22.5 5 21.6 5 20.5C5 19.4 5.9 18.5 7 18.5C8.1 18.5 9 19.4 9 20.5ZM17 18.5C15.9 18.5 15 19.4 15 20.5C15 21.6 15.9 22.5 17 22.5C18.1 22.5 19 21.6 19 20.5C19 19.4 18.1 18.5 17 18.5ZM7.2 15.3V15.2L8.1 13.5H15.5C16.2 13.5 16.9 13.1 17.2 12.5L21.1 5.50002L19.4 4.50002L15.5 11.5H8.5L4.3 2.50002H1V4.50002H3L6.6 12.1L5.2 14.5C5.1 14.8 5 15.1 5 15.5C5 16.6 5.9 17.5 7 17.5H19V15.5H7.4C7.3 15.5 7.2 15.4 7.2 15.3ZM18 3.30002L16.6 1.90002L11.8 6.70002L9.2 4.10002L7.8 5.50002L11.8 9.50002L18 3.30002Z"
                                      fill="#FC4F52"
                                    />
                                  </svg>
                                  <h6>Remove Gems Protect</h6>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      </div> */}
                      {role === "institution" && (
                        <div
                          className="material-textfield"
                          style={{ marginTop: "5px", marginBottom: "25px" }}
                        >
                          <input
                            onChange={inputField1Handler5}
                            value={inputFeild5}
                            onWheel={(e) => e.target.blur()}
                            type="text"
                            placeholder="Enter only ERC20 wallet address"
                          />
                          <label>Enter $RAIN recipient wallet address</label>
                        </div>
                      )}
                      <div className="bottom-text">
                        {/* <div className="inner-text">
<p>Receive:</p>
<h6>
{inputFeild1
? inputFeild1
?.toFixed(3)
: "0.00"}{" "}
TOMI
</h6>
</div>
<div className="inner-text">
<p>+{aaa / 10}% Bonus:</p>
<h6>
{inputFeild1
? ((inputFeild1 * (aaa / 10)) / 100)
?.toFixed(3)
: "0.00"}{" "}
TOMI
</h6>
</div> */}
                        {/* <div className="inner-text-bold">
                          <h6>sub Total</h6>
                          <h6>
                            {inputFeild1 && inputFeild
                              ? parseFloat((inputFeild1))
                                ?.toFixed(3)
                              : "0.00"}{" "}
                            $RAIN
                          </h6>
                        </div> */}
                        {/* <div className="inner-text-bold inner-text-bolddddd">
                          <div className="twice-text">
                            <h6>{round == 1 ? '20' : "7"}% Additional Tokens:</h6>
                            <p>For Golden Users </p>
                          </div>
                          <h6>
                            {stakedAmount >=  5555 ?
                              <>
                                {inputFeild1 && inputFeild
                                  ?
                                  ethValueCalcualte.toFixed(2)
                                  :
                                  "0.00"}
                              </>
                              :
                              0.00
                              // (parseFloat(inputFeild) / discountedPriceee) - parseFloat((inputFeild1))
                            }
                            {" "}$RAIN
                          </h6>
                        </div> */}

                        <div className="inner-text-bold">
                          <h6 style={{ textAlign: "start" }}>Tokens You Get</h6>
                          <h6>
                            {(stakedAmount >= 5555 &&
                              stakingData?.length > 0) ||
                            moment().isBefore(stakeEndTime1) ? (
                              <>
                                {inputFeild1 && inputFeild
                                  ? parseFloat(inputFeild1) +
                                    parseInt(ethValueCalcualte?.toFixed(2))
                                  : "0.00"}
                              </>
                            ) : (
                              <>
                                {inputFeild1 && inputFeild
                                  ? parseFloat(inputFeild1)?.toFixed(3)
                                  : "0.00"}
                              </>
                            )}{" "}
                            $RAIN
                          </h6>
                        </div>
                        <div
                          className="inner-text-bold mt-3 w-100"
                          style={{ flexDirection: "column" }}
                        >
                          {checkBoxx && (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                              className="w-100 mb-3"
                            >
                              <h6
                                style={{ color: "#329879", textAlign: "start" }}
                              >
                                Gems Protect
                              </h6>
                              <h6>
                                <>
                                  {inputFeild1 && inputFeild ? (
                                    <>
                                      {(
                                        inputFeild * insurancePer
                                      )?.toLocaleString(undefined, {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 5,
                                      })}
                                    </>
                                  ) : (
                                    "0.00"
                                  )}
                                </>{" "}
                                {mainTag}
                                <span
                                  style={{
                                    fontSize: "18px",
                                    color: "#77868B",
                                    marginLeft: "5px",
                                  }}
                                >
                                  ($
                                  {inputFeild1 && inputFeild
                                    ? (
                                        amountInUsdt * insurancePer
                                      )?.toLocaleString(undefined, {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 5,
                                      })
                                    : 0.0}
                                  )
                                </span>
                              </h6>
                            </div>
                          )}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                            className="w-100"
                          >
                            <h6 style={{ color: "#329879" }}>Total:</h6>
                            <h6>
                              <span style={{ color: "#329879" }}>
                                {inputFeild1 && inputFeild ? (
                                  <>
                                    {checkBoxx
                                      ? parseFloat(
                                          parseFloat(inputFeild) +
                                            inputFeild * insurancePer
                                        )?.toFixed(4)
                                      : parseFloat(inputFeild)?.toFixed(4)}
                                  </>
                                ) : (
                                  "0.00"
                                )}
                              </span>{" "}
                              <span style={{ color: "#329879" }}>
                                {" "}
                                {mainTag}
                              </span>{" "}
                              <span
                                style={{ fontSize: "18px", color: "#77868B" }}
                              >
                                ($
                                {inputFeild1 && inputFeild ? (
                                  <>
                                    {checkBoxx
                                      ? (
                                          amountInUsdt +
                                          amountInUsdt * insurancePer
                                        )?.toLocaleString(undefined, {
                                          minimumFractionDigits: 0,
                                          maximumFractionDigits: 5,
                                        })
                                      : amountInUsdt?.toLocaleString(
                                          undefined,
                                          {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 5,
                                          }
                                        )}
                                  </>
                                ) : (
                                  0.0
                                )}
                                )
                              </span>
                            </h6>
                          </div>
                        </div>
                        {/* <div className="inner-text-bold">
                          <h6>Unlocks On:</h6>
                          <h6>
                            Q1,2024
                          </h6>
                        </div> */}

                        {/* <div className="inner-text">
                          <p>Unlock Date:</p>
                          <h6>{date}</h6>
                          <h6>Q1,2024</h6>
                        </div> */}
                      </div>
                      {account && emailModelCheck ? (
                        <>
                          {!timeshow &&
                          currentTime >
                            new Date(parseInt(currentRount?.startTime)) &&
                          currentTime <
                            new Date(parseInt(currentRount?.endTime)) ? (
                            <>
                              {
                                role !== "institution" ? (
                                  <>
                                    {/* {psMaxxCap>=psmyTotlaPurchasess? */}
                                    <>
                                      {mainTag === "ETH" ? (
                                        <>
                                          {inputFeild == "" ||
                                          inputFeild == null ||
                                          inputFeild <= 0 ||
                                          blanceOfEth <
                                            (checkBoxx
                                              ? parseFloat(inputFeild) +
                                                parseFloat(inputFeild) *
                                                  insurancePer
                                              : inputFeild) ? (
                                            <>
                                              <button className=" btn-buy">
                                                Buy $RAIN{" "}
                                              </button>
                                            </>
                                          ) : (
                                            <button
                                              className="newClasss"
                                              onClick={handlerPop}
                                            >
                                              Buy $RAIN{" "}
                                            </button>
                                          )}
                                        </>
                                      ) : (
                                        <>
                                          {mainTag == "USDT" ? (
                                            // <button className="btn-buy" onClick={handlerPop}>Buy TOMI....</button>
                                            <>
                                              {inputFeild == "" ||
                                              inputFeild == null ||
                                              inputFeild <= 0 ||
                                              balanceeUsdt <
                                                (checkBoxx
                                                  ? parseFloat(inputFeild) +
                                                    parseFloat(inputFeild) *
                                                      insurancePer
                                                  : inputFeild) ? (
                                                <button className=" btn-buy">
                                                  Buy $RAIN
                                                </button>
                                              ) : (
                                                <button
                                                  className="newClasss"
                                                  onClick={handlerPop}
                                                >
                                                  Buy $RAIN{" "}
                                                </button>
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              {mainTag == "USDC" ? (
                                                // <button className="btn-buy" onClick={handlerPop}>Buy TOMI....</button>
                                                <>
                                                  {inputFeild == "" ||
                                                  inputFeild == null ||
                                                  inputFeild <= 0 ||
                                                  balaceOfUsdc <
                                                    (checkBoxx
                                                      ? parseFloat(inputFeild) +
                                                        parseFloat(inputFeild) *
                                                          insurancePer
                                                      : inputFeild) ? (
                                                    <button className=" btn-buy">
                                                      Buy $RAIN
                                                    </button>
                                                  ) : (
                                                    <button
                                                      className="newClasss"
                                                      onClick={handlerPop}
                                                    >
                                                      Buy $RAIN{" "}
                                                    </button>
                                                  )}
                                                </>
                                              ) : (
                                                <>
                                                  {mainTag == "WBTC" ? (
                                                    // <button className="btn-buy" onClick={handlerPop}>Buy TOMI....</button>
                                                    <>
                                                      {inputFeild == "" ||
                                                      inputFeild == null ||
                                                      inputFeild <= 0 ||
                                                      balaceOfWbtc <
                                                        (checkBoxx
                                                          ? parseFloat(
                                                              inputFeild
                                                            ) +
                                                            parseFloat(
                                                              inputFeild
                                                            ) *
                                                              insurancePer
                                                          : inputFeild) ? (
                                                        <button className=" btn-buy">
                                                          Buy $RAIN{" "}
                                                        </button>
                                                      ) : (
                                                        <button
                                                          className="newClasss"
                                                          onClick={handlerPop}
                                                        >
                                                          Buy $RAIN{" "}
                                                        </button>
                                                      )}
                                                    </>
                                                  ) : (
                                                    <>
                                                      {mainTag == "LINK" ? (
                                                        <>
                                                          {inputFeild == "" ||
                                                          inputFeild == null ||
                                                          inputFeild <= 0 ||
                                                          balaceOfLinkk <
                                                            (checkBoxx
                                                              ? parseFloat(
                                                                  inputFeild
                                                                ) +
                                                                parseFloat(
                                                                  inputFeild
                                                                ) *
                                                                  insurancePer
                                                              : inputFeild) ? (
                                                            <button className=" btn-buy">
                                                              Buy $RAIN{" "}
                                                            </button>
                                                          ) : (
                                                            <button
                                                              className="newClasss"
                                                              onClick={
                                                                handlerPop
                                                              }
                                                            >
                                                              Buy $RAIN{" "}
                                                            </button>
                                                          )}
                                                        </>
                                                      ) : (
                                                        <>
                                                          {mainTag == "PEPE" ? (
                                                            <>
                                                              {inputFeild ==
                                                                "" ||
                                                              inputFeild ==
                                                                null ||
                                                              inputFeild <= 0 ||
                                                              balaceOfPepee <
                                                                (checkBoxx
                                                                  ? parseFloat(
                                                                      inputFeild
                                                                    ) +
                                                                    parseFloat(
                                                                      inputFeild
                                                                    ) *
                                                                      insurancePer
                                                                  : inputFeild) ? (
                                                                <button className=" btn-buy">
                                                                  Buy $RAIN{" "}
                                                                </button>
                                                              ) : (
                                                                <button
                                                                  className="newClasss"
                                                                  onClick={
                                                                    handlerPop
                                                                  }
                                                                >
                                                                  Buy $RAIN{" "}
                                                                </button>
                                                              )}
                                                            </>
                                                          ) : (
                                                            <>
                                                              {mainTag ==
                                                              "UNI" ? (
                                                                <>
                                                                  {inputFeild ==
                                                                    "" ||
                                                                  inputFeild ==
                                                                    null ||
                                                                  inputFeild <=
                                                                    0 ||
                                                                  balaceOfUnii <
                                                                    (checkBoxx
                                                                      ? parseFloat(
                                                                          inputFeild
                                                                        ) +
                                                                        parseFloat(
                                                                          inputFeild
                                                                        ) *
                                                                          insurancePer
                                                                      : inputFeild) ? (
                                                                    <button className=" btn-buy">
                                                                      Buy $RAIN{" "}
                                                                    </button>
                                                                  ) : (
                                                                    <button
                                                                      className="newClasss"
                                                                      onClick={
                                                                        handlerPop
                                                                      }
                                                                    >
                                                                      Buy $RAIN{" "}
                                                                    </button>
                                                                  )}
                                                                </>
                                                              ) : (
                                                                <>
                                                                  {mainTag ==
                                                                  "DOP" ? (
                                                                    <>
                                                                      {inputFeild ==
                                                                        "" ||
                                                                      inputFeild ==
                                                                        null ||
                                                                      inputFeild <=
                                                                        0 ||
                                                                      balaceOfDoppp <
                                                                        (checkBoxx
                                                                          ? parseFloat(
                                                                              inputFeild
                                                                            ) +
                                                                            parseFloat(
                                                                              inputFeild
                                                                            ) *
                                                                              insurancePer
                                                                          : inputFeild) ? (
                                                                        <button className=" btn-buy">
                                                                          Buy
                                                                          $RAIN{" "}
                                                                        </button>
                                                                      ) : (
                                                                        <button
                                                                          className="newClasss"
                                                                          onClick={
                                                                            handlerPop
                                                                          }
                                                                        >
                                                                          Buy
                                                                          $RAIN{" "}
                                                                        </button>
                                                                      )}
                                                                    </>
                                                                  ) : (
                                                                    <>
                                                                      {mainTag ==
                                                                      "TOMI" ? (
                                                                        <>
                                                                          {inputFeild ==
                                                                            "" ||
                                                                          inputFeild ==
                                                                            null ||
                                                                          inputFeild <=
                                                                            0 ||
                                                                          balaceOfTmi <
                                                                            (checkBoxx
                                                                              ? parseFloat(
                                                                                  inputFeild
                                                                                ) +
                                                                                parseFloat(
                                                                                  inputFeild
                                                                                ) *
                                                                                  insurancePer
                                                                              : inputFeild) ? (
                                                                            <button className=" btn-buy">
                                                                              Buy
                                                                              $RAIN
                                                                            </button>
                                                                          ) : (
                                                                            <button
                                                                              className="newClasss"
                                                                              onClick={
                                                                                handlerPop
                                                                              }
                                                                            >
                                                                              Buy
                                                                              $RAIN{" "}
                                                                            </button>
                                                                          )}
                                                                        </>
                                                                      ) : (
                                                                        <>
                                                                          {inputFeild ==
                                                                            "" ||
                                                                          inputFeild ==
                                                                            null ||
                                                                          inputFeild <=
                                                                            0 ||
                                                                          gemsBalance <
                                                                            (checkBoxx
                                                                              ? parseFloat(
                                                                                  inputFeild
                                                                                ) +
                                                                                parseFloat(
                                                                                  inputFeild
                                                                                ) *
                                                                                  insurancePer
                                                                              : inputFeild) ? (
                                                                            <button className=" btn-buy">
                                                                              Buy
                                                                              $RAIN
                                                                            </button>
                                                                          ) : (
                                                                            <button
                                                                              className="newClasss"
                                                                              onClick={
                                                                                handlerPop
                                                                              }
                                                                            >
                                                                              Buy
                                                                              $RAIN{" "}
                                                                            </button>
                                                                          )}
                                                                        </>
                                                                      )}
                                                                    </>
                                                                  )}
                                                                </>
                                                              )}
                                                            </>
                                                          )}
                                                        </>
                                                      )}
                                                    </>
                                                  )}
                                                </>
                                              )}
                                            </>
                                          )}
                                        </>
                                      )}
                                    </>
                                  </>
                                ) : (
                                  <>
                                    {mainTag === "ETH" ? (
                                      <>
                                        {check ? (
                                          <>
                                            {inputFeild == "" ||
                                            inputFeild == null ||
                                            inputFeild <= 0 ||
                                            blanceOfEth <
                                              (checkBoxx
                                                ? parseFloat(inputFeild) +
                                                  parseFloat(inputFeild) *
                                                    insurancePer
                                                : inputFeild) ? (
                                              <>
                                                <button className=" btn-buy">
                                                  Buy $RAIN{check}
                                                </button>
                                              </>
                                            ) : (
                                              <button
                                                className="newClasss"
                                                onClick={handlerPop}
                                              >
                                                Buy $RAIN{" "}
                                              </button>
                                            )}
                                          </>
                                        ) : (
                                          <button className=" btn-buy">
                                            Buy $RAIN
                                          </button>
                                        )}
                                      </>
                                    ) : (
                                      // <button className="btn-buy" onClick={handlerPop}>Buy TOMI....</button>
                                      <>
                                        {check ? (
                                          <>
                                            {inputFeild == "" ||
                                            inputFeild == null ||
                                            inputFeild <= 0 ||
                                            balanceeUsdt <
                                              (checkBoxx
                                                ? parseFloat(inputFeild) +
                                                  parseFloat(inputFeild) *
                                                    insurancePer
                                                : inputFeild) ? (
                                              <>
                                                <button className=" btn-buy">
                                                  Buy $RAIN
                                                </button>
                                              </>
                                            ) : (
                                              <button
                                                className="newClasss"
                                                onClick={handlerPop}
                                              >
                                                Buy $RAIN{" "}
                                              </button>
                                            )}
                                          </>
                                        ) : (
                                          <button className=" btn-buy">
                                            Buy $RAIN
                                          </button>
                                        )}
                                      </>
                                    )}
                                  </>
                                )
                                // <button className=" newClasss" onClick={handlerPop}>Buy GEMS </button>
                              }
                            </>
                          ) : (
                            <button className="btn-buy">Buy $RAIN</button>
                          )}
                        </>
                      ) : (
                        <>
                          {!account ? (
                            <button
                              className="btn-buy"
                              onClick={() => setShow(true)}
                            >
                              Buy $RVV
                            </button>
                          ) : (
                            <button
                              className="btn-buy"
                              onClick={() => handleShow2()}
                            >
                              Buy $RVV
                            </button>
                          )}
                        </>
                      )}
                    </div>
                  </Tab>
                  <Tab eventKey="profile" title="Buy NFTs">
                    <DopNft
                      psMaxxCap={psMaxxCap}
                      psmyTotlaPurchasess={psmyTotlaPurchasess}
                      timeshow={timeshow}
                      balaceOfWbtc={balaceOfWbtc}
                      balaceOfUsdc={balaceOfUsdc}
                      getAllowanceWbtc={getAllowanceWbtc}
                      getAllowanceUsdc={getAllowanceUsdc}
                      setShow={setShow}
                      price={price}
                      wbtcCurrentPrice={wbtcCurrentPrice}
                      ethPricevalue={ethPricevalue}
                      code={code}
                      setLoarder={setLoarder}
                      saleCurrentStaus={saleCurrentStaus}
                      currentRoundd={currentRoundd}
                      blanceOfEth={blanceOfEth}
                      balanceeUsdt={balanceeUsdt}
                      pepePrice={pepePrice}
                      tomiAllowance={tomiAllowance}
                      allowanceTpl={allowanceTpl}
                      balaceOfTmi={balaceOfTmi}
                      alowence={alowence}
                      sallowance={sallowance}
                      discoundedPriceee={discoundedPriceee}
                      tab={tab}
                      setMyPsTotlaPurchasess={setMyPsTotlaPurchasess}
                      psTotlaPurchasess={psTotlaPurchasess}
                      stakeIndex={stakeIndex}
                      stakedAmount={stakedAmount}
                      discountedPriceee={discountedPriceee}
                      round={round}
                      linkPricevalue={linkPricevalue}
                      uniPricevalue={uniPricevalue}
                      pepeAllowance={pepeAllowance}
                      linkAllowance={linkAllowance}
                      uniAllowance={uniAllowance}
                      balaceOfLinkk={balaceOfLinkk}
                      balaceOfPepee={balaceOfPepee}
                      balaceOfUnii={balaceOfUnii}
                      dopAllowance={dopAllowance}
                      balaceOfDoppp={balaceOfDoppp}
                      dopPricevalue={dopPricevalue}
                      insurancePer={insurancePer}
                      checkBoxx={checkBoxx}
                      tomiPrice={tomiPrice}
                      gemsAllowance={gemsAllowance}
                      gemsBalance={gemsBalance}
                      gemsPrice={gemsPrice}
                      handleShow2Insurance1={handleShow2Insurance1}
                      setCheked3={setCheked3}
                      setCheked4={setCheked4}
                      setCheckBoxx={setCheckBoxx}
                      handleShow5={handleShow5}
                    />
                  </Tab>
                </Tabs>
              </div>
            )}
          </div>
        </div>
      </section>

      <Modal
        className="connectwallet-modal buy-modal trx-modal"
        show={show1}
        onHide={handleClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>$RAIN Purchased</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="buy-modal">
            <img src="\assets\purchased.svg" alt="img" className="img-fluid" />
            <h4>Tokens Successfully Purchased</h4>
            <p>You have successfully purchased Tokens</p>
            <div className="token-purchased-area">
              <div className="single-value">
                <h5>Tokens Purchased</h5>
                <h6>
                  {(stakedAmount >= 5555 && stakingData?.length > 0) ||
                  moment().isBefore(stakeEndTime1) ? (
                    <>
                      {inputFeild1 && inputFeild
                        ? parseFloat(inputFeild1) +
                          parseInt(ethValueCalcualte?.toFixed(2))
                        : "0.00"}
                    </>
                  ) : (
                    <>
                      {inputFeild1 && inputFeild
                        ? parseFloat(inputFeild1)?.toFixed(3)
                        : "0.00"}
                    </>
                  )}{" "}
                  $RAIN
                </h6>
              </div>
            </div>
            <div className="token-purchased-area tokenpurchasedlast">
              {checkBoxx && (
                <div className="single-value">
                  <h5 style={{ color: "#329879" }}>Spent on Token Purchase</h5>
                  <h6>
                    {inputFeild1 && inputFeild
                      ? parseFloat(inputFeild)
                      : "0.00"}{" "}
                    {mainTag}{" "}
                    <span style={{ fontSize: "18px", color: "#77868B" }}>
                      ($
                      {inputFeild1 && inputFeild
                        ? amountInUsdt?.toLocaleString(undefined, {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 5,
                          })
                        : 0.0}
                      )
                    </span>
                  </h6>
                </div>
              )}
              {checkBoxx && (
                <div className="single-value">
                  <h5 style={{ color: "#329879" }}>Gems Protect</h5>
                  <h6>
                    <>
                      {inputFeild1 && inputFeild ? (
                        <>
                          {(inputFeild * insurancePer)?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 5,
                            }
                          )}
                        </>
                      ) : (
                        "0.00"
                      )}
                    </>{" "}
                    {mainTag}
                    <span
                      style={{
                        fontSize: "18px",
                        color: "#77868B",
                        marginLeft: "5px",
                      }}
                    >
                      ($
                      {inputFeild1 && inputFeild
                        ? (amountInUsdt * insurancePer)?.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 5,
                            }
                          )
                        : 0.0}
                      )
                    </span>
                  </h6>
                </div>
              )}
              <div
                className={
                  checkBoxx ? "single-value newborderr" : "single-value"
                }
              >
                <h5 style={{ color: "#329879" }}>Total Amount Spent</h5>
                <h6>
                  {inputFeild1 && inputFeild ? (
                    <>
                      {checkBoxx
                        ? parseFloat(
                            parseFloat(inputFeild) + inputFeild * insurancePer
                          )
                        : parseFloat(inputFeild)}
                    </>
                  ) : (
                    "0.00"
                  )}{" "}
                  {mainTag}{" "}
                  <span style={{ fontSize: "18px", color: "#77868B" }}>
                    ($
                    {inputFeild1 && inputFeild ? (
                      <>
                        {checkBoxx
                          ? (
                              amountInUsdt +
                              amountInUsdt * insurancePer
                            )?.toLocaleString(undefined, {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 5,
                            })
                          : amountInUsdt?.toLocaleString(undefined, {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 5,
                            })}
                      </>
                    ) : (
                      0.0
                    )}
                    )
                  </span>
                </h6>
              </div>
            </div>

            <button
              className="btn-common"
              onClick={() => {
                handleClose();
                handleShow5();
              }}
              style={{ marginTop: "20px" }}
            >
              Okay
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="connectwallet-modal followusonx-modal"
        show={show5}
        onHide={handleClose5}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Follow Us</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="buydopnft-modal buynft-modal2">
            <img src="\assets\followx.svg" alt="img" className="img-fluid" />
            <h4>Follow Gems on X</h4>
            <p className="newdeisgnpara">
              Follow Gems on X to stay updated with news and announcements{" "}
            </p>
          </div>
          <div className="twice-btnsss">
            <button
              onClick={witterHandler}
              className="btn-proceed sscscscscscsc"
            >
              Follow Gems on X
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="stakingmodal premiumstake-modal newmodalbackdrop"
        show={show0}
        onHide={handleClos0}
        centered
        backdrop={false}
        keyboard={false}
      >
        <Modal.Body>
          <div className="stakingmodal">
            <div className="inner-content">
              <img
                src="\assets\premium\modalbg.png"
                alt="img"
                className="img-fluid modalbg-stake"
              />
              <img
                src="\assets\premium\goldenuser.svg"
                alt="img"
                className="img-fluid"
              />
              <h5>
                Get Gems Premium and <br />
                Receive {round == 1 ? "20" : "7"}% Discount
              </h5>
            </div>
            <div className="d-flex justify-content-center mb-4">
              {/* <p className="text-danger ">{walletError}</p> */}
            </div>
            <div className="stakingbtns">
              <button
                onClick={() => {
                  handleClos0();
                }}
                className="cancelbtn"
              >
                Continue
              </button>
              <button
                onClick={() => {
                  history.push("/discount");
                }}
                className="confirmbtn"
              >
                Get Gems Premium
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* <Modal
        className="connectwallet-modal nooreee learnmore-modal"
        show={show2insurance1}
        onHide={handleClose2Insurance1}
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Terms & Conditions</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="disclaimerdiv">
            <div className="darktext">
              <div className="scrolltext">
                <p className="darkparaupper text-center">
                  You may choose to sign up for Gems Protect, in order to be
                  eligible to take part in Gems Protect you must:
                </p>

                <p className="darkpara">
                  <ol>
                    <li>purchase one or more Rain;</li>
                    <li>
                      deposit, claim, and trade all mined Tokens exclusively via
                      GEMS' Exchange; and
                    </li>
                    <li>
                      maintain an active account on the Exchange in all times
                      until the expiration of the Rain product (which matures
                      within 18 months from the TGE).
                    </li>
                  </ol>
                </p>
                <p className="darkpara">
                  For the removal of any doubt any withdrawal of the Tokens from
                  the Exchange will result in an immediate cancelation of your
                  participation in the Gems Protect program.
                </p>

                <p className="darkpara">
                  Gems Protect allows you to recover up to 75% of the initial
                  purchase value of the acquired Tokens via the Rain, meaning,
                  if the total value of the Rain that you originally purchased
                  will drop on Effective Day, we will reimburse you in such way
                  that your Rain value will increase to 75% of the initial
                  purchase value of the acquired Rain. When calculating your P&L
                  on Effective Day we will consider the value of Tokens held by
                  you in your account with the Exchange and the ones that were
                  sold via the Exchange. We will reimburse you in USTD (or in
                  any other cryptocurrency as we see fit). The fee for
                  participating in the Gems Protect program is 5% of the value
                  of the Rain, in case a few Rain were purchased by you, you
                  will need to pay 5% of their value in total.
                </p>

                <p className="darkpara">
                  <span className="headingtext formarginleft">
                    Gems Protect Coverage and Evaluation:
                  </span>
                  Gems Protect protection will be evaluated every month based on
                  the user's Profit & Loss (P&L) calculation. The protection
                  will expire if any of the following conditions are met:
                  <ol>
                    <li>
                      18 months have passed since the TGE, after which Gems
                      Protect is no longer valid.
                    </li>
                    <li>
                      Total rewards received from the miner exceed 75% of the
                      initial miner purchase cost. If the total value of mined
                      tokens claimed by the user (whether sold or held) reaches
                      75% of the miner's initial purchase price, Gems Protect
                      coverage terminates.
                    </li>
                    <li>
                      The value of mined tokens is double the initial miner
                      cost. If the total mined tokens (including those not yet
                      sold) reach a value of 2x the initial purchase price, Gems
                      Protect coverage terminates, as the tokens are liquid and
                      can be sold at market price.
                    </li>
                  </ol>
                </p>

                <p className="darkpara">
                  <span className="headingtext formarginleft">
                    Monthly Valuation and Calculation:
                  </span>
                </p>
                <p className="darkpara">
                  A fixed valuation date will be announced.
                </p>
                <p className="darkpara">
                  Every month, a snapshot will be taken on this date to assess
                  the user's P&L.
                </p>
                <p className="darkpara">
                  The token price will be determined using the 7-day average
                  price prior to the snapshot date.
                </p>

                <p className="darkpara">
                  The P&L calculation for the user's miners will be based on:
                </p>
                <p className="darkpara">
                  Total USDT generated from token sales by the user.
                </p>
                <p className="darkpara">
                  The total value of tokens still held, using the price
                  calculation method above.
                </p>

                <p className="darkpara">
                  Insurance Fund Allocation and Withdrawal Conditions
                </p>

                <p className="darkpara">
                  If a user qualifies for Gems Protect support in any given
                  month (i.e., their miner's total value is below 75% of the
                  initial purchase price), the calculated compensation amount
                  will be allocated to a sub-account in GEMS Exchange.
                </p>

                <p className="darkpara">
                  Users cannot withdraw these funds immediately.
                </p>

                <p className="darkpara">
                  The final Gems Protect calculation will be made only after 18
                  months, once the miner has completed its full cycle and all
                  potential earnings have been realized.
                </p>
                <p className="darkpara">
                  If, by the end of 18 months, the user's total P&L remains
                  below 75% of the initial purchase price, the accumulated Gems
                  Protect funds in the sub-account will be released for
                  withdrawal. <br /> <br />
                  If the user's P&L recovers above 75% during the 18-month
                  period, no Gems Protect funds will be paid out, even if
                  allocations were made in previous months.
                </p>
                <p className="darkpara">Reimbursement Mechanism</p>
                <p className="darkpara">
                  The preferred form of Gems Protect reimbursement is USDT.
                </p>
                <p className="darkpara">
                  In extreme cases, Gems Protect payments may be made in other
                  cryptocurrencies at our discretion.
                </p>

                <p className="darkpara">Gems Protect Participation Fee</p>
                <p className="darkpara">
                  A 5% fee of the total value of the purchased Rain will be
                  required to enroll in Gems Protect. If multiple Rain are
                  purchased, the fee applies to the total value.
                </p>
              </div>
            </div>
            <div className="checkboxmainnnnnn">
              <label class="checkbox m-0" for="ch1">
                <input
                  type="checkbox"
                  onChange={inputField1Handler6}
                  id="ch1"
                  value={cheked3}
                  checked={cheked3}
                ></input>
                <span class="checkmark"></span>
              </label>
              <p className="checkboxpara">
                I confirm that I have read and understand the Terms & Conditions
              </p>
            </div>

            <div className="checkboxmainnnnnn">
              <label class="checkbox m-0" for="ch2">
                <input
                  type="checkbox"
                  id="ch2"
                  value={cheked4}
                  checked={cheked4}
                  onChange={inputField1Handler7}
                />
                <span class="checkmark"></span>
              </label>
              <p className="checkboxpara">I agree to the Terms & Conditions</p>
            </div>
            // disablebutton 
            {cheked3 && cheked4 ? (
              <button
                className="continuebutton"
                onClick={handleClose2Insurance12}
              >
                Add Gems Protect
              </button>
            ) : (
              <button className="disablebutton">Add Gems Protect</button>
            )}
          </div>
        </Modal.Body>
      </Modal> */}

      <Modal
        className="connectwallet-modal nooreee"
        show={show2}
        onHide={handleClose2}
        centered
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title>
            <img src="\assets\warning.svg" alt="img" className="mr-2" />
            Disclaimer
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="disclaimerdiv" style={{ padding: "20px" }}>
            <div className="darktext">
              <div className="scrolltext">
                <p className="darkparaupper text-center">
                  GEMS NODES AND GEMS MINERS <br /> TERMS & CONDITIONS
                </p>
                {/* <p className="darkpara text-center">
                  Last updated: 04 . 02 . 25
                </p> */}
                <p className="darkpara">
                  Please carefully read these terms and conditions before
                  receiving any tokens from us and or our affiliates and or any
                  other person and accepting them as they affect your
                  obligations and legal rights, including, but not limited to,
                  waivers of rights and limitations of liability. If you do not
                  agree with these terms and conditions or if you are a
                  prohibited person, then you are not permitted to receive the
                  tokens.
                </p>
                <p className="darkpara">
                  Please carefully read these terms and conditions before
                  receiving any tokens from us and/or our affiliates and/or any
                  other person and accepting them as they affect your
                  obligations and legal rights, including, but not limited to,
                  waivers of rights and limitations of liability. If you do not
                  agree with these terms and conditions or if you are a
                  prohibited person, then you are not permitted to receive the
                  tokens.
                </p>
                <p className="darkpara">
                  By receiving tokens or any other form of reword from us, you
                  acknowledge that you have fully read, understand and
                  irrevocably accept and agree to be bound by these terms and
                  conditions. You must also monitor the website for any
                  announcements from us as they may add to, or change, these
                  terms and conditions from time to time.
                </p>
                <p className="darkpara">
                  You acknowledge and understand that the tokens do not
                  represent or confer any ownership right or stake, share, or
                  equivalent rights, or any right to receive intellectual
                  property rights in or relating to us. The tokens are not
                  intended to be or to represent a stock, a loan contract, a
                  commodity, a currency, a share, an instrument creating or
                  acknowledging indebtedness, an instrument giving entitlements
                  to securities, a certificate representing certain securities,
                  an option, a future or a contract for difference or in any
                  permitted jurisdictions.
                </p>
                <p className="darkpara">
                  1.
                  <span className="headingtext formarginleft">Definitions</span>
                </p>
                <p className="darkpara">
                  <span className="bold">“Affiliates”</span> means with respect
                  to any specified person, any director, officer, partner,
                  member, agent, advisor or employee of such person and any
                  other person that, directly or indirectly, through one or more
                  intermediaries, controls, is controlled by, or is under common
                  control with, such specified person, and for purposes of this
                  definition “control” (including, with correlative meanings,
                  the terms, “controlled by” and “under common control with”),
                  as used with respect to any person, means the possession,
                  directly or indirectly, of the power to direct or cause the
                  direction of the management or policies of such person,
                  whether through the ownership of voting securities, by
                  contract or otherwise.
                </p>

                <p className="darkpara">
                  <span className="bold">“Airdrop”</span> means the distribution
                  of the token to eligible users of the Platform at no
                  additional cost.
                </p>

                <p className="darkpara">
                  <span className="bold">“Applicable law”</span> means the
                  applicable laws, acts, statutes, ordinances, rules,
                  regulations, judgments, injunctions, orders, treaties,
                  sanctions, administrative acts and decrees of any relevant
                  jurisdiction.
                </p>

                <p className="darkpara">
                  <span className="bold">“Blockchain”</span> means a type of
                  distributed ledger, comprised of immutable, digitally
                  recorded, data in packages called blocks.
                </p>

                <p className="darkpara">
                  <span className="bold">“Eligible User”</span> means members of
                  the “GEMS” community who are determined to be eligible for an
                  allocation of the tokens based on criteria determined by us in
                  its sole discretion, but at all times shall exclude any
                  prohibited person.
                </p>

                <p className="darkpara">
                  <span className="bold">“Effective Day”</span> means the
                  three-month anniversary as of the day of the purchase of the
                  GEMS Miners.
                </p>

                <p className="darkpara">
                  <span className="bold">“Gems Nodes”</span> means your computer
                  which is connected to other computers which follows rules and
                  shares information which is based on GEMS protocol encrypted
                  on the Blockchain.
                </p>

                <p className="darkpara">
                  <span className="bold">“Gems Miners”</span> means your
                  computer which is engaged in critical process in GEMS networks
                  and or community and which is involved verifying transactions
                  and adding them to the Blockchain.
                </p>

                <p className="darkpara">
                  <span className="bold">“Governmental Authority”</span> means
                  any nation or government, any state or other political
                  subdivision thereof, any entity exercising legislative,
                  judicial or administrative functions of or pertaining to
                  government, including, without limitation, any government
                  authority, agency, department, board, commission or
                  instrumentality, and any court, tribunal or arbitrator(s) of
                  competent jurisdiction, and any self-regulatory organisation.
                </p>

                <p className="darkpara">
                  <span className="bold">“Information Materials”</span> means
                  documents or other materials issued by us in connection with
                  the tokens from time to time.
                </p>

                <p className="darkpara">
                  <span className="bold">Gems Protect Program</span> means an
                  elective tool that allows the Eligible User to hedge his / her
                  risk which is associated with the purchase of the GEMS Miners.
                </p>

                <p className="darkpara">
                  <span className="bold">“Us” or “We”</span> means GEMS SL
                  LIMITED, a Saint Lucia international business company with
                  limited liability, which is the entity owning Rocks Platform
                  initiating the Services subject to these T&Cs.
                </p>

                <p className="darkpara">
                  <span className="bold">“Parties”</span> means us and you.
                </p>

                <p className="darkpara">
                  <span className="bold">“Person”</span> means an individual or
                  legal entity or person, including, without limitation, a
                  governmental authority or an agency or instrumentality
                  thereof.
                </p>

                <p className="darkpara">
                  <span className="bold">“Proceedings”</span> means any
                  disputes, claims, suits, actions, causes of action, demands,
                  procedures or proceedings.
                </p>

                <p className="darkpara">
                  <span className="bold">“Rocks Platform”</span> or the
                  “Platform” means a streamlined platform in the GEMS ecosystem
                  which was created in order to facilitate Token launches,
                  operating on the BASE network.
                </p>
                <p className="darkpara">
                  <span className="bold">“T&Cs”</span> means these terms and
                  conditions, including without limitation, all information
                  materials, and any other rules, policies or procedures that
                  may be issued by any member of us and published from time to
                  time on the website, each as amended from time to time and at
                  any time in accordance with the provisions herein.
                </p>
                <p className="darkpara">
                  <span className="bold">“Token”</span> means cryptographic
                  tokens, as described further in the information materials, and
                  which do not belong to us and or created by us.
                </p>
                <p className="darkpara">
                  <span className="bold">“Token Generation Event (TGE)”</span>{" "}
                  means the event marking the start of token generation and
                  distribution for a certain token.
                </p>
                <p className="darkpara">
                  <span className="bold">“You”, “Your” or “Yourself”</span>{" "}
                  means any person who from time to time and at any time (i)
                  proposes to acquire tokens from us or any third party; or (ii)
                  holds tokens.
                </p>
                <p className="darkpara">
                  <span className="bold">“Website”</span> means any website URL
                  used to allow eligible users to receive the tokens allocated
                  to them under the airdrop (as may be updated from time to
                  time).
                </p>
                <p className="darkpara">
                  as used herein, any reference to the “use” of the tokens
                  includes, without limitation, any holding, transferring,
                  exchanging and/or selling of the tokens or the grant of any
                  security over the tokens and a reference to “using” the tokens
                  shall be construed accordingly.
                </p>

                <p className="darkpara">
                  2.
                  <span className="headingtext formarginleft">
                    Terms and Conditions, Status and Acceptance
                  </span>
                </p>

                <p className="darkpara">
                  These T&Cs constitute a legally binding obligation on you
                  effective upon the earlier to occur of the date and time: (i)
                  you click the check box on the website to indicate that you
                  have read, understand and agree to these T&Cs; or (ii) you
                  receiving any tokens allocated to you as part of the airdrop.
                  These T&Cs define the rights and obligations of the parties in
                  relation to the tokens and your receipt of the tokens. You
                  must carefully read and agree to comply with these T&Cs before
                  receiving and/or using the tokens. By receiving tokens, you
                  are confirming that you have fully read, understand and
                  irrevocably accept these T&Cs. If you do not agree with these
                  T&Cs in general or any part of them or have not acknowledged
                  your review and acceptance of these T&Cs, you are not
                  permitted to receive tokens.
                </p>

                <p className="darkpara">
                  3.
                  <span className="headingtext formarginleft">
                    The Services
                  </span>
                </p>
                <p className="darkpara">
                  <span className="headingtext text-underline">
                    3.1 GEMS Nodes and GEMS Miners
                  </span>{" "}
                  <br /> <br />
                  We provide You with innovative community building tools
                  through GEMS Nodes and GEMS Miners subject to fees as
                  stipulated on our website. We serve as essential components
                  for community engagement and token distribution via the
                  Platform, while offering benefits such as token airdrops,
                  additional allocations, and rewards.
                  <br /> <br />
                  <span className="headingtext text-underline">
                    3.2 Gems Protect
                  </span>{" "}
                  <br />
                </p>

                <p className="darkpara">
                  You may choose to sign up for Gems Protect, in order to be
                  eligible to take part in Gems Protect you must: <br /> <br />
                  (1) purchase one or more GEMS Miners; <br />
                  (2) deposit, claim, and trade all mined Tokens exclusively via
                  GEMS’ Exchange; and <br />
                  (3) maintain an active account on the Exchange in all times
                  until the expiration of the GEMS Miner product (which matures
                  within 18 months from the TGE). <br />
                  For the removal of any doubt any withdrawal of the Tokens from
                  the Exchange will result in an immediate cancelation of your
                  participation in the Gems Protect program. Gems Protect allows
                  you to recover up to 75% of the initial purchase value of the
                  acquired Tokens via the GEMS Miners, meaning, if the total
                  value of the GEMS Miners that you originally purchased will
                  drop on Effective Day, we will reimburse you in such way that
                  your GEMS Miners value will increase to 75% of the initial
                  purchase value of the acquired GEMS Miners. When calculating
                  your P&L on Effective Day we will consider the value of Tokens
                  held by you in your account with the Exchange and the ones
                  that were sold via the Exchange. We will reimburse you in USTD
                  (or in any other cryptocurrency as we see fit). The fee for
                  participating in the Gems Protect program is 5% of the value
                  of the GEMS Miners, in case a few GEMS Miners were purchased
                  by you, you will need to pay 5% of their value in total.{" "}
                  <br /> <br />
                  <span className="headingtext text-underline">
                    3.2 “Gems Protect” and Evaluation: <br /> <br />
                  </span>
                  “Gems Protect” will be evaluated every month based on your
                  Profit & Loss (P&L) calculation. The protection will expire if
                  any of the following conditions are met:
                  <br /> <br />
                  1. 18 months have passed since the TGE, after which Gems
                  Protect is no longer valid; <br /> <br />
                  2. the total rewards received from the Miner exceed 75% of the
                  initial Miner purchase price. That means that the total value
                  of mined tokens claimed by you (whether sold or held)
                  overpassed 75% of the Miner’s initial purchase price; <br />{" "}
                  <br />
                  3. The value of mined tokens had doubled the initial Miner
                  cost. Meaning, if the total mined tokens (including those not
                  yet sold) reaches a value of two times the initial purchase
                  price, “Gems Protect” terminates, as the tokens are liquid and
                  can be sold at market price. <br /> <br />
                </p>

                <p className="darkpara">
                  <span className="headingtext text-underline">
                    3.3 Monthly Valuation and Calculation: <br />
                  </span>
                  A fixed valuation date will be announced. <br />
                  Every month, a snapshot will be taken on this date to assess
                  your P&L. <br />
                  The token price will be determined using the 7-day average
                  price prior to the snapshot date. <br />
                </p>

                <p className="darkpara">
                  The P&L calculation for your Miners will be based on: <br />{" "}
                  <br />
                  Total USDT generated from token sales by You. <br />
                  The total value of tokens still held, using the price
                  calculation stipulated above. <br />
                </p>

                <p className="darkpara">
                  <span className="headingtext text-underline">
                    3.4 Fund Allocation and Withdrawal Conditions: <br />
                  </span>
                </p>

                <p className="darkpara">
                  If you are qualifying for Gems Protect support in any given
                  month (i.e., your Miner’s total value is below 75% of the
                  initial purchase price), the calculated compensation amount
                  will be allocated to a sub-account in GEMS Exchange.
                </p>

                <p className="darkpara">
                  If you are qualifying for Gems Protect support in any given
                  month (i.e., your Miner’s total value is below 75% of the
                  initial purchase price), the calculated compensation amount
                  will be allocated to a sub-account in GEMS Exchange. However,
                  you cannot withdraw these funds immediately. The final Gems
                  Protect calculation will be made only after 18 months as of
                  TGE, once the Miner has completed its full cycle and all
                  potential earnings have been realized. If, by the elapse end
                  of 18 months, your total P&L remains below 75% of the initial
                  purchase price, the accumulated Gems Protect funds in the
                  sub-account will be released for withdrawal. However, if your
                  P&L recovers above 75% during the 18 months period, the terms
                  of the Gems Protect will not apply of you, even if allocations
                  were made in previous months.
                </p>

                <p className="darkpara">
                  <span className="headingtext text-underline">
                    3.5 The Reimbursement: <br />
                  </span>
                </p>

                <p className="darkpara">
                  The default form of Gems Protect reimbursement is in USDT. In
                  extreme cases, Gems Protect pay outs may be made in other
                  cryptocurrencies at GEMS sole discretion.
                </p>

                <p className="darkpara">
                  4.
                  <span className="headingtext formarginleft">Limitations</span>
                </p>
                <p className="darkpara">
                  Tokens are only intended for those persons who are
                  knowledgeable and experienced in cryptocurrencies, blockchain
                  and related technologies and protocols. By receiving the
                  tokens, you acknowledge that transactions using
                  cryptocurrencies (including cryptographic tokens) are
                  inherently unstable and you agree to accept that risk, and
                  agree that we is not liable for any loss that you may suffer
                  or incur, and further acknowledge, accept and assume all risks
                  associated with the tokens including, without limitation,
                  those identified in clause 6 of these T&Cs and in the
                  information materials. Tokens are intended to be marketed,
                  allocated and received by only to persons that are not
                  prohibited persons. The airdrop is expressly being made in the
                  permitted jurisdictions on the basis that the tokens do not
                  require that a prospectus be prepared or that other disclosure
                  or registration requirements be met or where other investor
                  safeguards or regulatory documents or licensing is required in
                  connection with the making available of the tokens by the user
                  in the permitted jurisdictions.
                </p>

                <p className="darkpara">
                  The tokens are not intended to be or to represent a stock, a
                  loan contract, a commodity, a currency, a share, an instrument
                  creating or acknowledging indebtedness, an instrument giving
                  entitlements to securities, a certificate representing certain
                  securities, an option, a future or a contract for difference
                  or in any permitted jurisdictions. Tokens are not intended to
                  be securities and shall not in any case be considered as such
                  and the offer of tokens has not been registered with any
                  governmental authority. You acknowledge and agree that tokens
                  do not represent any stock, loan contract, commodity,
                  currency, share, instrument creating or acknowledging
                  indebtedness, instrument giving entitlements to securities,
                  certificate representing certain securities, option, future or
                  contract for difference or right to receive intellectual
                  property rights, or any voting or governance rights or any
                  other right to influence the our development or our operation
                  and do not represent any ownership right in us. However,
                  without limitation to the above, we us reserves all rights
                  with respect to pursuing any form of decentralised governance
                  and shall do so in its sole and absolute discretion.
                </p>
                <p className="darkpara">
                  We reserve the right to cancel any tokens allocated to you in
                  connection with any airdrop, TGE or Rocks Platform
                  distribution at any time prior to your receipt of the tokens
                  as such is in our sole and absolute discretion and without
                  prior notice and without any liability or further obligation
                  of any kind whatsoever to you or any other party, in the event
                  us finds such measures reasonable and/or necessary in a
                  particular situation, including, but not limited to, change of
                  regulatory requirements, or upon suspicion or detection that
                  you do not primarily reside or are not domiciled in a
                  permitted jurisdiction or are engaged in fraud or other
                  illegal activity.
                </p>
                <p className="darkpara">
                  Certain jurisdictions expressly prohibit or restrict the
                  distribution of cryptocurrencies and/or cryptographic tokens,
                  while other jurisdictions may require us and/or the tokens to
                  be licensed, registered, authorised or otherwise regulated.
                  The tokens may be deemed to be securities for purposes of
                  securities laws in various jurisdictions such that the offer
                  or sale of tokens by us in such jurisdictions may require
                  registration or other steps to be taken with the relevant
                  regulatory authorities in those jurisdictions or for an
                  exemption from such registration or other steps being a
                  requirement. No such steps have been taken by us nor has any
                  such relevant exemption been confirmed. Some other
                  jurisdictions have or may have been excluded from the token
                  sale for other reasons, as determined by us in its sole and
                  absolute discretion. Persons (natural or legal) who are a
                  resident or tax resident, have a domicile in or otherwise have
                  a relevant connection with any prohibited jurisdiction are
                  excluded from participating in the token sale and possessing
                  and using a token. Tokens may not be distributed or made
                  available directly or indirectly to any prohibited person and
                  neither these T&Cs nor any information materials may be
                  supplied to any prohibited person, or used in connection with
                  the distribution or making available of the tokens by us to
                  any prohibited person. For the avoidance of doubt, the list of
                  prohibited jurisdictions may be changed from time to time,
                  irrespective of our awareness us and relevant amendments may
                  be made to these T&Cs. You are only permitted to use the
                  website and receive tokens if you are not a prohibited person.
                  To the extent a prohibited person attempts to enter into these
                  T&Cs, receive tokens under the airdrop, such purported
                  activity is void and of no force or effect.
                </p>

                <p className="darkpara">
                  You understand and agrees that we shall not be liable and
                  disclaims all liability to you in connection with any force
                  majeure event, including acts of God, labour disputes or other
                  industrial disturbances, electrical, telecommunications,
                  hardware, software or other utility failures, software or
                  smart contract bugs or weaknesses, earthquakes, storms, or
                  other nature-related events, blockages, embargoes, riots, acts
                  or orders of government, acts of terrorism or war, epidemic,
                  pandemic, technological change, changes in interest rates or
                  other monetary conditions, and, for the avoidance of doubt,
                  changes to any blockchain related protocol.
                </p>

                <p className="darkpara">
                  5.
                  <span className="headingtext formarginleft">General</span>
                </p>

                <p className="darkpara">
                  You shall not acquire or seek to receive any tokens if you are
                  a prohibited person or are otherwise not an eligible user. Us
                  may change, modify, amend, alter or supplement these T&Cs
                  (each an “amendment”) at any time in order to reflect (i)
                  changes to applicable law that may be, or which may otherwise
                  become, applicable to the tokens, (ii) any developments that
                  may otherwise reasonably be capable of materially adversely
                  impacting the tokens or its award by us; or (iii) as we may in
                  good faith deem advisable to protect our reputation. These
                  T&Cs do not constitute a sale of newly created virtual assets
                  to the public under applicable laws. One of the information or
                  analyses presented herein, therein or thereon are intended to
                  form the basis for any investment decision. You enter into
                  these T&Cs based on your own independent judgement and on
                  advice from independent advisers (as applicable). <br />
                  Subject to applicable laws, each project which is a member of
                  Rocks Platform reserves the right, in their respective sole
                  and absolute discretion, to refuse to allow you to receive any
                  tokens where there is a change in applicable laws or where any
                  member of the Rocks Platform suspects that you are engaging in
                  illegal activities. In order to seek compliance with (or to
                  seek to mitigate the impact of) any applicable law or any
                  other laws, statutes, ordinances, rules, regulations,
                  judgments, injunctions, orders, treaties, administrative acts
                  or decrees of any nation or governmental authority, any state
                  or other political subdivision thereof, any entity exercising
                  legislative, judicial or administrative functions of or
                  pertaining to government, including, without limitation, any
                  governmental authority, agency, department, board, commission
                  or instrumentality, and any court, tribunal or arbitrator(s)
                  of competent jurisdiction, believes that you applied to or
                  affect us or the tokens. In addition, us we may take such
                  steps as they consider necessary or convenient where they
                  believe or suspect the tokens may be used, trafficked or
                  applied in the attempted furtherance of money laundering,
                  terrorist financing, tax evasion or other unlawful activity.
                </p>

                <p className="darkpara">
                  6.
                  <span className="headingtext formarginleft">
                    Risks of Tokens and Limitations of Liabilities
                  </span>
                </p>

                <p className="darkpara">
                  You understand and acknowledge that tokens, blockchain-based
                  technologies and other associated and related technologies are
                  not exclusively (or, as appropriate, at all) controlled by us
                  and adverse changes in market forces or the technology,
                  broadly construed, may prevent or compromise the Platform’s
                  performance under these T&Cs. As such, the purchase of tokens
                  carries with it a number of risks. Prior to receiving tokens,
                  you should carefully consider the risks listed herein and in
                  the information materials and, to the extent necessary,
                  consult an appropriate lawyer, accountant, or tax
                  professional. If any of the risks associated with receiving
                  and holding tokens is unacceptable to you, you should not
                  receive tokens. you acknowledge, agree and assume all risks
                  associated with these T&Cs and the tokens including, without
                  limitation, those risks disclosed in the information
                  materials. There may be additional risks that cannot be
                  anticipated or foreseen due to the incipience of cryptographic
                  token technology, blockchain-based technology and related
                  technologies.
                </p>

                <p className="darkpara">
                  7.
                  <span className="headingtext formarginleft">
                    Disclaimer of Warranties
                  </span>
                </p>

                <p className="darkpara">
                  The tokens are provided to the fullest extent legally
                  permissible to you “as is” and on an “as available” basis with
                  no representation or warranty of any kind either, statutory,
                  expressed or implied, including, but not limited to, the
                  implied representations or warranties of title, non-
                  infringement, merchantability, and fitness for a particular
                  purpose. You assume all responsibility and risk with respect
                  to your acquisition of the Services. Us or any of their
                  respective affiliates or advisers make any warranty or
                  representation with respect to the completeness, security,
                  reliability, quality, accuracy, or availability of smart
                  contracts associated with the tokens, including that your
                  access to such smart contracts will be reliable, error-free,
                  or uninterrupted, that defects will be corrected. You
                  understand and expressly agree that none, of us or any of our
                  respective affiliates or advisers represents, warrants or
                  guarantees in any way that tokens might be sold or
                  transferred, or be saleable or transferable, or there is an
                  ability or will be a platform to exchange tokens for fiat
                  currencies, cryptocurrencies or cryptographic tokens, during
                  or after the TGE. We Us further does not make any
                  representations or warranties with respect to the regulatory
                  oversight or the use or security of any such exchange.
                </p>

                <p className="darkpara">
                  8.
                  <span className="headingtext formarginleft">Indemnity</span>
                </p>

                <p className="darkpara">
                  You do hereby to the fullest extent permitted by applicable
                  law indemnify, defend and hold us and each other relevant
                  party harmless from and against any and all loss, penalty,
                  claim, damage, liability or expense whatsoever (including
                  reasonable attorneys’ fees and disbursements) due to or
                  arising out of or based upon (i) any inaccurate representation
                  or warranty made by you, or breach or failure by you to comply
                  with any covenant or agreement made by you in these T&Cs or in
                  any other document furnished by you to any of the foregoing in
                  connection with this transaction, or (ii) any action
                  instituted by or on behalf of you against us or any other
                  relevant party that is finally resolved by judgment against
                  you or in favour of us or any other relevant party.
                </p>

                <p className="darkpara">
                  9.
                  <span className="headingtext formarginleft">
                    Miscellaneous
                  </span>
                </p>

                <p className="darkpara">
                  <span className="bold">Third Party Rights.</span> These T&Cs
                  constitute the entire agreement between the parties. We
                  reserve the right to modify these T&Cs at any time.Any
                  disputes shall be resolved under the applicable laws of Saint
                  Lucia.You hereby acknowledge and agree that each relevant
                  party is an intended third-party beneficiary under these T&Cs
                  (and we us shall hold the benefit of such provisions on trust
                  for each such relevant party). However, the parties to these
                  T&Cs may rescind or vary these T&Cs (including, without
                  limitation, any variation to extinguish or alter a third
                  party's entitlement to enforce any provisions of these T&Cs)
                  without the consent of any such third party.
                </p>

                <p className="darkpara">
                  <span className="bold">Security.</span>
                  You must secure your private key, digital wallet, and login
                  credentials at all times. <br />
                  We are not responsible for any loss resulting from
                  unauthorized access to your account. You must at all times
                  remain the only person who has control over your private key,
                  digital wallet and any other device associated with the
                  purchase of tokens and any username, passwords or other login
                  or identifying credentials used by you with respect to the
                  tokens. you must implement reasonable and appropriate measures
                  designed to secure access to any private key, digital wallet
                  or any other device associated with the receipt of tokens. If
                  you transfer any such private key, digital wallet or any other
                  device associated with the purchase of tokens to any third
                  party, you do so at your own risk and we shall not be held
                  responsible for any loss you may suffer as a result of third
                  parties accessing your private key, digital wallet or any
                  other device associated with the receipt of tokens.
                </p>

                <p className="darkpara">
                  <span className="bold">Suspension.</span> Notwithstanding
                  anything contained herein, we us reserves the right, without
                  notice and in its sole and absolute discretion, to suspend
                  your ability to receive the tokens, and without liability to
                  you, at its sole and absolute discretion, including but not
                  limited to, in case of your breach of these T&Cs or if we
                  believes you have committed fraud or other misconduct or are a
                  prohibited person.
                </p>

                <p className="darkpara">
                  <span className="bold">Entire Agreement.</span> Unless
                  otherwise provided, these T&Cs are intended to fully reflect
                  the terms of the agreement between the parties, and shall
                  supersede any previously or contemporaneously agreed upon
                  terms or understanding. no provision of these T&Cs shall be
                  considered waived unless such waiver is in writing and signed
                  by the party that benefits from the enforcement of such
                  provision. No waiver of any provision in these T&Cs, however,
                  will be deemed a waiver of a subsequent breach of such
                  provision or a waiver of a similar provision. in addition, a
                  waiver of any breach or a failure to enforce any term or
                  condition of these T&Cs will not in any way affect, limit, or
                  waive a party’s rights hereunder at any time to enforce strict
                  compliance thereafter with every term and condition hereof.
                </p>

                <p className="darkpara">
                  <span className="bold">Assignment.</span> We may, at its sole
                  and absolute discretion, assign any of its rights and/or
                  delegate its duties under these T&Cs. you may not assign your
                  rights or delegate right to receive any tokens, and any
                  assignment or delegation in breach of the foregoing shall be
                  null and void.
                </p>

                <p className="darkpara">
                  <span className="bold">severability.</span> in the event any
                  one or more of the provisions of these T&Cs are for any reason
                  held to be invalid, illegal or unenforceable in any
                  jurisdiction, in whole or in part or in any respect, or in the
                  event that any one or more of the provisions of these T&Cs
                  operate or would prospectively operate to invalidate these
                  T&Cs in any jurisdiction, then and in any such event, such
                  provision(s) shall be deemed modified to the minimum extent
                  necessary so that such provision, as so modified, shall no
                  longer be held to be invalid, illegal or unenforceable. any
                  such modification, invalidity or unenforceability shall be
                  strictly limited both to such provision and to such
                  jurisdiction, and in each case to no other. furthermore, in
                  the event of any such modification, invalidity or
                  unenforceability, these T&Cs shall be interpreted so as to
                  achieve the intent expressed herein to the greatest extent
                  possible in the jurisdiction in question and otherwise as set
                  forth herein.
                </p>

                <p className="darkpara">
                  <span className="bold">
                    Electronic Notices and use of Information.
                  </span>{" "}
                  you agree and consent to receive electronically all
                  communications, agreements, documents, receipts, notices and
                  disclosures (hereinafter - the “Communications”). Us WE and
                  OUR respective service providers may further disclose your
                  information to any of their respective service providers,
                  agents, relevant custodians or similar third parties for any
                  reason and such persons may keep your information for any
                  period of time permitted by applicable law.
                </p>

                <p className="darkpara">
                  <span className="bold">Tax Issues.</span> us We makes no
                  representations concerning the tax implications of the receipt
                  of tokens or the possession or use of them. you bear the sole
                  and absolute responsibility to determine if the potential
                  appreciation or depreciation in the value of tokens over time
                  has tax implications for you in your home jurisdiction or any
                  other jurisdiction. By receiving tokens, and to the extent
                  permitted by applicable law, you agree to be solely
                  responsible for any applicable taxes imposed on, and agree not
                  to hold us liable for any tax liability associated with or
                  arising from your acquisition, possession, or transfer of
                  tokens.
                </p>

                <p className="darkpara">
                  <span className="bold">limited Recourse:</span>{" "}
                  Notwithstanding any other provision of these T&Cs, any our
                  obligations hereunder are limited recourse of our obligations
                  of us. all obligations of and any claims against us hereunder
                  or in connection herewith after such realisation shall be
                  extinguished and shall not thereafter revive. No recourse
                  shall be had against any of ours officers, directors,
                  partners, employees, shareholders or incorporators.
                </p>
              </div>
            </div>

            <div className="material-textfield">
              <input
                type="text"
                placeholder="Enter your email address"
                onChange={inputField1Handler8}
                value={inputFeild8}
              />
              {isChecking && <span className="checking-text">Checking...</span>}
              {!isChecking && verified === false && (
                <span className="error-text">
                  {" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="15"
                    viewBox="0 0 14 15"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_10924_18725)">
                      <circle
                        cx="6.99963"
                        cy="7.49963"
                        r="6.99963"
                        fill="#FC4F52"
                      />
                      <path
                        d="M11 4.54473L8.04473 7.5L11 10.4553L9.95527 11.5L7 8.54473L4.04473 11.5L3 10.4553L5.95527 7.5L3 4.54473L4.04473 3.5L7 6.45527L9.95527 3.5L11 4.54473Z"
                        fill="#E2E9EC"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_10924_18725">
                        <rect
                          width="14"
                          height="14"
                          fill="white"
                          transform="translate(0 0.5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  Email not verified
                </span>
              )}
              {!isChecking && verified === true && (
                <span className="success-text">Email verified</span>
              )}
            </div>

            <div className="checkboxmainnnnnn">
              <label className="checkbox" htmlFor="ch1">
                <input
                  type="checkbox"
                  onChange={inputField1Handler2}
                  id="ch1"
                />
                <span className="checkmark"></span>
              </label>
              <p className="checkboxpara">
                I have carefully reviewed the Terms of Service, including its
                disclaimers, and fully agree to abide by its terms and
                conditions.
              </p>
            </div>

            {cheked && (
              <div className="checkboxmainnnnnn">
                <label className="checkbox" htmlFor="ch2">
                  <input
                    type="checkbox"
                    id="ch2"
                    onChange={inputField1Handler3}
                  />
                  <span className="checkmark"></span>
                </label>
                <p className="checkboxpara">
                  I understand the risks of cryptocurrency, including volatility
                  and loss, and take full responsibility for buying this miner.
                </p>
              </div>
            )}

            {cheked && cheked1 && (
              <div className="checkboxmainnnnnn">
                <label className="checkbox" htmlFor="ch3">
                  <input
                    type="checkbox"
                    id="ch3"
                    onChange={inputField1Handler4}
                  />
                  <span className="checkmark"></span>
                </label>
                <p className="checkboxpara">
                  I agree to receive communication and marketing emails from
                  Gems
                </p>
              </div>
            )}
            {cheked && cheked1 && cheked2 ? (
              verified === false ? (
                <button
                  onClick={() => {
                    handleShowVerify();
                  }}
                  className="continuebutton"
                >
                  Proceed to Verification
                </button>
              ) : (
                <button onClick={checkVerification} className="continuebutton">
                  {isChecking ? "Checking..." : "Check Verification"}
                </button>
              )
            ) : (
              <button className="disablebutton">continue</button>
            )}
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        className="connectwallet-modal followusonx-modal verificationemail-modal"
        show={showverify}
        onHide={handleCloseVerify}
        centered
        backdrop="static" // prevents closing on outside click
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Email Verification</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "20px" }}>
          <div className="verification-modal">
            <p className="para">
              We will email you a 6-digit code to verify your email address.
              Enter the code below.
            </p>

            <div className="option-field">
              <label>Email Address</label>
              <div className="inside-input">
                <div className="material-textfield">
                  <input
                    type="text"
                    placeholder="Enter your email address"
                    value={inputFeild7}
                    onChange={inputField1Handler7}
                  />
                  <a
                    href="#"
                    className={`btn-send ${checkedNew1 ? "disabled" : ""}`}
                    onClick={handleSendCode}
                    disabled={!checkedNew1 ? true : false}
                    style={{
                      pointerEvents: isResendDisabled ? "none" : "auto",
                      opacity: isResendDisabled ? 0.5 : 1,
                    }}
                  >
                    {isResendDisabled ? `Resend in ${timer12}s` : "Send Code"}
                  </a>
                </div>
              </div>
            </div>

            <div
              style={{
                opacity: showOtpInput ? 1 : 0.5,
                pointerEvents: showOtpInput ? "auto" : "none",
              }}
            >
              <div className="option-field" style={{ marginTop: "25px" }}>
                <label
                  style={{ color: "var(--V6-Dark-Theme-Secondary-Text-Color)" }}
                >
                  Verification Code
                </label>
                <div className="inside-input">
                  <div className="material-textfield mb-0">
                    <input
                      type="text"
                      placeholder="Enter 6-digit code here"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              {!isOtpValid && (
                <p className="error-text errortextemail">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="15"
                    viewBox="0 0 14 15"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_10924_18725)">
                      <circle
                        cx="6.99963"
                        cy="7.49963"
                        r="6.99963"
                        fill="#FC4F52"
                      />
                      <path
                        d="M11 4.54473L8.04473 7.5L11 10.4553L9.95527 11.5L7 8.54473L4.04473 11.5L3 10.4553L5.95527 7.5L3 4.54473L4.04473 3.5L7 6.45527L9.95527 3.5L11 4.54473Z"
                        fill="#E2E9EC"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_10924_18725">
                        <rect
                          width="14"
                          height="14"
                          fill="white"
                          transform="translate(0 0.5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  Invalid email verification code
                </p>
              )}

              <div className="twice-btnsss">
                <button
                  className={`continuebutton sscscscscscsc ${
                    otp?.length !== 6 ? "disabled" : ""
                  }`}
                  onClick={handleVerifyOtp}
                  disabled={otp?.length !== 6}
                  style={
                    otp?.length !== 6
                      ? {
                          pointerEvents: "none",
                          opacity: "0.5",
                          marginTop: "28px",
                        }
                      : { marginTop: "28px" }
                  }
                >
                  Verify Code
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Banner;
